// Sistema de Tradução
export const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    users: 'Users',
    menuPermissions: 'Menu Permissions',
    clients: 'Clients',
    properties: 'Properties',
    appointments: 'Appointments',
    financial: 'Financial',
    reports: 'Reports',
    settings: 'Settings',
    logout: 'Logout',
    help: 'Help',
    helpTitle: 'Help Center',
    helpSubtitle: 'Watch tutorial videos to learn how to use Agenda House Keep.',
    helpVideoList: 'Available tutorials',
    helpVideoOverview: 'System overview',
    helpVideoOverviewDesc: 'Navigate the main modules: dashboard, clients, appointments and financial.',
    helpVideoAdminFull: 'Admin — full workflow',
    helpVideoAdminFullDesc: 'Register employees, clients, properties and schedule a cleaning service.',
    helpVideoEmployee: 'Employee — daily routine',
    helpVideoEmployeeDesc: 'View your schedule, clients, ratings and notification preferences.',
    helpVideoClient: 'Client — appointments and preferences',
    helpVideoClientDesc: 'Track your cleaning appointments and configure notification alerts.',
    helpTip: 'Videos have no audio — explanatory captions are burned into the recording. Use fullscreen for better readability.',
    helpAudienceAll: 'Everyone',
    helpAudienceAdmin: 'Admin',
    helpAudienceEmployee: 'Employee',
    helpAudienceClient: 'Client',
    helpRecommended: 'For you',
    search: 'Search...',
    searchAll: 'All',
    searching: 'Searching...',
    noResults: 'No results found',
    recentSearches: 'Recent Searches',
    employees: 'Employees',
    products: 'Products',
    
    // Settings Page
    settingsTitle: 'Settings',
    settingsSubtitle: 'Manage your account preferences and settings',
    settingsMenu: 'Settings Menu',
    myAccount: 'My Account',
    notifications: 'Notifications',
    security: 'Security',
    
    // Account Settings
    regionalSettings: 'Regional Settings',
    language: 'Language',
    currency: 'Currency',
    dateFormat: 'Date Format',
    timeFormat: 'Time Format',
    timezone: 'Timezone',
    numberFormat: 'Number Format',
    
    // Save buttons
    saveSettings: 'Save Settings',
    saving: 'Saving...',
    settingsSaved: 'Settings saved successfully!',
    
    // Account info
    accountInformation: 'Account Information',
    email: 'Email',
    role: 'Role',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    
    // Reports page
    reportsAndAnalytics: 'Reports & Analytics',
    reportsSubtitle: 'Track your business performance',
    period: 'Period',
    
    // Appointments page
    appointmentManagement: 'Appointment Management',
    appointmentSubtitle: 'Manage all service appointments',
    appointmentList: 'Appointment List',
    newAppointment: 'New Appointment',
    client: 'Client',
    property: 'Property',
    serviceType: 'Service Type',
    dateTime: 'Date and Time',
    cleaning: 'Cleaning',
    maintenance: 'Maintenance',
    repair: 'Repair',
    schedule: 'Schedule',
    cancel: 'Cancel',
    noAppointmentsFound: 'No appointments found',
    loadingAppointments: 'Loading appointments...',
    appointmentCreatedSuccess: 'Appointment created successfully!',
    appointmentUpdatedSuccess: 'Appointment updated successfully!',
    appointmentCancelledSuccess: 'Appointment cancelled successfully!',
    format: 'Format',
    scheduled: 'Scheduled',
    confirmed: 'Confirmed',
    completed: 'Completed',
    cancelled: 'Cancelled',
    last3Months: 'Last 3 months',
    last6Months: 'Last 6 months',
    lastYear: 'Last year',
    servicesByType: 'Services by Type',
    topClients: 'Top Clients',
    download: 'Download',
    totalBilled: 'Total billed',
    services: 'services',
    reportMonthlyRevenue: 'Monthly Revenue Report',
    reportServiceTypes: 'Service Types Report',
    reportTopClients: 'Top Clients Report',
    reportTypeNotRecognized: 'Report type not recognized',
    reportGeneratedSuccess: 'Report {type} generated and downloaded successfully!',
    reportGenerationError: 'Error generating report. Check console for more details.',
    'serviceSuggestions.title': 'Next Service Suggestions',
    'serviceSuggestions.subtitle': 'We analyze completed appointments to recommend the best moment to reengage customers.',
    'serviceSuggestions.loading': 'Calculating suggestions...',
    'serviceSuggestions.noSuggestions': 'Not enough history to generate suggestions yet.',
    'serviceSuggestions.noSuggestionsHint': 'Complete more services to unlock personalized recommendations.',
    'serviceSuggestions.avgInterval': 'Average interval: {days} days',
    'serviceSuggestions.nextSuggested': 'Next suggested date:',
    'serviceSuggestions.totalCompleted': 'Completed services: {count}',
    'serviceSuggestions.confidence.alto': 'High confidence',
    'serviceSuggestions.confidence.medio': 'Medium confidence',
    'serviceSuggestions.confidence.baixo': 'Low confidence',
    generatedAt: 'Generated at',
    totalServices: 'Total Services',
    totalClients: 'Total Clients',
    month: 'Month',
    count: 'Count',
    
    // Financial page
    financialDashboard: 'Financial Dashboard',
    financialSubtitle: 'Track your financial situation',
    totalRevenue: 'Total Revenue',
    monthlyRevenue: 'Monthly Revenue',
    pending: 'Pending',
    completedServices: 'Completed Services',
    recentTransactions: 'Recent Transactions',
    allTransactions: 'All Transactions',
    income: 'Income',
    expense: 'Expense',
    paid: 'Paid',
    loading: 'Loading',
    noTransactionsFound: 'No transactions found',
      
      // Menu Permissions
      menuPermissionsSubtitle: 'Configure which menu options each user profile can access',
    saveChanges: 'Save Changes',
    restoreDefaults: 'Restore Defaults',
    unsavedChanges: 'Unsaved changes',
    menuProfile: 'Menu / Profile',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
      mainMenu: 'Main Menu',
      administration: 'Administration',
    legend: 'Legend',
    mainMenuDesc: 'Essential options for daily operations',
    administrationDesc: 'System management options',
    reportsDesc: 'Analysis and reporting options',
    tip: 'Tip',
    tipText: 'Use "Select/Deselect All" to quickly configure all permissions for a profile.',
    
    // Client Management
    clientManagement: 'Client Management',
    clientSubtitle: 'Manage all your clients',
    clientList: 'Client List',
    newClient: 'New Client',
    clientName: 'Name',
    clientPhone: 'Phone',
    clientDocument: 'Document',
    clientRegistration: 'Registration',
    clientActions: 'Actions',
    birthDate: 'Birth Date',
    birthDateHelp: 'We will send a birthday reminder to this client',
    noClientsFound: 'No clients registered',
    loadingClients: 'Loading clients...',
    
    // Property Management
    propertyManagement: 'Property Management',
    propertySubtitle: 'Manage all available properties',
    propertyList: 'Properties',
    addProperty: 'Add Property',
    propertyName: 'Property Name',
    propertyAddress: 'Address',
    propertyType: 'Property Type',
    propertyPrice: 'Monthly Price ($)',
    noPropertiesFound: 'No properties registered',
    loadingProperties: 'Loading properties...',
    
    // Dashboard
    dashboardSubtitle: 'Welcome to the property management system',
    dashboardCustomize: 'Customize',
    dashboardDoneCustomize: 'Done',
    dashboardConfigureWidgets: 'Configure widgets',
    dashboardLayout: 'Layout',
    dashboardLayoutGrid: 'Grid',
    dashboardLayoutList: 'List',
    dashboardAvailableWidgets: 'Available widgets',
    dashboardRestoreDefault: 'Restore default',
    dashboardEmptyWidgets: 'No widgets visible. Open settings to show widgets or restore the default layout.',
    dashboardAdminTitle: 'Admin dashboard',
    dashboardAdminSubtitle: 'Financial and operational overview',
    dashboardSupervisorTitle: 'Supervisor dashboard',
    dashboardSupervisorSubtitle: 'Field operations and team overview',
    dashboardEmployeeTitle: 'My day',
    dashboardEmployeeSubtitle: "Today's appointments and services",
    dashboardClientTitle: 'My services',
    dashboardClientSubtitle: 'Upcoming and recent appointments',
    dashboardSaveError: 'Could not save widget preferences',
    dashboardWidgetTodayAppointments: "Today's appointments",
    dashboardWidgetUpcoming: 'Upcoming appointments',
    dashboardWidgetCompletedToday: 'Completed today',
    dashboardWidgetRecent: 'Recent services',
    dashboardWidgetTotalServices: 'Total services',
    dashboardNoAppointmentsToday: 'No appointments for today',
    dashboardNoUpcoming: 'No upcoming appointments',
    dashboardNoRecentServices: 'No completed services yet',
    quickActions: 'Quick Actions',
    welcomeMessage: 'Welcome to the property management system',
    revenue: 'Revenue',
    
    // User Roles
    administrator: 'Administrator',
    supervisor: 'Supervisor',
    employee: 'Employee',
    clientRole: 'Client',
    
    // Search
    searchingFor: 'Searching for',
    
    // Common Actions
    create: 'Create',
    edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
    success: 'Success',
    error: 'Error',
    confirm: 'Confirm',
    registerProperty: 'Register Property',
    editClient: 'Edit Client',
    deleteClient: 'Delete Client',
    
    // Password validation
    passwordsDoNotMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    changePassword: 'Change Password',
    changing: 'Changing...',
    
    // Property Types
    house: 'House',
    apartment: 'Apartment',
    condo: 'Condo',
    commercial: 'Commercial',
    
    // Common Fields
    name: 'Name',
    phone: 'Phone',
    document: 'Document',
    address: 'Address',
    type: 'Type',
    price: 'Price',
    monthly: 'Monthly',
    actions: 'Actions',
    registration: 'Registration',
    
    // Users Management
    userManagement: 'User Management',
    userSubtitle: 'Manage system users and permissions',
    createNewUser: 'Create New User',
    editUser: 'Edit User',
    filterByRole: 'Filter by Role',
    filterByStatus: 'Filter by Status',
    allRoles: 'All roles',
    allStatus: 'All status',
    lastLogin: 'Last Login',
    never: 'Never',
    confirmDelete: 'Are you sure you want to delete this user?',
    errorLoadingUsers: 'Error loading users. Check your permissions.',
    errorCreatingUser: 'Error creating user',
    errorUpdatingUser: 'Error updating user',
    errorDeletingUser: 'Error deleting user',
    errorUpdatingRole: 'Error updating role',
    password: 'Password',
    optional: 'Optional',
    
    // Employees Management
    'employees.title': 'Employee Management',
    'employees.subtitle': 'Manage your team',
    'employees.list': 'Employee List',
    'employees.new': 'New Employee',
    'employees.edit': 'Edit Employee',
    'employees.name': 'Name',
    'employees.email': 'Email',
    'employees.phone': 'Phone',
    'employees.document': 'Document',
    'employees.noDocument': 'No document',
    'employees.zone': 'Zone',
    'employees.hireDate': 'Hire Date',
    'employees.status': 'Status',
    'employees.active': 'Active',
    'employees.inactive': 'Inactive',
    'employees.notFound': 'No employees found',
    'employees.loading': 'Loading employees...',
    'employees.filter.zone': 'Zone',
    'employees.filter.allZones': 'All zones',
    'employees.filter.status': 'Status',
    'employees.filter.allStatus': 'All',
    'employees.filter.active': 'Active',
    'employees.filter.inactive': 'Inactive',
    'employees.error.loading': 'Error loading employees',
    'employees.ratings.highlightTitle': 'Rating Highlights',
    'employees.ratings.highlightSubtitle': 'Track who is receiving the best ratings from clients.',
    'employees.ratings.total': 'ratings',
    
    // Zones Management
    'zones.title': 'Zone Management',
    'zones.subtitle': 'Manage geographic zones of operation',
    'zones.name': 'Name',
    'zones.description': 'Description',
    'zones.center': 'Center',
    'zones.centerLat': 'Center Latitude',
    'zones.centerLon': 'Center Longitude',
    'zones.radius': 'Radius (km)',
    'zones.radiusHelp': 'Leave empty to use polygon (boundaries)',
    'zones.boundaries': 'Boundaries (JSON)',
    'zones.boundariesHelp': 'GeoJSON format to define zone polygon',
    'zones.create': 'New Zone',
    'zones.edit': 'Edit Zone',
    'zones.empty': 'No zones registered',
    'zones.success.created': 'Zone created successfully!',
    'zones.success.updated': 'Zone updated successfully!',
    'zones.success.deleted': 'Zone deactivated successfully!',
    'zones.error.loading': 'Error loading zones',
    'zones.error.saving': 'Error saving zone',
    'zones.error.deleting': 'Error deleting zone',
    'zones.confirm.delete': 'Are you sure you want to deactivate the zone',
    'zones.mapView': 'Map View',
    'zones.showMap': 'Show Map',
    'zones.hideMap': 'Hide Map',
    'zones.currentLocation.loading': 'Getting location...',
    'zones.currentLocation.gps': 'GPS',
    'zones.currentLocation.ip': 'Approximate (IP)',
    'zones.currentLocation.refresh': 'Refresh location',
    'zones.currentLocation.error': 'Location unavailable',
    
    // Services Management
    'services.title': 'Service Management',
    'services.subtitle': 'Manage cleaning services offered',
    'services.list': 'Service List',
    'services.new': 'New Service',
    'services.edit': 'Edit Service',
    'services.name': 'Service Name',
    'services.description': 'Description',
    'services.type': 'Service Type',
    'services.duration': 'Duration (min)',
    'services.price': 'Base Price',
    'services.rooms': 'Included Rooms',
    'services.includedRooms': 'Rooms',
    'services.minutes': 'minutes',
    'services.notFound': 'No services found',
    'services.loading': 'Loading services...',
    'services.filter.type': 'Service Type',
    'services.filter.allTypes': 'All types',
    'services.filter.status': 'Status',
    'services.filter.allStatus': 'All',
    'services.filter.active': 'Active',
    'services.filter.inactive': 'Inactive',
    'services.error.loading': 'Error loading services',
    
    // Products Management
    'products.title': 'Product Management',
    'products.subtitle': 'Inventory control of cleaning products',
    'products.list': 'Product List',
    'products.new': 'New Product',
    'products.edit': 'Edit Product',
    'products.name': 'Product Name',
    'products.brand': 'Brand',
    'products.description': 'Description',
    'products.unit': 'Unit',
    'products.quantity': 'Quantity',
    'products.minStock': 'Min Stock',
    'products.costPrice': 'Cost Price',
    'products.category': 'Category',
    'products.notFound': 'No products found',
    'products.loading': 'Loading products...',
    'products.filter.category': 'Category',
    'products.filter.allCategories': 'All categories',
    'products.filter.status': 'Status',
    'products.filter.allStatus': 'All',
    'products.filter.active': 'Active',
    'products.filter.inactive': 'Inactive',
    'products.error.loading': 'Error loading products',
    
    // Notification History
    'notifications.history.title': 'Notification History',
    'notifications.history.unread': 'Unread:',
    'notifications.history.filterByType': 'Filter by type',
    'notifications.history.all': 'All',
    'notifications.history.info': 'Informative',
    'notifications.history.success': 'Success',
    'notifications.history.warning': 'Warnings',
    'notifications.history.error': 'Errors',
    'notifications.history.markAllRead': 'Mark all as read',
    'notifications.history.markAsRead': 'Mark as read',
    'notifications.history.delete': 'Delete',
    'notifications.history.loading': 'Loading...',
    'notifications.history.none': 'No notifications yet',
    'notifications.history.loadMore': 'Load more notifications',
    'notifications.history.error.loading': 'Error loading history',
    'notifications.history.error.markRead': 'Error marking as read',
    'notifications.history.error.markAllRead': 'Error marking all as read',
    'notifications.history.error.delete': 'Error deleting',
    
    // Notification Settings
    'notifications.settings.title': 'Notification Settings',
    'notifications.settings.notSupported': 'Push Notifications are not supported',
    'notifications.settings.notSupportedDesc': 'Your browser does not support Push Notifications. Please use a modern browser like Chrome, Firefox or Edge.',
    'notifications.settings.permissionStatus': 'Permission Status:',
    'notifications.settings.subscriptionStatus': 'Subscription Status:',
    'notifications.settings.permission.granted': 'Granted',
    'notifications.settings.permission.denied': 'Denied',
    'notifications.settings.permission.default': 'Not requested',
    'notifications.settings.subscription.active': 'Active',
    'notifications.settings.subscription.inactive': 'Inactive',
    'notifications.settings.activate': 'Activate Notifications',
    'notifications.settings.activatePush': 'Activate Push Notifications',
    'notifications.settings.sendTest': 'Send Test Notification',
    'notifications.settings.deactivate': 'Deactivate Notifications',
    'notifications.settings.permissionDenied': 'Notification permission was denied. Please enable it in your browser settings.',
    'notifications.settings.error.requestPermission': 'Error requesting permission',
    'notifications.settings.error.activate': 'Error activating notifications',
    'notifications.settings.error.deactivate': 'Error deactivating notifications',
    'notifications.settings.error.sendTest': 'Error sending test notification',
    'notifications.settings.loading': 'Loading...',
    'notifications.settings.connecting': 'Connecting...',
    'notifications.settings.sending': 'Sending...',
    'notifications.settings.deactivating': 'Deactivating...',
    
    // Special Instructions Modal
    'specialInstructions.title': 'Special Instructions',
    'specialInstructions.current': 'Current Instructions',
    'specialInstructions.history': 'History',
    'specialInstructions.placeholder': 'Type the special instructions for this property...',
    'specialInstructions.saving': 'Saving...',
    'specialInstructions.deleting': 'Deleting...',
    'specialInstructions.edit': 'Edit Instructions',
    'specialInstructions.add': 'Add Instructions',
    'specialInstructions.none': 'No special instructions registered for this property.',
    'specialInstructions.noHistory': 'No change history found.',
    'specialInstructions.changedBy': 'Changed by:',
    'specialInstructions.invalidId': 'Invalid Property ID',
    'specialInstructions.invalidIdDesc': 'This property (ID: {id}) does not have a valid UUID and cannot use the special instructions feature.',
    'specialInstructions.invalidIdSolution': 'Solution: Create a new property using the "+ Add Property" button on the Properties page.',
    'specialInstructions.error.loading': 'Error loading instructions',
    'specialInstructions.error.saving': 'Error saving instructions',
    'specialInstructions.error.deleting': 'Error deleting instructions',
    'specialInstructions.confirmDelete': 'Are you sure you want to delete the special instructions for this property?',
    
    // Animal Management Modal
    'animals.title': 'Animals - {propertyName}',
    'animals.subtitle': 'Manage animals in this property for security alerts',
    'animals.total': 'Total animals:',
    'animals.dangerous': 'dangerous',
    'animals.add': 'Add Animal',
    'animals.new': 'New Animal',
    'animals.edit': 'Edit Animal',
    'animals.none': 'No animals registered in this property.',
    'animals.addFirst': 'Add First Animal',
    'animals.name': 'Name *',
    'animals.type': 'Type *',
    'animals.breed': 'Breed',
    'animals.behavior': 'Behavior',
    'animals.size': 'Size',
    'animals.notes': 'Notes',
    'animals.dangerousLabel': 'Dangerous animal (requires special attention)',
    'animals.dangerousTag': 'Dangerous',
    'animals.type.dog': 'Dog',
    'animals.type.cat': 'Cat',
    'animals.type.bird': 'Bird',
    'animals.type.other': 'Other',
    'animals.behavior.friendly': 'Friendly',
    'animals.behavior.shy': 'Shy',
    'animals.behavior.aggressive': 'Aggressive',
    'animals.behavior.unknown': 'Unknown',
    'animals.size.small': 'Small',
    'animals.size.medium': 'Medium',
    'animals.size.large': 'Large',
    'animals.size.select': 'Select...',
    'animals.label.type': 'Type:',
    'animals.label.breed': 'Breed:',
    'animals.label.behavior': 'Behavior:',
    'animals.label.size': 'Size:',
    'animals.label.notes': 'Notes:',
    'animals.error.loading': 'Error loading animals',
    'animals.error.saving': 'Error saving animal',
    'animals.error.deleting': 'Error deleting animal',
    'animals.success.created': 'Animal created successfully!',
    'animals.success.updated': 'Animal updated successfully!',
    'animals.success.deleted': 'Animal deleted successfully!',
    'animals.confirmDelete': 'Are you sure you want to delete this animal?',
    
    // Check-in/Check-out
    'checkin.title': 'Check-in',
    'checkout.title': 'Check-out',
    'checkin.process': 'Process Check-in',
    'checkout.process': 'Process Check-out',
    'checkin.processing': 'Processing...',
    
    // SMTP Settings
    'smtp.success.saved': 'SMTP configuration saved successfully',
    'smtp.success.testSent': 'Test email sent successfully! Check your inbox.',
    'smtp.error.saving': 'Error saving SMTP configuration',
    'smtp.error.testing': 'Error testing SMTP configuration',
    'smtp.error.unknown': 'Unknown error',
    'smtp.error.testEmail': 'Please provide an email for testing',
    'smtp.save': 'Save Configuration',
    'smtp.sendTest': 'Send Test',
    'smtp.saveNotificationSettings': 'Save Notification Settings',
    
    // Reports - Months
    'reports.month.jan': 'Jan',
    'reports.month.feb': 'Feb',
    'reports.month.mar': 'Mar',
    'reports.month.apr': 'Apr',
    'reports.month.may': 'May',
    'reports.month.jun': 'Jun',
    'reports.month.jul': 'Jul',
    'reports.month.aug': 'Aug',
    'reports.month.sep': 'Sep',
    'reports.month.oct': 'Oct',
    'reports.month.nov': 'Nov',
    'reports.month.dec': 'Dec',
    'reports.clientNotInformed': 'Client not informed',
    'reports.error.loadingProperties': 'Error loading properties to map clients',
    'reports.error.loading': 'Error loading reports',
    'reports.error.generating': 'Error generating report',
    'reports.error.generatingPdf': 'Error generating PDF report',
    'reports.error.generatingDetails': 'Error generating report. Check console for more details.',
    'reports.filters': 'Filters',
    'reports.filterByZone': 'Zone',
    'reports.allZones': 'All zones',
    
    // Properties
    'properties.error.notReturned': 'Property not returned by API',
    'properties.success.created': 'Property created successfully!',
    'properties.success.updated': 'Property updated successfully!',
    'properties.error.creating': 'Error creating property',
    'properties.error.updating': 'Error updating property',
    'properties.error.deleting': 'Error deleting property',
    'properties.error.loading': 'Error loading properties',
    'properties.error.cep': 'Error fetching CEP/ZIP Code',
    'properties.confirmDelete': 'Are you sure you want to delete this property?',
    'properties.clientNotFound': 'Client not found? Click "New Client" to register',
    'properties.searchingCep': 'Searching CEP...',
    'properties.searchingZip': 'Searching ZIP Code...',
    'properties.updating': 'Updating...',
    'properties.creating': 'Creating...',
    'properties.update': 'Update',
    'properties.create': 'Create Property',
    'properties.phone': 'Phone',
    'properties.documentId': 'Document ID',
    'properties.enterDocumentId': 'Enter document ID',
    'properties.type.residential': 'Residential',
    'properties.type.commercial': 'Commercial',
    'properties.type.other': 'Other',
    
    // Appointments
    'appointments.error.selectClient': 'Please select a client',
    'appointments.error.selectProperty': 'Please select a property',
    'appointments.error.selectValidProperty': 'Please select a valid property',
    'appointments.error.selectEmployee': 'Please select an employee',
    'appointments.error.creating': 'Error creating appointment',
    'appointments.error.updating': 'Error updating appointment',
    'appointments.error.cancelling': 'Error cancelling appointment',
    'appointments.error.dateNotInformed': 'Date not informed',
    'appointments.error.invalidDate': 'Invalid date',
    'appointments.error.formattingDate': 'Error formatting date',
    'appointments.edit': 'Edit Appointment',
    'appointments.searchClientPlaceholder': 'Type at least 3 letters to search client...',
    'appointments.selectPropertyPlaceholder': 'Select a property...',
    'appointments.searchPropertyPlaceholder': 'Type to search or select from dropdown above',
    'appointments.searchPropertyPlaceholderAlt': 'Select a client first or type to search...',
    'appointments.selectClientFirst': 'Select a client first',
    'appointments.employee': 'Employee',
    'appointments.searchEmployeePlaceholder': 'Type to search or click to see all...',
    'appointments.noName': 'No name',
    'appointments.time': 'Time',
    
    // Financial
    'financial.error.loadingPayments': 'Error loading payments',
    'financial.error.loadingClients': 'Error loading clients',
    'financial.error.loadingAllocations': 'Error loading allocations',
    'financial.error.loadingCosts': 'Error loading costs',
    'financial.error.loadingBalance': 'Error loading balance',
    'financial.success.paymentCreated': 'Payment registered successfully!',
    'financial.success.paymentUpdated': 'Payment updated!',
    'financial.success.paymentDeleted': 'Payment deleted!',
    'financial.success.allocationCreated': 'Allocation created successfully!',
    'financial.success.statusUpdated': 'Status updated!',
    'financial.success.thirdPartyCreated': 'Third party created successfully! The field was updated automatically.',
    'financial.success.thirdPartyCreatedPartial': 'Third party created, but there was a problem updating the list. Try reloading the page.',
    'financial.success.costCreated': 'Cost registered!',
    'financial.error.creatingPayment': 'Error creating payment',
    'financial.error.updatingPayment': 'Error updating payment',
    'financial.error.deletingPayment': 'Error deleting payment',
    'financial.error.creatingAllocation': 'Error creating allocation',
    'financial.error.updatingStatus': 'Error updating status',
    'financial.error.creatingThirdParty': 'Error creating third party',
    'financial.error.creatingCost': 'Error creating cost',
    'financial.error.deletingCost': 'Error deleting cost',
    'financial.confirmDeletePayment': 'Are you sure you want to delete this payment?',
    'financial.confirmDeleteCost': 'Delete this cost?',
    'financial.status.paid': 'Paid',
    'financial.status.pending': 'Pending',
    'financial.status.cancelled': 'Cancelled',
    
    // Autocomplete
    'autocomplete.placeholder': 'Type to search...',
    'autocomplete.error.searching': 'Error searching',
    'autocomplete.error.loading': 'Error loading initial options',
    'autocomplete.minChars': 'Type at least {minChars} characters to search',
    'autocomplete.createNew': 'Create new: "{value}"',
    
    // Chat Modal
    'chat.title': 'Real-Time Chat',
    'chat.subtitle': 'Communication between client and employee linked to the appointment',
    'chat.filter': 'Filter by client or property',
    'chat.property': 'Property',
    'chat.client': 'Client:',
    'chat.employee': 'Employee:',
    'chat.messagePlaceholder': 'Type a message',
    'chat.sending': 'Sending...',
    'chat.send': 'Send',
    'chat.loadingThreads': 'Loading conversations...',
    'chat.noThreads': 'No conversations available',
    'chat.loadingMessages': 'Loading messages...',
    'chat.noMessages': 'No messages yet',
    'chat.selectThread': 'Select a conversation to start',
    'chat.helpRequest': 'Help Request · Priority',
    
    // Quick Create Modals
    'quickCreate.property.title': 'Register New Property',
    'quickCreate.property.client': 'Client:',
    'quickCreate.property.name': 'Property Name',
    'quickCreate.property.address': 'Address',
    'quickCreate.property.zipCode': 'ZIP Code / ZIP Code',
    'quickCreate.property.type': 'Type',
    'quickCreate.property.city': 'City',
    'quickCreate.property.state': 'State (UF)',
    'quickCreate.property.price': 'Monthly Price (R$)',
    'quickCreate.property.required': '(required)',
    'quickCreate.property.searchingCep': '🔍 Searching...',
    'quickCreate.property.cepInstructions': 'Enter ZIP Code (8 digits) or ZIP Code (5 digits) to auto-fill',
    'quickCreate.property.cepNotFound': 'ZIP Code/ZIP Code not found',
    'quickCreate.property.clientNotSelected': 'Client not selected. Please select a client first.',
    'quickCreate.property.invalidResponse': 'Invalid API response - property not returned',
    'quickCreate.property.error': 'Error creating property',
    'quickCreate.property.error.endpoint': 'Endpoint not found. Check if the service is running.',
    'quickCreate.property.error.invalidData': 'Invalid data. Check required fields.',
    'quickCreate.property.error.server': 'Internal server error. Try again.',
    'quickCreate.property.error.connection': 'Connection error. Check your internet connection.',
    'quickCreate.property.exampleName': 'Ex: Beach House',
    'quickCreate.property.exampleAddress': 'Street, number, neighborhood...',
    'quickCreate.property.autoFill': 'Will be filled automatically by ZIP Code',
    'quickCreate.property.examplePrice': 'Ex: 250.00',
    'quickCreate.property.registering': 'Registering...',
    'quickCreate.property.register': 'Register Property',
    'quickCreate.employee.error': 'Error creating employee',
    'quickCreate.employee.exampleZone': 'Ex: North Zone',
    'quickCreate.employee.registering': 'Registering...',
    'quickCreate.employee.register': 'Register Employee',
    'quickCreate.client.error': 'Error creating client',
    'quickCreate.client.registering': 'Registering...',
    'quickCreate.client.register': 'Register Client',
    
    // Complete Service Modal
    'completeService.error.positiveTime': 'Real time must be a positive number',
    'completeService.error.invalidEndTime': 'Invalid end date/time',
    'completeService.error': 'Error completing service',
    'completeService.error.invalidData': 'Invalid data. Check filled fields.',
    'completeService.error.notFound': 'Appointment not found. Please reload the page.',
    'completeService.error.server': 'Internal server error. Try again.',
    'completeService.error.connection': 'Connection error. Check your internet connection.',
    'completeService.notesPlaceholder': 'Notes about service completion...',
    'completeService.completing': 'Completing...',
    'completeService.complete': 'Complete Service',
    
    // Dashboard
    'dashboard.noAppointments': 'No appointments yet',
    'dashboard.employees': 'Employees',
    'dashboard.services': 'Services',
    'dashboard.products': 'Products',
    
    // Common error messages
    'errors.loading': 'Error loading',
    'errors.saving': 'Error saving',
    'errors.creating': 'Error creating',
    'errors.updating': 'Error updating',
    'errors.deleting': 'Error deleting',
    'errors.searching': 'Error searching',
    'errors.testing': 'Error testing',
    'errors.unknown': 'Unknown error',
    
    // Common success messages
    'success.created': 'created successfully!',
    'success.updated': 'updated successfully!',
    'success.deleted': 'deleted successfully!',
    'success.saved': 'saved successfully!',
    
    // Common confirmations
    'confirm.delete': 'Are you sure you want to delete this?',
    'confirm.cancel': 'Are you sure you want to cancel this?',
    'confirm.action': 'Are you sure you want to do this?',
    
    // Common placeholders
    'placeholders.typeToSearch': 'Type to search...',
    'placeholders.select': 'Select...',
    'placeholders.pleaseSelect': 'Please select...',
    'placeholders.pleaseInform': 'Please inform...',
    
    // Common actions
    'actions.save': 'Save',
    'actions.cancel': 'Cancel',
    'actions.confirm': 'Confirm',
    'actions.delete': 'Delete',
    'actions.edit': 'Edit',
    'actions.create': 'Create',
    'actions.update': 'Update',
    'actions.add': 'Add',
    'actions.remove': 'Remove',
    
    // Ratings
    'ratings.history.title': 'Rating History',
    'ratings.history.subtitle': 'View all ratings received',
    'ratings.history.empty': 'No ratings found',
    'ratings.search.placeholder': 'Search by client, property or comment...',
    'ratings.filter.all': 'All Status',
    'ratings.filter.approved': 'Approved',
    'ratings.filter.pending': 'Pending',
    'ratings.filter.submitted': 'Submitted',
    'ratings.stats.average': 'Average Rating',
    'ratings.stats.total': 'Total Ratings',
    'ratings.stats.fiveStar': '5 Stars',

    // PWA
    'pwa.install.title': 'Install House Keep',
    'pwa.install.description': 'Add the app to your home screen for quick access.',
    'pwa.install.action': 'Install',
    'pwa.install.dismiss': 'Not now',
    'pwa.install.ios_hint': 'Tap Share, then "Add to Home Screen".',
    'pwa.update.title': 'A new version is available',
    'pwa.update.action': 'Update now',
    'pwa.offline.message': 'You are offline',
    'common.loading': 'Loading...',
    'common.loadingChart': 'Loading chart...',
    'common.loadingData': 'Loading data...',
    'common.sortBy': 'Sort by:',
    'common.month': 'Month',
    'common.quantity': 'Quantity',
    'common.position': 'Position',
    'common.difference': 'Difference',
    'common.yourResponse': 'Your response:',
    'common.punctuality': 'Punctuality',
    'common.quality': 'Quality',
    'common.communication': 'Communication',
    'billing.title': 'SaaS Billing',
    'billing.subtitle': 'Platform billing plans and invoices',
    'billing.tabs.plans': 'Plans',
    'billing.tabs.invoices': 'Invoices',
    'billing.tabs.aria': 'Billing sections',
    'reports.monthlyRevenue': 'Monthly Revenue',
    'reports.monthlyRevenueCol': 'Revenue',
    'reports.serviceTypes': 'Service Types',
    'reports.topClients': 'Top Clients',
    'reports.type': 'Type',
    'reports.client': 'Client',
    'reports.services': 'Services',
    'reports.generatedBy': 'Report generated by Agenda House Keep System',
    'reports.moreInfo': 'For more information, visit the system at {url}',
    'reports.timeDiscrepancies': 'Time Discrepancies',
    'reports.timeDiscrepanciesFull': 'Time Discrepancies (Expected vs Actual)',
    'reports.noClients': 'No clients found.',
    'reports.addClientsHint': 'Add clients in the system to view reports.',
    'reports.noDiscrepancies': 'No discrepancies found.',
    'reports.allOnTime': 'All completed services are within the estimated time.',
    'reports.noAppointmentsDay': 'No appointments on this day',
    'reports.loadingRatings': 'Loading ratings...',
    'permissions.legend': 'Legend - CRUD Permissions:',
    'permissions.createDesc': 'Create: Allows creating new records for the resource',
    'permissions.readDesc': 'Read: Allows viewing records for the resource',
    'permissions.updateDesc': 'Update: Allows modifying existing records',
    'permissions.deleteDesc': 'Delete: Allows removing records for the resource',
    'permissions.tipTitle': 'Tip:',
    'permissions.tipText': 'CRUD permissions control which actions each role can perform within pages. Even if a role has menu access (previous tab), it can only execute actions allowed here.',
    'language.en': 'English',
    'language.es': 'Spanish',
    'language.ptBR': 'Portuguese (Brazil)',
    'language.ptPT': 'Portuguese (Portugal)',

    // Phase 4 — common UI strings
    'common.name': 'Name',
    'common.description': 'Description',
    'common.status': 'Status',
    'common.email': 'Email',
    'common.phone': 'Phone',
    'common.client': 'Client',
    'common.employee': 'Employee',
    'common.optional': '(optional)',
    'common.requiredMark': '(required)',
    'common.all': 'All',
    'common.filters': 'Filters',
    'common.action': 'Action',
    'common.resource': 'Resource',
    'common.clear': 'Clear',
    'common.clearSelection': 'Clear selection',
    'common.tryAgain': 'Try again',
    'common.backToLogin': 'Back to login',
    'common.notes': 'Notes',
    'common.value': 'Value',
    'common.loadingClients': 'Loading clients...',
    'common.noData': 'No data found',
    'common.select': 'Select...',
    'common.dateNotInformed': 'Date not provided',
    'common.thirdParty': 'Contractor',
    'common.actions': 'Actions',
    'common.remove': 'Remove',
    'common.add': 'Add',
    'common.update': 'Update',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.save': 'Save',
    'common.close': 'Close',
    'common.search': 'Search',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.resourceLimits': 'Resource Limits',
    'common.keepCurrent': 'Keep current',
    'common.keepSeries': 'Keep from series',
    'common.dateFormatHint': 'DD/MM/YYYY',
    'validation.fixFormErrors': 'Please fix the errors in the form',
    'validation.requiredCustomFields': 'Fill in all required custom fields.',
    'validation.priceRequired': 'Price is required and must be greater than zero',
    'login.appName': 'Agenda House Keep',
    'login.tagline': 'Cleaning Management System',
    'login.title': 'Sign In',
    'login.subtitle': 'Access your account to continue',
    'login.emailLabel': 'Email',
    'login.passwordLabel': 'Password',
    'login.emailPlaceholder': 'your@email.com',
    'login.emailRequired': 'Email is required',
    'login.passwordRequired': 'Password is required',
    'login.invalidCredentials': 'Incorrect email or password',
    'login.connectionError': 'Connection error. Check if services are running.',
    'login.twoFactorTitle': 'Two-Factor Authentication',
    'login.twoFactorSubtitle': 'Enter the 6-digit code from your authenticator app',
    'login.twoFactorCodeRequired': 'Enter the 6-digit code',
    'login.twoFactorInvalid': 'Invalid code. Try again.',
    'login.twoFactorVerifyError': 'Error verifying code. Try again.',
    'login.submit': 'Sign In',
    'login.submitting': 'Signing in...',
    'login.verify': 'Verify',
    'login.verifying': 'Verifying...',
    'login.forgotPassword': 'Forgot password?',
    'login.noAccount': 'Don\'t have an account?',
    'login.register': 'Register',
    'forgotPassword.title': 'Forgot Password',
    'forgotPassword.subtitle': 'Enter your email to receive reset instructions',
    'forgotPassword.submit': 'Send reset link',
    'forgotPassword.backToLogin': 'Back to login',
    'resetPassword.title': 'Reset Password',
    'resetPassword.submit': 'Reset password',
    'financial.thirdPartyNone': 'No contractors registered',
    'financial.thirdPartyHint': 'Manage contractors on the Employees page. Mark "Contractor" when creating or editing an employee.',
    'financial.newAllocation': 'New Allocation',
    'financial.fixedAmount': 'Fixed Amount',
    'financial.percentage': 'Percentage',
    'financial.costs': 'Costs',
    'financial.newCost': 'New Cost',
    'financial.status.pending': 'Pending',
    'financial.status.paid': 'Paid',
    'financial.status.cancelled': 'Cancelled',
    'billing.loadingInvoices': 'Loading invoices...',
    'billing.allStatuses': 'All statuses',
    'billing.retryLoad': 'Try again',
    'billing.generateFromPlan': 'Generate from active plan',
    'billing.noInvoices': 'No invoices found',
    'billing.paymentMethodPrompt': 'Payment method:',
    'billing.paymentError': 'Error processing payment',
    'dashboard.completedToday': 'Services completed today',
    'dashboard.completedThisMonth': 'Services completed this month',
    'dashboard.completionRate': 'Completion Rate',
    'dashboard.noAppointmentsYet': 'No appointments yet',
    'dashboard.monthlyRevenueSubtitle': 'Revenue from completed services',
    'dashboard.servicesOverTime': '{count} services exceeded time',
    'dashboard.servicesSlower': '⚠️ {count} services took longer than estimated',
    'dashboard.servicesFaster': '✅ {count} services were faster',
    'dashboard.noDiscrepancy': 'No discrepancies found',
    'dashboard.avgDifference': 'Average difference: {value} min',
    'dashboard.appointmentsOfDay': 'Appointments for {date}',
    'appointments.clearSelection': 'Clear selection',
    'appointments.dateNotInformed': 'Date not provided',
    'rbac.legend': 'Legend',
    'rbac.colorLegend': 'Color Legend',
    'support.title': 'Support',
    'support.newTicket': 'New ticket',
    'support.refresh': 'Refresh',
    'support.noTickets': 'No tickets found',
    'support.loading': 'Loading tickets...',
    'zones.fillNameAndCoords': 'Please fill in at least the name and center coordinates of the zone',
    'menuPermissions.saved': 'Permissions saved successfully!',
    'menuPermissions.saveError': 'Error saving permissions',

    // Phase 4 — common UI strings
    'common.name': 'Name',
    'common.description': 'Description',
    'common.status': 'Status',
    'common.email': 'Email',
    'common.phone': 'Phone',
    'common.client': 'Client',
    'common.employee': 'Employee',
    'common.optional': '(optional)',
    'common.requiredMark': '(required)',
    'common.all': 'All',
    'common.filters': 'Filters',
    'common.action': 'Action',
    'common.resource': 'Resource',
    'common.clear': 'Clear',
    'common.clearSelection': 'Clear selection',
    'common.tryAgain': 'Try again',
    'common.backToLogin': 'Back to login',
    'common.notes': 'Notes',
    'common.value': 'Value',
    'common.loadingClients': 'Loading clients...',
    'common.noData': 'No data found',
    'common.select': 'Select...',
    'common.dateNotInformed': 'Date not provided',
    'common.thirdParty': 'Contractor',
    'common.actions': 'Actions',
    'common.remove': 'Remove',
    'common.add': 'Add',
    'common.update': 'Update',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.save': 'Save',
    'common.close': 'Close',
    'common.search': 'Search',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.resourceLimits': 'Resource Limits',
    'common.keepCurrent': 'Keep current',
    'common.keepSeries': 'Keep from series',
    'common.dateFormatHint': 'DD/MM/YYYY',
    'validation.fixFormErrors': 'Please fix the errors in the form',
    'validation.requiredCustomFields': 'Fill in all required custom fields.',
    'validation.priceRequired': 'Price is required and must be greater than zero',
    'login.appName': 'Agenda House Keep',
    'login.tagline': 'Cleaning Management System',
    'login.title': 'Sign In',
    'login.subtitle': 'Access your account to continue',
    'login.emailLabel': 'Email',
    'login.passwordLabel': 'Password',
    'login.emailPlaceholder': 'your@email.com',
    'login.emailRequired': 'Email is required',
    'login.passwordRequired': 'Password is required',
    'login.invalidCredentials': 'Incorrect email or password',
    'login.connectionError': 'Connection error. Check if services are running.',
    'login.twoFactorTitle': 'Two-Factor Authentication',
    'login.twoFactorSubtitle': 'Enter the 6-digit code from your authenticator app',
    'login.twoFactorCodeRequired': 'Enter the 6-digit code',
    'login.twoFactorInvalid': 'Invalid code. Try again.',
    'login.twoFactorVerifyError': 'Error verifying code. Try again.',
    'login.submit': 'Sign In',
    'login.submitting': 'Signing in...',
    'login.verify': 'Verify',
    'login.verifying': 'Verifying...',
    'login.forgotPassword': 'Forgot password?',
    'login.noAccount': 'Don\'t have an account?',
    'login.register': 'Register',
    'forgotPassword.title': 'Forgot Password',
    'forgotPassword.subtitle': 'Enter your email to receive reset instructions',
    'forgotPassword.submit': 'Send reset link',
    'forgotPassword.backToLogin': 'Back to login',
    'resetPassword.title': 'Reset Password',
    'resetPassword.submit': 'Reset password',
    'financial.thirdPartyNone': 'No contractors registered',
    'financial.thirdPartyHint': 'Manage contractors on the Employees page. Mark "Contractor" when creating or editing an employee.',
    'financial.newAllocation': 'New Allocation',
    'financial.fixedAmount': 'Fixed Amount',
    'financial.percentage': 'Percentage',
    'financial.costs': 'Costs',
    'financial.newCost': 'New Cost',
    'financial.status.pending': 'Pending',
    'financial.status.paid': 'Paid',
    'financial.status.cancelled': 'Cancelled',
    'billing.loadingInvoices': 'Loading invoices...',
    'billing.allStatuses': 'All statuses',
    'billing.retryLoad': 'Try again',
    'billing.generateFromPlan': 'Generate from active plan',
    'billing.noInvoices': 'No invoices found',
    'billing.paymentMethodPrompt': 'Payment method:',
    'billing.paymentError': 'Error processing payment',
    'dashboard.completedToday': 'Services completed today',
    'dashboard.completedThisMonth': 'Services completed this month',
    'dashboard.completionRate': 'Completion Rate',
    'dashboard.noAppointmentsYet': 'No appointments yet',
    'dashboard.monthlyRevenueSubtitle': 'Revenue from completed services',
    'dashboard.servicesOverTime': '{count} services exceeded time',
    'dashboard.servicesSlower': '⚠️ {count} services took longer than estimated',
    'dashboard.servicesFaster': '✅ {count} services were faster',
    'dashboard.noDiscrepancy': 'No discrepancies found',
    'dashboard.avgDifference': 'Average difference: {value} min',
    'dashboard.appointmentsOfDay': 'Appointments for {date}',
    'appointments.clearSelection': 'Clear selection',
    'appointments.dateNotInformed': 'Date not provided',
    'rbac.legend': 'Legend',
    'rbac.colorLegend': 'Color Legend',
    'support.title': 'Support',
    'support.newTicket': 'New ticket',
    'support.refresh': 'Refresh',
    'support.noTickets': 'No tickets found',
    'support.loading': 'Loading tickets...',
    'zones.fillNameAndCoords': 'Please fill in at least the name and center coordinates of the zone',
    'menuPermissions.saved': 'Permissions saved successfully!',
    'menuPermissions.saveError': 'Error saving permissions',
    'recurrence.createTitle': 'Create Recurring Appointment',
    'recurrence.validateConflicts': 'Validate Conflicts',
    'recurrence.creating': 'Creating...',
    'recurrence.createSeries': 'Create Series',
    'recurrence.noConflicts': 'No conflicts! You can create the series.',
    'recurrence.successCreated': 'Recurring series created successfully!',
    'recurrence.errorCreating': 'Error creating recurring series',
    'workload.loading': 'Loading workload...',
    'workload.errorLoading': 'Error loading workload',
    'forgotPassword.sendLink': 'Send Recovery Link',
    'forgotPassword.success': 'If the email exists, a recovery link has been sent.',
    'forgotPassword.error': 'Error processing request.',
    'setup2fa.required': 'Required Setup',
    'support.noTicketsYet': 'No tickets yet.',
    'calendar.appointmentsTitle': 'Appointments Calendar',
    'zone.myLocation': 'My location',
    'checkpoint.none': 'No checkpoints found',
    'twoFactor.title': 'Two-Factor Authentication',
    'employeeSelector.loading': 'Loading employees...',
    'quickCreate.employee.title': 'Register New Employee',
    'preferences.loading': 'Loading preferences...',
    'smtp.settingsTitle': 'SMTP Settings',
    'financial.subtitle': 'Payment, cost and allocation control for contractors',
    'companySwitcher.loading': 'Loading companies...',
    'completeService.cancel': 'Cancel',

    'setup2fa.subtitle': 'For your security, you must configure two-factor authentication (2FA) before continuing.',
    'companySwitcher.notFound': 'No company found',
    'companySwitcher.noneAvailable': 'No company available',
    // Phase 4 final
    'audit.title': 'Audit Log',
    'audit.subtitle': 'Complete history of all actions in the system',
    'audit.applyFilters': 'Apply Filters',
    'audit.noLogs': 'No logs found',
    'audit.errorLoading': 'Error loading audit logs',
    'audit.errorExport': 'Error exporting logs',
    'audit.next': 'Next',
    'audit.previous': 'Previous',
    'checkpoint.title': 'Checkpoint History',
    'checkpoint.loading': 'Loading history...',
    'checkpoint.errorLoading': 'Error loading checkpoint history',
    'checkpoint.stats': 'Statistics',
    'checkpoint.avgPerService': 'Average per Service',
    'checkpoint.duration': 'Duration:',
    'rating.title': 'Rate Service',
    'rating.overall': 'Overall Rating *',
    'rating.anonymous': 'Anonymous rating',
    'rating.success': 'Rating submitted successfully!',
    'rating.detailedOptional': 'Detailed Ratings (Optional)',
    'rating.commentOptional': 'Comment (Optional)',
    'rating.commentPlaceholder': 'Share your experience with this service...',
    'rating.submit': 'Submit Rating',
    'recurrence.editTitle': 'Edit Recurring Appointment',
    'recurrence.cancelOccurrence': 'Cancel only this occurrence',
    'recurrence.cancelSeries': 'Cancel entire series (all future occurrences)',
    'recurrence.newEndDate': 'New end date',
    'recurrence.newDuration': 'New duration (minutes)',
    'recurrence.newInstructions': 'New special instructions',
    'recurrence.startDate': 'Start date *',
    'recurrence.dayOfMonth': 'Day of month *',
    'recurrence.frequency': 'Frequency',
    'recurrence.frequencyRequired': 'Frequency *',
    'recurrence.durationRequired': 'Duration (minutes) *',
    'recurrence.daily': 'Daily (every day)',
    'recurrence.monthly': 'Monthly (every month)',
    'company.search': 'Search company',
    'company.searchPlaceholder': 'Search company...',
    'company.switchTitle': 'Switch Company',
    'company.switchHint': 'Select the company to switch context',
    'company.notFound': 'No company found',
    'company.noneAvailable': 'No company available',
    'completeService.title': 'Complete Service',
    'completeService.endTime': 'End Time',
    'completeService.autoCalcHint': 'If not provided, will be calculated automatically',
    'dashboard.welcome': 'Welcome to the cleaning management system',
    'dashboard.noClients': 'No clients registered',
    'dashboard.newClient': 'New Client',
    'employeeDashboard.loading': 'Loading dashboard...',
    'employeeDashboard.error': 'Error loading dashboard',
    'employeeDashboard.completed': 'Completed',
    'employeeDashboard.thisMonth': 'This Month',
    'employeeDashboard.noUpcoming': 'No upcoming appointments',
    'employeeDashboard.noData': 'No data available',
    'employeeDashboard.avgRating': 'Average rating:',
    'employeeSelector.available': 'Available',
    'employeeSelector.unavailable': 'Unavailable',
    'employeeSelector.noneAvailable': 'No employees available',
    'employeeSelector.invalidZone': 'Invalid zone',
    'employeeSelector.validZone': 'Valid zone',
    'workload.title': 'Employee Workload',
    'workload.avgLoad': 'Average load (20-40h)',
    'workload.totalAppointments': 'Total appointments:',
    'workload.totalEmployees': 'Total employees:',
    'login.back': 'Back',
    'login.forgotPasswordLink': 'Forgot my password',
    'login.twoFactorVerification': 'Two-Step Verification',
    'login.verificationCode': 'Verification Code',
    'login.twoFactorAppHint': 'Enter the 6-digit code from your authenticator app',
    'login.contactAdmin': 'Contact the administrator to create an account',
    'login.privacyPolicy': 'Privacy Policy',
    'forgotPassword.titleFull': 'Recover Password',
    'forgotPassword.subtitleFull': 'Enter your email to receive a recovery link',
    'quickCreate.client.title': 'Register New Client',
    'zone.drawStart': 'Start Drawing',
    'zone.redraw': 'Redraw',
    'zone.removeLast': 'Remove Last',
    'zone.minPoints': 'At least 3 points are required to form a polygon',
    'zone.centerOnMe': 'Center on my location',
    'zone.yourLocation': 'Your location',
    'limits.loading': 'Loading limits...',
    'limits.configure': 'Configure Limits',
    'limits.usageStats': 'Usage Statistics',
    'limits.maxClients': 'Maximum Clients',
    'limits.maxEmployees': 'Maximum Employees',
    'limits.maxUsers': 'Maximum Users',
    'limits.errorLoading': 'Could not load limits.',
    'limits.disabledHint': 'When disabled, limits will not be applied',
    'billing.invoiceDetails': 'Invoice Details',
    'billing.clearFilter': 'Clear filter',
    'billing.number': 'Number:',
    'plans.loading': 'Loading plans...',
    'plans.billingCycle': 'Billing Cycle',
    'plans.errorDeactivate': 'Error deactivating plan',
    'plans.errorSave': 'Error saving plan',
    'plans.history': 'Plan History',
    'plans.noneRegistered': 'No plans registered. Click to create',
    'plans.name': 'Plan Name',
    'plans.new': 'New Plan',
    'customization.adminOnly': 'Only administrators can manage company customizations.',
    'customization.subtitle': 'Configure a unique experience for each corporate client.',
    'customization.title': 'Company Customization',
    'customization.selectCompany': 'Select a company to customize features.',
    'customization.branding.subtitle': 'Customize logo, colors and custom CSS for the company.',
    'customization.branding.primaryColor': 'Primary color',
    'customization.branding.secondaryColor': 'Secondary color',
    'customization.branding.gradientHint': 'Buttons, cards and charts will use this custom gradient.',
    'customization.branding.errorSave': 'Error saving branding.',
    'customization.branding.errorLoad': 'Could not load company branding.',
    'customization.fields.loading': 'Loading custom fields...',
    'customization.fields.required': 'Required field',
    'customization.fields.byModule': 'Fields by module',
    'customization.fields.configJson': 'Configuration (JSON)',
    'customization.fields.errorRemove': 'Error removing field.',
    'customization.fields.errorSave': 'Error saving custom field.',
    'customization.features.loading': 'Loading feature flags...',
    'customization.features.advancedJson': 'Advanced configuration (JSON)',
    'customization.features.enabled': 'Feature enabled for company',
    'customization.features.invalidJson': 'Invalid configuration JSON.',
    'customization.features.clearForm': 'Clear form',
    'customization.features.none': 'No feature flags configured for this company.',
    'customization.features.errorSave': 'Error saving feature flag.',
    'customization.templates.loading': 'Loading templates...',
    'customization.templates.subtitle': 'Customize notification content sent to clients.',
    'customization.templates.welcomeSample': 'Welcome to House Keep!',
    'customization.templates.errorRemove': 'Error removing template.',
    'customization.workflows.loading': 'Loading modules...',
    'customization.workflows.definitionJson': 'Workflow definition (JSON)',
    'customization.workflows.editor': 'Workflow editor',
    'customization.workflows.errorRemove': 'Error removing workflow.',
    'customization.workflows.errorSave': 'Error saving workflow.',
    'customization.workflows.moduleRequired': 'Enter the workflow module.',
    'customization.workflows.invalidJson': 'Invalid definition JSON.',
    'customization.workflows.module': 'Module *',
    'customFields.loading': 'Loading custom fields...',
    'adminDashboard.attentionRequired': 'Attention Required',
    'adminDashboard.loadingTrend': 'Loading trend data...',
    'adminDashboard.noEmployeesCompleted': 'No employees with completed services',
    'adminDashboard.last6Months': 'Last 6 months',
    'clientDashboard.errorHistory': 'Error loading service history',
    'employeeDashboard.errorToday': 'Error loading today\'s appointments',
    'rbac.departments.title': 'Departments',
    'rbac.departments.parent': 'Parent Department',
    'rbac.departments.parentOptional': 'Parent Department (optional)',
    'rbac.departments.descPlaceholder': 'Department description',
    'rbac.departments.none': 'None',
    'rbac.departments.noneConfigured': 'No departments configured',
    'rbac.permissions.conditions': 'Conditions',
    'rbac.permissions.conditionsOptional': 'Conditions (optional JSON)',
    'rbac.permissions.noneConfigured': 'No permissions configured',
    'rbac.permissions.new': 'New Permission',
    'rbac.permissions.errorLoad': 'Could not load permissions.',
    'rbac.roles.custom': 'Custom',
    'rbac.roles.descPlaceholder': 'Role description',
    'rbac.roles.noneConfigured': 'No roles configured',
    'rbac.roles.errorLoad': 'Could not load roles.',
    'rbac.roles.permissions': 'Permissions',
    'rbac.management.title': 'RBAC Management',
    'rbac.management.subtitle': 'Role, permission and department access control.',
    'rbac.management.adminOnly': 'Only administrators can manage RBAC.',
    'rbac.management.selectCompany': 'Select a company to manage RBAC.',
    'limits.management.adminOnly': 'Only system administrators can configure these limits.',
    'limits.management.loadingCompany': 'Loading company information...',
    'limits.management.selectCompany': 'Select a company to manage resource limits.',
    'preferences.channels': 'Notification Channels',
    'preferences.subtitle': 'Configure how and when you want to receive notifications',
    'preferences.quietHours': 'Quiet Hours',
    'preferences.quietHoursHint': 'During this period you will not receive notifications (except urgent ones)',
    'preferences.quietStart': 'Start (HH:MM)',
    'preferences.appointmentCreated': 'Appointment Created',
    'preferences.appointmentCancelled': 'Appointment Cancelled',
    'preferences.appointmentReminders': 'Appointment Reminders',
    'resetPassword.minLength': 'Password must be at least 6 characters.',
    'resetPassword.mismatch': 'Passwords do not match.',
    'resetPassword.confirmNew': 'Confirm New Password',
    'resetPassword.newPassword': 'New Password',
    'resetPassword.placeholder': 'Enter your new password',
    'resetPassword.successTitle': 'Password Reset!',
    'resetPassword.successMessage': 'Password reset successfully! Redirecting to login...',
    'resetPassword.titleFull': 'Reset Password',
    'setup2fa.logoutRetry': 'Log out and try again later',
    'support.tickets': 'Tickets',
    'support.ticketsSubtitle': 'Tickets and SLA isolated by company',
    'support.openTicket': 'Open ticket',
    'support.newTicketBtn': 'New ticket',
    'support.errorUpdate': 'Failed to update ticket.',
    'support.errorCreate': 'Failed to create ticket.',
    'support.average': 'Average',
    'support.refreshBtn': 'Refresh',
    'timeDiscrepancies.subtitle': 'Detailed analysis of services with differences between estimated and actual time',
    'timeDiscrepancies.avgDifference': 'Average Difference',
    'timeDiscrepancies.errorLoading': 'Error loading time discrepancies',
    'timeDiscrepancies.errorExport': 'Error exporting report',
    'timeDiscrepancies.backToReports': '← Back to Reports',
    'timeDiscrepancies.alphabetical': '🔤 Alphabetical Order',
    'timeDiscrepancies.service': 'Service',
    'reports.errorGenerate': 'Error generating report. Check the console for details.',
    'chat.sendWhatsApp': 'Also send via WhatsApp',
    'notes.templatePreview': 'Subject preview:',
    'notes.applyTemplate': 'Apply template content',
    'notes.mobileHint': 'The notification will be sent to the client\'s mobile app.',
    'notes.loadingTemplates': 'Loading templates...',
    'menuPermissions.loading': 'Loading permissions...',
    'menuPermissions.crudTitle': 'CRUD Permissions',
    'menuPermissions.menuTitle': 'Menu Permissions',
    'menuPermissions.resourceAction': 'Resource / Action',
    'companies.searchPlaceholder': 'Search companies...',
    'companies.active': 'Active company',
    'companies.errorLoad': 'Error loading companies:',
    'companies.errorDelete': 'Error deleting company:',
    'companies.errorSave': 'Error saving company:',
    'users.passwordRequiredWhen': 'Password is required when',
    'users.administrator': 'Administrator',
    'users.changePassword': 'Change Password',
    'users.passwordMismatch': 'Passwords do not match',
    'users.errorDelete': 'Error deleting user:',
    'users.errorCompany': 'Could not determine company. Please reload the page and try again.',
    'users.errorGetCompany': 'Error getting company. Please reload the page and try again.',
    'appointments.recurring': 'Recurring Appointment',
    'appointments.clientSignature': 'Client signature',
    'appointments.createFirst': 'Create First Appointment',
    'appointments.errorUpdateProperties': 'Error updating properties',
    'appointments.errorLoad': 'Error loading appointments. Try reloading the page.',
    'appointments.searchClientMin': 'Type at least 3 letters to search client...',
    'twoFactor.enabled': '2FA Enabled',
    'twoFactor.disabled': '2FA Disabled',
    'twoFactor.disabledSuccess': '2FA disabled successfully.',
    'twoFactor.enabledSuccess': '2FA enabled successfully!',
    'twoFactor.adminMustKeep': 'Administrators must keep 2FA enabled.',
    'twoFactor.warning': 'Warning:',
    'twoFactor.activate': 'Enable 2FA',
    'twoFactor.deactivate': 'Disable 2FA',
    'twoFactor.deactivateTitle': 'Disable 2FA',
    'twoFactor.deactivateWarning': '2FA is required for your account. Contact the administrator if you need to disable it.',
    'twoFactor.enabledInfo': 'Your login requires the 2FA code. Keep your backup codes in a safe place.',
    'twoFactor.disabledInfo': '2FA is disabled. Enable it to add an extra layer of security to your account.',
    'twoFactor.requiredDisabled': 'This action is disabled because 2FA is required for your account.',
    'twoFactor.errorLoadStatus': 'Could not load 2FA status.',
    'twoFactor.errorStartSetup': 'Failed to start 2FA setup.',
    'twoFactor.errorDisable': 'Could not disable 2FA.',
    'products.deactivate': 'Deactivate',
    'products.deleteTitle': 'Delete Product',
    'products.cost': 'Cost:',
    'products.warning': 'WARNING:',
    'products.descriptionPlaceholder': 'Product description...',
    'products.errorDeactivate': 'Error deactivating product',
    'services.deactivate': 'Deactivate',
    'services.deleteTitle': 'Delete Service',
    'services.descriptionPlaceholder': 'Detailed service description...',
    'services.errorDeactivate': 'Error deactivating service',
    'services.errorReactivate': 'Error reactivating service',
    'services.deleteChoice': 'Choose how to delete this service:',
    'services.hardDeleteUnavailable': 'Hard delete not available. Performing soft delete...',
    'settings.whatsapp': 'WhatsApp Settings',
    'settings.smtpSaved': 'SMTP configuration saved successfully',
    'settings.whatsappSaved': 'WhatsApp configuration saved successfully',
    'settings.currentApplied': 'Current Settings Applied:',
    'settings.customizationByCompany': 'Company Customization',
    'settings.phonePlaceholder': '+5511999999999 or whatsapp:+5511999999999',
    'settings.auth': 'Authentication',
    'settings.timezoneBRT': 'Brasília Time (BRT)',
    'calendar.appointments': 'appointments',
    'calendar.titleShort': 'Appointments Calendar',
    'finance.addContractorQuick': 'Quick Add Contractor',
    'finance.allocationSuccess': 'Allocation created successfully!',
    'finance.loadingMonth': 'Loading month data...',
    'finance.selectToDistribute': 'Click "Select to Distribute" button',
    'finance.createFirstAllocation': 'Create First Allocation',
    'properties.instructions': 'Instructions',
    'properties.cepHint': '💡 8 digits (Brazil) or 5 digits (USA)',
    'properties.errorLoad': 'Error loading properties:',
    'employees.thirdPartyHint': 'Check if this employee is an external contractor',
    'employees.zoneExample': 'E.g.: North Zone, Downtown, etc.',

    'menu.companies': 'Companies',
    'menu.zones': 'Zones',
    'menu.services': 'Services',
    'menu.limits': 'Limits',
    'menu.rbac': 'RBAC',
    'menu.notificationPreferences': 'Notification Preferences',
    'menu.history': 'History',
  },
  
  'pt-BR': {
    // Navigation
    dashboard: 'Painel',
    users: 'Usuários',
    menuPermissions: 'Permissões de Menu',
    clients: 'Clientes',
    properties: 'Propriedades',
    appointments: 'Agendamentos',
    financial: 'Financeiro',
    reports: 'Relatórios',
    settings: 'Configurações',
    logout: 'Sair',
    help: 'Ajuda',
    helpTitle: 'Central de Ajuda',
    helpSubtitle: 'Assista aos vídeos tutoriais para aprender a usar o Agenda House Keep.',
    helpVideoList: 'Tutoriais disponíveis',
    helpVideoOverview: 'Visão geral do sistema',
    helpVideoOverviewDesc: 'Navegue pelos módulos principais: painel, clientes, agendamentos e financeiro.',
    helpVideoAdminFull: 'Admin — fluxo completo',
    helpVideoAdminFullDesc: 'Cadastre funcionários, clientes, propriedades e agende um serviço de limpeza.',
    helpVideoEmployee: 'Funcionário — rotina diária',
    helpVideoEmployeeDesc: 'Veja sua agenda, clientes, avaliações e preferências de notificação.',
    helpVideoClient: 'Cliente — agendamentos e preferências',
    helpVideoClientDesc: 'Acompanhe seus agendamentos de limpeza e configure alertas de notificação.',
    helpTip: 'Os vídeos não possuem áudio — as legendas explicativas estão queimadas na gravação. Use tela cheia para melhor leitura.',
    helpAudienceAll: 'Todos',
    helpAudienceAdmin: 'Admin',
    helpAudienceEmployee: 'Funcionário',
    helpAudienceClient: 'Cliente',
    helpRecommended: 'Para você',
    search: 'Buscar...',
    searchAll: 'Todos',
    searching: 'Buscando...',
    noResults: 'Nenhum resultado encontrado',
    recentSearches: 'Buscas Recentes',
    employees: 'Funcionários',
    products: 'Produtos',
    
    // Settings Page
    settingsTitle: 'Configurações',
    settingsSubtitle: 'Gerencie suas preferências e configurações da conta',
    settingsMenu: 'Menu de Configurações',
    myAccount: 'Minha Conta',
    notifications: 'Notificações',
    security: 'Segurança',
    
    // Account Settings
    regionalSettings: 'Configurações Regionais',
    language: 'Idioma',
    currency: 'Moeda',
    dateFormat: 'Formato de Data',
    timeFormat: 'Formato de Hora',
    timezone: 'Fuso Horário',
    numberFormat: 'Formato de Números',
    
    // Save buttons
    saveSettings: 'Salvar Configurações',
    saving: 'Salvando...',
    settingsSaved: 'Configurações salvas com sucesso!',
    
    // Account info
    accountInformation: 'Informações da Conta',
    email: 'Email',
    role: 'Função',
    status: 'Status',
    active: 'Ativo',
    inactive: 'Inativo',
    
    // Reports page
    reportsAndAnalytics: 'Relatórios e Análises',
    reportsSubtitle: 'Acompanhe o desempenho do seu negócio',
    period: 'Período',
    
    // Appointments page
    appointmentManagement: 'Gestão de Agendamentos',
    appointmentSubtitle: 'Gerencie todos os agendamentos de serviços',
    appointmentList: 'Lista de Agendamentos',
    newAppointment: 'Novo Agendamento',
    client: 'Cliente',
    property: 'Propriedade',
    serviceType: 'Tipo de Serviço',
    dateTime: 'Data e Hora',
    cleaning: 'Limpeza',
    maintenance: 'Manutenção',
    repair: 'Reparo',
    schedule: 'Agendar',
    cancel: 'Cancelar',
    noAppointmentsFound: 'Nenhum agendamento encontrado',
    loadingAppointments: 'Carregando agendamentos...',
    appointmentCreatedSuccess: 'Agendamento criado com sucesso!',
    appointmentUpdatedSuccess: 'Agendamento atualizado com sucesso!',
    appointmentCancelledSuccess: 'Agendamento cancelado com sucesso!',
    format: 'Formato',
    scheduled: 'Agendado',
    confirmed: 'Confirmado',
    completed: 'Concluído',
    cancelled: 'Cancelado',
    last3Months: 'Últimos 3 meses',
    last6Months: 'Últimos 6 meses',
    lastYear: 'Último ano',
    monthlyRevenue: 'Receita Mensal',
    servicesByType: 'Serviços por Tipo',
    topClients: 'Top Clientes',
    download: 'Baixar',
    totalBilled: 'Total faturado',
    services: 'serviços',
    reportMonthlyRevenue: 'Relatório de Receita Mensal',
    reportServiceTypes: 'Relatório de Tipos de Serviço',
    reportTopClients: 'Relatório de Top Clientes',
    reportTypeNotRecognized: 'Tipo de relatório não reconhecido',
    reportGeneratedSuccess: 'Relatório {type} gerado e baixado com sucesso!',
    reportGenerationError: 'Erro ao gerar relatório. Verifique o console para mais detalhes.',
    'serviceSuggestions.title': 'Sugestões de Próximo Serviço',
    'serviceSuggestions.subtitle': 'Analisamos o histórico de agendamentos para sugerir o melhor momento de recontato.',
    'serviceSuggestions.loading': 'Calculando sugestões...',
    'serviceSuggestions.noSuggestions': 'Ainda não há histórico suficiente para gerar sugestões.',
    'serviceSuggestions.noSuggestionsHint': 'Conclua mais serviços para liberar recomendações personalizadas.',
    'serviceSuggestions.avgInterval': 'Intervalo médio: {days} dias',
    'serviceSuggestions.nextSuggested': 'Próxima sugestão:',
    'serviceSuggestions.totalCompleted': 'Serviços completados: {count}',
    'serviceSuggestions.confidence.alto': 'Alta confiança',
    'serviceSuggestions.confidence.medio': 'Confiança média',
    'serviceSuggestions.confidence.baixo': 'Baixa confiança',
    generatedAt: 'Gerado em',
    totalServices: 'Total de Serviços',
    totalClients: 'Total de Clientes',
    month: 'Mês',
    count: 'Quantidade',
    
    // Financial page
    financialDashboard: 'Painel Financeiro',
    financialSubtitle: 'Acompanhe sua situação financeira',
    totalRevenue: 'Receita Total',
    pending: 'Pendentes',
    completedServices: 'Serviços Concluídos',
    recentTransactions: 'Transações Recentes',
    allTransactions: 'Todas as Transações',
    income: 'Receita',
    expense: 'Despesa',
    paid: 'Pago',
    loading: 'Carregando',
    noTransactionsFound: 'Nenhuma transação encontrada',
      
      // Menu Permissions
      menuPermissionsSubtitle: 'Configure quais opções do menu cada perfil de usuário pode acessar',
    saveChanges: 'Salvar Alterações',
    restoreDefaults: 'Restaurar Padrões',
    unsavedChanges: 'Alterações não salvas',
    menuProfile: 'Menu / Perfil',
    selectAll: 'Marcar Todos',
    deselectAll: 'Desmarcar Todos',
    mainMenu: 'Menu Principal',
    administration: 'Administração',
    legend: 'Legenda',
    mainMenuDesc: 'Opções essenciais para operação diária',
    administrationDesc: 'Opções para gerenciamento do sistema',
    reportsDesc: 'Opções para análise e relatórios',
    tip: 'Dica',
    tipText: 'Use "Marcar/Desmarcar Todos" para configurar rapidamente todas as permissões de um perfil.',
    
    // Client Management
    clientManagement: 'Gestão de Clientes',
    clientSubtitle: 'Gerencie todos os seus clientes',
    clientList: 'Lista de Clientes',
    newClient: 'Novo Cliente',
    clientName: 'Nome',
    clientPhone: 'Telefone',
    clientDocument: 'Documento',
    clientRegistration: 'Cadastro',
    clientActions: 'Ações',
    birthDate: 'Data de Nascimento',
    birthDateHelp: 'Enviaremos um lembrete de aniversário para este cliente',
    noClientsFound: 'Nenhum cliente cadastrado',
    loadingClients: 'Carregando clientes...',
    
    // Property Management
    propertyManagement: 'Gestão de Propriedades',
    propertySubtitle: 'Gerencie todas as propriedades disponíveis',
    propertyList: 'Propriedades',
    addProperty: 'Adicionar Propriedade',
    propertyName: 'Nome da Propriedade',
    propertyAddress: 'Endereço',
    propertyType: 'Tipo de Propriedade',
    propertyPrice: 'Preço Mensal (R$)',
    noPropertiesFound: 'Nenhuma propriedade cadastrada',
    loadingProperties: 'Carregando propriedades...',
    
    // Dashboard
    dashboardSubtitle: 'Bem-vindo ao sistema de gestão de propriedades',
    dashboardCustomize: 'Personalizar',
    dashboardDoneCustomize: 'Concluir',
    dashboardConfigureWidgets: 'Configurar widgets',
    dashboardLayout: 'Layout',
    dashboardLayoutGrid: 'Grade',
    dashboardLayoutList: 'Lista',
    dashboardAvailableWidgets: 'Widgets disponíveis',
    dashboardRestoreDefault: 'Restaurar padrão',
    dashboardEmptyWidgets: 'Nenhum widget visível. Abra as configurações ou restaure o layout padrão.',
    dashboardAdminTitle: 'Dashboard administrativo',
    dashboardAdminSubtitle: 'Visão geral financeira e operacional',
    dashboardSupervisorTitle: 'Dashboard de supervisão',
    dashboardSupervisorSubtitle: 'Operação de campo e equipe',
    dashboardEmployeeTitle: 'Meu dia',
    dashboardEmployeeSubtitle: 'Agendamentos e serviços de hoje',
    dashboardClientTitle: 'Meus serviços',
    dashboardClientSubtitle: 'Próximos agendamentos e histórico',
    dashboardSaveError: 'Não foi possível salvar as preferências dos widgets',
    dashboardWidgetTodayAppointments: 'Agendamentos de hoje',
    dashboardWidgetUpcoming: 'Próximos agendamentos',
    dashboardWidgetCompletedToday: 'Completados hoje',
    dashboardWidgetRecent: 'Histórico de serviços',
    dashboardWidgetTotalServices: 'Total de serviços',
    dashboardNoAppointmentsToday: 'Nenhum agendamento para hoje',
    dashboardNoUpcoming: 'Nenhum agendamento futuro',
    dashboardNoRecentServices: 'Nenhum serviço completado ainda',
    quickActions: 'Ações Rápidas',
    welcomeMessage: 'Bem-vindo ao sistema de gestão de propriedades',
    revenue: 'Receita',
    
    // User Roles
    administrator: 'Administrador',
    supervisor: 'Supervisor',
    employee: 'Funcionário',
    clientRole: 'Cliente',
    
    // Search
    searchingFor: 'Buscando por',
    
    // Common Actions
    create: 'Criar',
    edit: 'Editar',
    delete: 'Excluir',
    save: 'Salvar',
    success: 'Sucesso',
    error: 'Erro',
    confirm: 'Confirmar',
    registerProperty: 'Cadastrar Imóvel',
    editClient: 'Editar Cliente',
    deleteClient: 'Excluir Cliente',
    
    // Password validation
    passwordsDoNotMatch: 'As senhas não coincidem',
    passwordTooShort: 'A senha deve ter pelo menos 8 caracteres',
    currentPassword: 'Senha Atual',
    newPassword: 'Nova Senha',
    confirmNewPassword: 'Confirmar Nova Senha',
    changePassword: 'Alterar Senha',
    changing: 'Alterando...',
    
    // Property Types
    house: 'Casa',
    apartment: 'Apartamento',
    condo: 'Condomínio',
    commercial: 'Comercial',
    
    // Common Fields
    name: 'Nome',
    phone: 'Telefone',
    document: 'Documento',
    address: 'Endereço',
    type: 'Tipo',
    price: 'Preço',
    monthly: 'Mensal',
    actions: 'Ações',
    registration: 'Cadastro',
    
    // Users Management
    userManagement: 'Gerenciamento de Usuários',
    userSubtitle: 'Gerencie usuários e permissões do sistema',
    createNewUser: 'Criar Novo Usuário',
    editUser: 'Editar Usuário',
    filterByRole: 'Filtrar por Perfil',
    filterByStatus: 'Filtrar por Status',
    allRoles: 'Todos os perfis',
    allStatus: 'Todos os status',
    lastLogin: 'Último Login',
    never: 'Nunca',
    confirmDelete: 'Tem certeza que deseja excluir este usuário?',
    errorLoadingUsers: 'Erro ao carregar usuários. Verifique suas permissões.',
    errorCreatingUser: 'Erro ao criar usuário',
    errorUpdatingUser: 'Erro ao atualizar usuário',
    errorDeletingUser: 'Erro ao excluir usuário',
    errorUpdatingRole: 'Erro ao atualizar role',
    password: 'Senha',
    optional: 'Opcional',
    
    // Employees Management
    'employees.title': 'Gestão de Funcionários',
    'employees.subtitle': 'Gerencie sua equipe',
    'employees.list': 'Lista de Funcionários',
    'employees.new': 'Novo Funcionário',
    'employees.edit': 'Editar Funcionário',
    'employees.name': 'Nome',
    'employees.email': 'Email',
    'employees.phone': 'Telefone',
    'employees.document': 'Documento',
    'employees.noDocument': 'Sem documento',
    'employees.zone': 'Zona',
    'employees.hireDate': 'Data de Contratação',
    'employees.status': 'Status',
    'employees.active': 'Ativo',
    'employees.inactive': 'Inativo',
    'employees.notFound': 'Nenhum funcionário encontrado',
    'employees.loading': 'Carregando funcionários...',
    'employees.filter.zone': 'Zona',
    'employees.filter.allZones': 'Todas as zonas',
    'employees.filter.status': 'Status',
    'employees.filter.allStatus': 'Todos',
    'employees.filter.active': 'Ativos',
    'employees.filter.inactive': 'Inativos',
    'employees.error.loading': 'Erro ao carregar funcionários',
    'employees.ratings.highlightTitle': 'Destaques em avaliações',
    'employees.ratings.highlightSubtitle': 'Acompanhe quem está recebendo as melhores notas dos clientes.',
    'employees.ratings.total': 'avaliações',
    
    // Zones Management
    'zones.title': 'Gerenciamento de Zonas',
    'zones.subtitle': 'Gerencie as zonas geográficas de atuação',
    'zones.name': 'Nome',
    'zones.description': 'Descrição',
    'zones.center': 'Centro',
    'zones.centerLat': 'Latitude do Centro',
    'zones.centerLon': 'Longitude do Centro',
    'zones.radius': 'Raio (km)',
    'zones.radiusHelp': 'Deixe vazio para usar polígono (boundaries)',
    'zones.boundaries': 'Boundaries (JSON)',
    'zones.boundariesHelp': 'Formato GeoJSON para definir polígono da zona',
    'zones.create': 'Nova Zona',
    'zones.edit': 'Editar Zona',
    'zones.empty': 'Nenhuma zona cadastrada',
    'zones.success.created': 'Zona criada com sucesso!',
    'zones.success.updated': 'Zona atualizada com sucesso!',
    'zones.success.deleted': 'Zona desativada com sucesso!',
    'zones.error.loading': 'Erro ao carregar zonas',
    'zones.error.saving': 'Erro ao salvar zona',
    'zones.error.deleting': 'Erro ao deletar zona',
    'zones.confirm.delete': 'Tem certeza que deseja desativar a zona',
    'zones.mapView': 'Visualização no Mapa',
    'zones.showMap': 'Mostrar Mapa',
    'zones.hideMap': 'Ocultar Mapa',
    'zones.currentLocation.loading': 'Obtendo localização...',
    'zones.currentLocation.gps': 'GPS',
    'zones.currentLocation.ip': 'Aproximado (IP)',
    'zones.currentLocation.refresh': 'Atualizar localização',
    'zones.currentLocation.error': 'Localização indisponível',
    
    // Services Management
    'services.title': 'Gestão de Serviços',
    'services.subtitle': 'Gerencie os serviços de limpeza oferecidos',
    'services.list': 'Lista de Serviços',
    'services.new': 'Novo Serviço',
    'services.edit': 'Editar Serviço',
    'services.name': 'Nome do Serviço',
    'services.description': 'Descrição',
    'services.type': 'Tipo de Serviço',
    'services.duration': 'Duração (min)',
    'services.price': 'Preço Base',
    'services.rooms': 'Cômodos Incluídos',
    'services.includedRooms': 'Cômodos',
    'services.minutes': 'minutos',
    'services.notFound': 'Nenhum serviço encontrado',
    'services.loading': 'Carregando serviços...',
    'services.filter.type': 'Tipo de Serviço',
    'services.filter.allTypes': 'Todos os tipos',
    'services.filter.status': 'Status',
    'services.filter.allStatus': 'Todos',
    'services.filter.active': 'Ativos',
    'services.filter.inactive': 'Inativos',
    'services.error.loading': 'Erro ao carregar serviços',
    
    // Products Management
    'products.title': 'Gestão de Produtos',
    'products.subtitle': 'Controle de estoque de produtos de limpeza',
    'products.list': 'Lista de Produtos',
    'products.new': 'Novo Produto',
    'products.edit': 'Editar Produto',
    'products.name': 'Nome do Produto',
    'products.brand': 'Marca',
    'products.description': 'Descrição',
    'products.unit': 'Unidade',
    'products.quantity': 'Quantidade',
    'products.minStock': 'Estoque Mínimo',
    'products.costPrice': 'Preço de Custo',
    'products.category': 'Categoria',
    'products.notFound': 'Nenhum produto encontrado',
    'products.loading': 'Carregando produtos...',
    'products.filter.category': 'Categoria',
    'products.filter.allCategories': 'Todas as categorias',
    'products.filter.status': 'Status',
    'products.filter.allStatus': 'Todos',
    'products.filter.active': 'Ativos',
    'products.filter.inactive': 'Inativos',
    'products.error.loading': 'Erro ao carregar produtos',
    
    // Notification History
    'notifications.history.title': 'Histórico de Notificações',
    'notifications.history.unread': 'Não lidas:',
    'notifications.history.filterByType': 'Filtrar por tipo',
    'notifications.history.all': 'Todas',
    'notifications.history.info': 'Informativas',
    'notifications.history.success': 'Sucesso',
    'notifications.history.warning': 'Avisos',
    'notifications.history.error': 'Erros',
    'notifications.history.markAllRead': 'Marcar todas como lidas',
    'notifications.history.markAsRead': 'Marcar como lida',
    'notifications.history.delete': 'Excluir',
    'notifications.history.loading': 'Carregando...',
    'notifications.history.none': 'Nenhuma notificação ainda',
    'notifications.history.loadMore': 'Carregar mais notificações',
    'notifications.history.error.loading': 'Erro ao carregar histórico',
    'notifications.history.error.markRead': 'Erro ao marcar como lida',
    'notifications.history.error.markAllRead': 'Erro ao marcar todas como lidas',
    'notifications.history.error.delete': 'Erro ao deletar',
    
    // Notification Settings
    'notifications.settings.title': 'Configurações de Notificações',
    'notifications.settings.notSupported': 'Notificações Push não são suportadas',
    'notifications.settings.notSupportedDesc': 'Seu navegador não suporta Push Notifications. Por favor, use um navegador moderno como Chrome, Firefox ou Edge.',
    'notifications.settings.permissionStatus': 'Status da Permissão:',
    'notifications.settings.subscriptionStatus': 'Status da Subscription:',
    'notifications.settings.permission.granted': 'Concedida',
    'notifications.settings.permission.denied': 'Negada',
    'notifications.settings.permission.default': 'Não solicitada',
    'notifications.settings.subscription.active': 'Ativa',
    'notifications.settings.subscription.inactive': 'Inativa',
    'notifications.settings.activate': 'Ativar Notificações',
    'notifications.settings.activatePush': 'Ativar Push Notifications',
    'notifications.settings.sendTest': 'Enviar Notificação de Teste',
    'notifications.settings.deactivate': 'Desativar Notificações',
    'notifications.settings.permissionDenied': 'Permissão para notificações foi negada. Por favor, habilite nas configurações do navegador.',
    'notifications.settings.error.requestPermission': 'Erro ao solicitar permissão',
    'notifications.settings.error.activate': 'Erro ao ativar notificações',
    'notifications.settings.error.deactivate': 'Erro ao desativar notificações',
    'notifications.settings.error.sendTest': 'Erro ao enviar notificação de teste',
    'notifications.settings.loading': 'Carregando...',
    'notifications.settings.connecting': 'Conectando...',
    'notifications.settings.sending': 'Enviando...',
    'notifications.settings.deactivating': 'Desativando...',
    
    // Special Instructions Modal
    'specialInstructions.title': 'Instruções Especiais',
    'specialInstructions.current': 'Instruções Atuais',
    'specialInstructions.history': 'Histórico',
    'specialInstructions.placeholder': 'Digite as instruções especiais para esta propriedade...',
    'specialInstructions.saving': 'Salvando...',
    'specialInstructions.deleting': 'Deletando...',
    'specialInstructions.edit': 'Editar Instruções',
    'specialInstructions.add': 'Adicionar Instruções',
    'specialInstructions.none': 'Nenhuma instrução especial cadastrada para esta propriedade.',
    'specialInstructions.noHistory': 'Nenhum histórico de alterações encontrado.',
    'specialInstructions.changedBy': 'Alterado por:',
    'specialInstructions.invalidId': 'ID da Propriedade Inválido',
    'specialInstructions.invalidIdDesc': 'Esta propriedade (ID: {id}) não possui um UUID válido e não pode usar a funcionalidade de instruções especiais.',
    'specialInstructions.invalidIdSolution': 'Solução: Crie uma nova propriedade usando o botão "+ Add Property" na página de Propriedades.',
    'specialInstructions.error.loading': 'Erro ao carregar instruções',
    'specialInstructions.error.saving': 'Erro ao salvar instruções',
    'specialInstructions.error.deleting': 'Erro ao deletar instruções',
    'specialInstructions.confirmDelete': 'Tem certeza que deseja deletar as instruções especiais desta propriedade?',
    
    // Animal Management Modal
    'animals.title': 'Animais - {propertyName}',
    'animals.subtitle': 'Gerenciar animais desta propriedade para alertas de segurança',
    'animals.total': 'Total de animais:',
    'animals.dangerous': 'perigoso(s)',
    'animals.add': 'Adicionar Animal',
    'animals.new': 'Novo Animal',
    'animals.edit': 'Editar Animal',
    'animals.none': 'Nenhum animal cadastrado nesta propriedade.',
    'animals.addFirst': 'Adicionar Primeiro Animal',
    'animals.name': 'Nome *',
    'animals.type': 'Tipo *',
    'animals.breed': 'Raça',
    'animals.behavior': 'Comportamento',
    'animals.size': 'Tamanho',
    'animals.notes': 'Observações',
    'animals.dangerousLabel': 'Animal perigoso (requer atenção especial)',
    'animals.dangerousTag': 'Perigoso',
    'animals.type.dog': 'Cão',
    'animals.type.cat': 'Gato',
    'animals.type.bird': 'Pássaro',
    'animals.type.other': 'Outro',
    'animals.behavior.friendly': 'Amigável',
    'animals.behavior.shy': 'Tímido',
    'animals.behavior.aggressive': 'Agressivo',
    'animals.behavior.unknown': 'Desconhecido',
    'animals.size.small': 'Pequeno',
    'animals.size.medium': 'Médio',
    'animals.size.large': 'Grande',
    'animals.size.select': 'Selecione...',
    'animals.label.type': 'Tipo:',
    'animals.label.breed': 'Raça:',
    'animals.label.behavior': 'Comportamento:',
    'animals.label.size': 'Tamanho:',
    'animals.label.notes': 'Observações:',
    'animals.error.loading': 'Erro ao carregar animais',
    'animals.error.saving': 'Erro ao salvar animal',
    'animals.error.deleting': 'Erro ao excluir animal',
    'animals.success.created': 'Animal criado com sucesso!',
    'animals.success.updated': 'Animal atualizado com sucesso!',
    'animals.success.deleted': 'Animal excluído com sucesso!',
    'animals.confirmDelete': 'Tem certeza que deseja excluir este animal?',
    
    // Check-in/Check-out
    'checkin.title': 'Check-in',
    'checkout.title': 'Check-out',
    'checkin.process': 'Fazer Check-in',
    'checkout.process': 'Fazer Check-out',
    'checkin.processing': 'Processando...',
    
    // SMTP Settings
    'smtp.success.saved': 'Configuração SMTP salva com sucesso',
    'smtp.success.testSent': 'Email de teste enviado com sucesso! Verifique sua caixa de entrada.',
    'smtp.error.saving': 'Erro ao salvar configuração SMTP',
    'smtp.error.testing': 'Erro ao testar configuração SMTP',
    'smtp.error.unknown': 'Erro desconhecido',
    'smtp.error.testEmail': 'Por favor, informe um email para teste',
    'smtp.save': 'Salvar Configuração',
    'smtp.sendTest': 'Enviar Teste',
    'smtp.saveNotificationSettings': 'Salvar Notification Settings',
    
    // Reports - Months
    'reports.month.jan': 'Jan',
    'reports.month.feb': 'Fev',
    'reports.month.mar': 'Mar',
    'reports.month.apr': 'Abr',
    'reports.month.may': 'Mai',
    'reports.month.jun': 'Jun',
    'reports.month.jul': 'Jul',
    'reports.month.aug': 'Ago',
    'reports.month.sep': 'Set',
    'reports.month.oct': 'Out',
    'reports.month.nov': 'Nov',
    'reports.month.dec': 'Dez',
    'reports.clientNotInformed': 'Cliente não informado',
    'reports.error.loadingProperties': 'Erro ao buscar properties para mapear clientes',
    'reports.error.loading': 'Erro ao carregar relatórios',
    'reports.error.generating': 'Erro ao gerar relatório',
    'reports.error.generatingPdf': 'Erro ao gerar relatório PDF',
    'reports.error.generatingDetails': 'Erro ao gerar relatório. Verifique o console para mais detalhes.',
    'reports.filters': 'Filtros',
    'reports.filterByZone': 'Zona',
    'reports.allZones': 'Todas as zonas',
    
    // Properties
    'properties.error.notReturned': 'Propriedade não retornada pela API',
    'properties.success.created': 'Propriedade criada com sucesso!',
    'properties.success.updated': 'Propriedade atualizada com sucesso!',
    'properties.error.creating': 'Erro ao criar propriedade',
    'properties.error.updating': 'Erro ao atualizar propriedade',
    'properties.error.deleting': 'Erro ao deletar propriedade',
    'properties.error.loading': 'Erro ao carregar propriedades',
    'properties.error.cep': 'Erro ao buscar CEP/ZIP Code',
    'properties.confirmDelete': 'Tem certeza que deseja deletar esta propriedade?',
    'properties.clientNotFound': 'Client not found? Click "New Client" to register',
    'properties.searchingCep': 'Buscando CEP...',
    'properties.searchingZip': 'Searching ZIP Code...',
    'properties.updating': 'Atualizando...',
    'properties.creating': 'Criando...',
    'properties.update': 'Atualizar',
    'properties.create': 'Criar Propriedade',
    'properties.phone': 'Telefone',
    'properties.documentId': 'Documento',
    'properties.enterDocumentId': 'Digite o documento',
    'properties.type.residential': 'Residencial',
    'properties.type.commercial': 'Comercial',
    'properties.type.other': 'Outro',
    
    // Appointments
    'appointments.error.selectClient': 'Por favor, selecione um cliente',
    'appointments.error.selectProperty': 'Por favor, selecione uma propriedade',
    'appointments.error.selectValidProperty': 'Por favor, selecione uma propriedade válida',
    'appointments.error.selectEmployee': 'Por favor, selecione um funcionário',
    'appointments.error.creating': 'Erro ao criar agendamento',
    'appointments.error.updating': 'Erro ao atualizar agendamento',
    'appointments.error.cancelling': 'Erro ao cancelar agendamento',
    'appointments.error.dateNotInformed': 'Data não informada',
    'appointments.error.invalidDate': 'Data inválida',
    'appointments.error.formattingDate': 'Erro ao formatar data',
    'appointments.edit': 'Editar Agendamento',
    'appointments.searchClientPlaceholder': 'Digite pelo menos 3 letras para buscar cliente...',
    'appointments.selectPropertyPlaceholder': 'Selecione uma propriedade...',
    'appointments.searchPropertyPlaceholder': 'Digite para buscar ou selecione do dropdown acima',
    'appointments.searchPropertyPlaceholderAlt': 'Selecione um cliente primeiro ou digite para buscar...',
    'appointments.selectClientFirst': 'Selecione um cliente primeiro',
    'appointments.employee': 'Funcionário',
    'appointments.searchEmployeePlaceholder': 'Digite para buscar ou clique para ver todos...',
    'appointments.noName': 'Sem nome',
    'appointments.time': 'Hora',
    
    // Financial
    'financial.error.loadingPayments': 'Erro ao carregar pagamentos',
    'financial.error.loadingClients': 'Erro ao carregar clientes',
    'financial.error.loadingAllocations': 'Erro ao carregar alocações',
    'financial.error.loadingCosts': 'Erro ao carregar custos',
    'financial.error.loadingBalance': 'Erro ao carregar saldo',
    'financial.success.paymentCreated': 'Pagamento registrado com sucesso!',
    'financial.success.paymentUpdated': 'Pagamento atualizado!',
    'financial.success.paymentDeleted': 'Pagamento excluído!',
    'financial.success.allocationCreated': 'Alocação criada com sucesso!',
    'financial.success.statusUpdated': 'Status atualizado!',
    'financial.success.thirdPartyCreated': 'Terceirizado criado com sucesso! O campo foi atualizado automaticamente.',
    'financial.success.thirdPartyCreatedPartial': 'Terceirizado criado, mas houve problema ao atualizar a lista. Tente recarregar a página.',
    'financial.success.costCreated': 'Custo registrado!',
    'financial.error.creatingPayment': 'Erro ao criar pagamento',
    'financial.error.updatingPayment': 'Erro ao atualizar pagamento',
    'financial.error.deletingPayment': 'Erro ao excluir pagamento',
    'financial.error.creatingAllocation': 'Erro ao criar alocação',
    'financial.error.updatingStatus': 'Erro ao atualizar status',
    'financial.error.creatingThirdParty': 'Erro ao criar terceirizado',
    'financial.error.creatingCost': 'Erro ao criar custo',
    'financial.error.deletingCost': 'Erro ao excluir custo',
    'financial.confirmDeletePayment': 'Tem certeza que deseja excluir este pagamento?',
    'financial.confirmDeleteCost': 'Excluir este custo?',
    'financial.status.paid': 'Pago',
    'financial.status.pending': 'Pendente',
    'financial.status.cancelled': 'Cancelado',
    
    // Autocomplete
    'autocomplete.placeholder': 'Digite para buscar...',
    'autocomplete.error.searching': 'Erro ao buscar',
    'autocomplete.error.loading': 'Erro ao carregar opções iniciais',
    'autocomplete.minChars': 'Digite pelo menos {minChars} caracteres para buscar',
    'autocomplete.createNew': 'Criar novo: "{value}"',
    
    // Chat Modal
    'chat.title': 'Chat em Tempo Real',
    'chat.subtitle': 'Comunicação entre cliente e funcionário vinculados ao agendamento',
    'chat.filter': 'Filtrar por cliente ou propriedade',
    'chat.property': 'Propriedade',
    'chat.client': 'Cliente:',
    'chat.employee': 'Funcionário:',
    'chat.messagePlaceholder': 'Digite uma mensagem',
    'chat.sending': 'Enviando...',
    'chat.send': 'Enviar',
    'chat.loadingThreads': 'Carregando conversas...',
    'chat.noThreads': 'Nenhuma conversa disponível',
    'chat.loadingMessages': 'Carregando mensagens...',
    'chat.noMessages': 'Nenhuma mensagem ainda',
    'chat.selectThread': 'Selecione uma conversa para começar',
    'chat.helpRequest': 'Pedido de Ajuda · Prioridade',
    
    // Quick Create Modals
    'quickCreate.property.title': 'Cadastrar Nova Propriedade',
    'quickCreate.property.client': 'Cliente:',
    'quickCreate.property.name': 'Nome da Propriedade',
    'quickCreate.property.address': 'Endereço',
    'quickCreate.property.zipCode': 'CEP / ZIP Code',
    'quickCreate.property.type': 'Tipo',
    'quickCreate.property.city': 'Cidade',
    'quickCreate.property.state': 'Estado (UF)',
    'quickCreate.property.price': 'Preço Mensal (R$)',
    'quickCreate.property.required': '(obrigatório)',
    'quickCreate.property.searchingCep': '🔍 Buscando...',
    'quickCreate.property.cepInstructions': 'Digite o CEP (8 dígitos) ou ZIP Code (5 dígitos) para preencher automaticamente',
    'quickCreate.property.cepNotFound': 'CEP/ZIP Code não encontrado',
    'quickCreate.property.clientNotSelected': 'Cliente não selecionado. Por favor, selecione um cliente primeiro.',
    'quickCreate.property.invalidResponse': 'Resposta inválida da API - propriedade não retornada',
    'quickCreate.property.error': 'Erro ao criar propriedade',
    'quickCreate.property.error.endpoint': 'Endpoint não encontrado. Verifique se o serviço está rodando.',
    'quickCreate.property.error.invalidData': 'Dados inválidos. Verifique os campos obrigatórios.',
    'quickCreate.property.error.server': 'Erro interno do servidor. Tente novamente.',
    'quickCreate.property.error.connection': 'Erro de conexão. Verifique sua conexão com a internet.',
    'quickCreate.property.exampleName': 'Ex: Casa da Praia',
    'quickCreate.property.exampleAddress': 'Rua, número, bairro...',
    'quickCreate.property.autoFill': 'Será preenchido automaticamente pelo CEP',
    'quickCreate.property.examplePrice': 'Ex: 250.00',
    'quickCreate.property.registering': 'Cadastrando...',
    'quickCreate.property.register': 'Cadastrar Propriedade',
    'quickCreate.employee.error': 'Erro ao criar funcionário',
    'quickCreate.employee.exampleZone': 'Ex: Zona Norte',
    'quickCreate.employee.registering': 'Cadastrando...',
    'quickCreate.employee.register': 'Cadastrar Funcionário',
    'quickCreate.client.error': 'Erro ao criar cliente',
    'quickCreate.client.registering': 'Cadastrando...',
    'quickCreate.client.register': 'Cadastrar Cliente',
    
    // Complete Service Modal
    'completeService.error.positiveTime': 'Tempo real deve ser um número positivo',
    'completeService.error.invalidEndTime': 'Data/hora de término inválida',
    'completeService.error': 'Erro ao finalizar serviço',
    'completeService.error.invalidData': 'Dados inválidos. Verifique os campos preenchidos.',
    'completeService.error.notFound': 'Agendamento não encontrado. Por favor, recarregue a página.',
    'completeService.error.server': 'Erro interno do servidor. Tente novamente.',
    'completeService.error.connection': 'Erro de conexão. Verifique sua conexão com a internet.',
    'completeService.notesPlaceholder': 'Observações sobre a finalização do serviço...',
    'completeService.completing': 'Finalizando...',
    'completeService.complete': 'Finalizar Serviço',
    
    // Dashboard
    'dashboard.noAppointments': 'Nenhum agendamento ainda',
    'dashboard.employees': 'Funcionários',
    'dashboard.services': 'Serviços',
    'dashboard.products': 'Produtos',
    
    // Common error messages
    'errors.loading': 'Erro ao carregar',
    'errors.saving': 'Erro ao salvar',
    'errors.creating': 'Erro ao criar',
    'errors.updating': 'Erro ao atualizar',
    'errors.deleting': 'Erro ao deletar',
    'errors.searching': 'Erro ao buscar',
    'errors.testing': 'Erro ao testar',
    'errors.unknown': 'Erro desconhecido',
    
    // Common success messages
    'success.created': 'criado com sucesso!',
    'success.updated': 'atualizado com sucesso!',
    'success.deleted': 'deletado com sucesso!',
    'success.saved': 'salvo com sucesso!',
    
    // Common confirmations
    'confirm.delete': 'Tem certeza que deseja deletar isto?',
    'confirm.cancel': 'Tem certeza que deseja cancelar isto?',
    'confirm.action': 'Tem certeza que deseja fazer isto?',
    
    // Common placeholders
    'placeholders.typeToSearch': 'Digite para buscar...',
    'placeholders.select': 'Selecione...',
    'placeholders.pleaseSelect': 'Por favor, selecione...',
    'placeholders.pleaseInform': 'Por favor, informe...',
    
    // Common actions
    'actions.save': 'Salvar',
    'actions.cancel': 'Cancelar',
    'actions.confirm': 'Confirmar',
    'actions.delete': 'Deletar',
    'actions.edit': 'Editar',
    'actions.create': 'Criar',
    'actions.update': 'Atualizar',
    'actions.add': 'Adicionar',
    'actions.remove': 'Remover',
    
    // Ratings
    'ratings.history.title': 'Histórico de Avaliações',
    'ratings.history.subtitle': 'Visualize todas as avaliações recebidas',
    'ratings.history.empty': 'Nenhuma avaliação encontrada',
    'ratings.search.placeholder': 'Buscar por cliente, propriedade ou comentário...',
    'ratings.filter.all': 'Todos os Status',
    'ratings.filter.approved': 'Aprovadas',
    'ratings.filter.pending': 'Pendentes',
    'ratings.filter.submitted': 'Enviadas',
    'ratings.stats.average': 'Avaliação Média',
    'ratings.stats.total': 'Total de Avaliações',
    'ratings.stats.fiveStar': '5 Estrelas',

    // PWA
    'pwa.install.title': 'Instalar House Keep',
    'pwa.install.description': 'Adicione o app à tela inicial para acesso rápido.',
    'pwa.install.action': 'Instalar',
    'pwa.install.dismiss': 'Agora não',
    'pwa.install.ios_hint': 'Toque em Compartilhar e depois em "Adicionar à Tela de Início".',
    'pwa.update.title': 'Nova versão disponível',
    'pwa.update.action': 'Atualizar agora',
    'pwa.offline.message': 'Você está offline',
    'common.loading': 'Carregando...',
    'common.loadingChart': 'Carregando gráfico...',
    'common.loadingData': 'Carregando dados...',
    'common.sortBy': 'Ordenar por:',
    'common.month': 'Mês',
    'common.quantity': 'Quantidade',
    'common.position': 'Posição',
    'common.difference': 'Diferença',
    'common.yourResponse': 'Sua Resposta:',
    'common.punctuality': 'Pontualidade',
    'common.quality': 'Qualidade',
    'common.communication': 'Comunicação',
    'billing.title': 'Faturamento SaaS',
    'billing.subtitle': 'Planos de cobrança e faturas da plataforma',
    'billing.tabs.plans': 'Planos',
    'billing.tabs.invoices': 'Faturas',
    'billing.tabs.aria': 'Seções de faturamento',
    'reports.monthlyRevenue': 'Receita Mensal',
    'reports.monthlyRevenueCol': 'Receita (R$)',
    'reports.serviceTypes': 'Tipos de Serviço',
    'reports.topClients': 'Top Clientes',
    'reports.type': 'Tipo',
    'reports.client': 'Cliente',
    'reports.services': 'Serviços',
    'reports.generatedBy': 'Relatório gerado pelo Sistema Agenda House Keep',
    'reports.moreInfo': 'Para mais informações, acesse o sistema em {url}',
    'reports.timeDiscrepancies': 'Discrepâncias de Tempo',
    'reports.timeDiscrepanciesFull': 'Discrepâncias de Tempo (Esperado vs Real)',
    'reports.noClients': 'Nenhum cliente encontrado.',
    'reports.addClientsHint': 'Adicione clientes no sistema para visualizar os relatórios.',
    'reports.noDiscrepancies': 'Nenhuma discrepância encontrada.',
    'reports.allOnTime': 'Todos os serviços completados estão dentro do tempo estimado.',
    'reports.noAppointmentsDay': 'Sem agendamentos neste dia',
    'reports.loadingRatings': 'Carregando avaliações...',
    'permissions.legend': 'Legenda - Permissões CRUD:',
    'permissions.createDesc': 'Criar: Permite criar novos registros do recurso',
    'permissions.readDesc': 'Ler: Permite visualizar registros do recurso',
    'permissions.updateDesc': 'Atualizar: Permite modificar registros existentes',
    'permissions.deleteDesc': 'Deletar: Permite remover registros do recurso',
    'permissions.tipTitle': 'Dica:',
    'permissions.tipText': 'As permissões CRUD controlam quais ações cada perfil pode realizar dentro das páginas. Mesmo que um perfil tenha acesso ao menu (aba anterior), ele só poderá executar ações permitidas aqui.',
    'language.en': 'English',
    'language.es': 'Español',
    'language.ptBR': 'Português (Brasil)',
    'language.ptPT': 'Português (Portugal)',

    // Phase 4 — common UI strings
    'common.name': 'Nome',
    'common.description': 'Descrição',
    'common.status': 'Status',
    'common.email': 'Email',
    'common.phone': 'Telefone',
    'common.client': 'Cliente',
    'common.employee': 'Funcionário',
    'common.optional': '(opcional)',
    'common.requiredMark': '(obrigatório)',
    'common.all': 'Todos',
    'common.filters': 'Filtros',
    'common.action': 'Ação',
    'common.resource': 'Recurso',
    'common.clear': 'Limpar',
    'common.clearSelection': 'Limpar seleção',
    'common.tryAgain': 'Tentar novamente',
    'common.backToLogin': 'Voltar para o login',
    'common.notes': 'Observações',
    'common.value': 'Valor',
    'common.loadingClients': 'Carregando clientes...',
    'common.noData': 'Nenhum dado encontrado',
    'common.select': 'Selecione...',
    'common.dateNotInformed': 'Data não informada',
    'common.thirdParty': 'Terceirizado',
    'common.actions': 'Ações',
    'common.remove': 'Remover',
    'common.add': 'Adicionar',
    'common.update': 'Atualizar',
    'common.delete': 'Excluir',
    'common.edit': 'Editar',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.save': 'Salvar',
    'common.close': 'Fechar',
    'common.search': 'Buscar',
    'common.yes': 'Sim',
    'common.no': 'Não',
    'common.resourceLimits': 'Limites de Recursos',
    'common.keepCurrent': 'Manter atual',
    'common.keepSeries': 'Manter da série',
    'common.dateFormatHint': 'DD/MM/AAAA',
    'validation.fixFormErrors': 'Por favor, corrija os erros no formulário',
    'validation.requiredCustomFields': 'Preencha todos os campos personalizados obrigatórios.',
    'validation.priceRequired': 'O preço é obrigatório e deve ser maior que zero',
    'login.appName': 'Agenda House Keep',
    'login.tagline': 'Sistema de Gestão de Limpeza',
    'login.title': 'Entrar no Sistema',
    'login.subtitle': 'Acesse sua conta para continuar',
    'login.emailLabel': 'Email',
    'login.passwordLabel': 'Senha',
    'login.emailPlaceholder': 'seu@email.com',
    'login.emailRequired': 'Email é obrigatório',
    'login.passwordRequired': 'Senha é obrigatória',
    'login.invalidCredentials': 'Email ou senha incorretos',
    'login.connectionError': 'Erro de conexão. Verifique se os serviços estão rodando.',
    'login.twoFactorTitle': 'Autenticação em Dois Fatores',
    'login.twoFactorSubtitle': 'Informe o código de 6 dígitos do seu aplicativo autenticador',
    'login.twoFactorCodeRequired': 'Informe o código de 6 dígitos',
    'login.twoFactorInvalid': 'Código inválido. Tente novamente.',
    'login.twoFactorVerifyError': 'Erro ao verificar código. Tente novamente.',
    'login.submit': 'Entrar',
    'login.submitting': 'Entrando...',
    'login.verify': 'Verificar',
    'login.verifying': 'Verificando...',
    'login.forgotPassword': 'Esqueceu a senha?',
    'login.noAccount': 'Não tem uma conta?',
    'login.register': 'Cadastre-se',
    'forgotPassword.title': 'Esqueci minha senha',
    'forgotPassword.subtitle': 'Informe seu email para receber instruções de redefinição',
    'forgotPassword.submit': 'Enviar link de redefinição',
    'forgotPassword.backToLogin': 'Voltar para o login',
    'resetPassword.title': 'Redefinir senha',
    'resetPassword.submit': 'Redefinir senha',
    'financial.thirdPartyNone': 'Nenhum terceirizado cadastrado',
    'financial.thirdPartyHint': 'Gerencie os terceirizados na página de Funcionários. Marque "Terceirizado" ao criar ou editar um funcionário.',
    'financial.newAllocation': 'Nova Alocação',
    'financial.fixedAmount': 'Valor Fixo',
    'financial.percentage': 'Percentual',
    'financial.costs': 'Custos',
    'financial.newCost': 'Novo Custo',
    'financial.status.pending': 'Pendente',
    'financial.status.paid': 'Pago',
    'financial.status.cancelled': 'Cancelado',
    'billing.loadingInvoices': 'Carregando faturas...',
    'billing.allStatuses': 'Todos os status',
    'billing.retryLoad': 'Tentar novamente',
    'billing.generateFromPlan': 'Gerar a partir do plano ativo',
    'billing.noInvoices': 'Nenhuma fatura encontrada',
    'billing.paymentMethodPrompt': 'Método de pagamento:',
    'billing.paymentError': 'Erro ao processar pagamento',
    'dashboard.completedToday': 'Serviços finalizados hoje',
    'dashboard.completedThisMonth': 'Serviços finalizados no mês',
    'dashboard.completionRate': 'Taxa de Conclusão',
    'dashboard.noAppointmentsYet': 'Nenhum agendamento ainda',
    'dashboard.monthlyRevenueSubtitle': 'Receita dos serviços completados',
    'dashboard.servicesOverTime': '{count} serviços excederam',
    'dashboard.servicesSlower': '⚠️ {count} serviços demoraram mais que o estimado',
    'dashboard.servicesFaster': '✅ {count} serviços foram mais rápidos',
    'dashboard.noDiscrepancy': 'Nenhuma discrepância encontrada',
    'dashboard.avgDifference': 'Diferença média: {value} min',
    'dashboard.appointmentsOfDay': 'Agendamentos de {date}',
    'appointments.clearSelection': 'Limpar seleção',
    'appointments.dateNotInformed': 'Data não informada',
    'rbac.legend': 'Legenda',
    'rbac.colorLegend': 'Legenda de Cores',
    'support.title': 'Suporte',
    'support.newTicket': 'Novo ticket',
    'support.refresh': 'Atualizar',
    'support.noTickets': 'Nenhum ticket encontrado',
    'support.loading': 'Carregando tickets...',
    'zones.fillNameAndCoords': 'Por favor, preencha pelo menos o nome e as coordenadas do centro da zona',
    'menuPermissions.saved': 'Permissões salvas com sucesso!',
    'menuPermissions.saveError': 'Erro ao salvar permissões',

    // Phase 4 — common UI strings
    'common.name': 'Nome',
    'common.description': 'Descrição',
    'common.status': 'Status',
    'common.email': 'Email',
    'common.phone': 'Telefone',
    'common.client': 'Cliente',
    'common.employee': 'Funcionário',
    'common.optional': '(opcional)',
    'common.requiredMark': '(obrigatório)',
    'common.all': 'Todos',
    'common.filters': 'Filtros',
    'common.action': 'Ação',
    'common.resource': 'Recurso',
    'common.clear': 'Limpar',
    'common.clearSelection': 'Limpar seleção',
    'common.tryAgain': 'Tentar novamente',
    'common.backToLogin': 'Voltar para o login',
    'common.notes': 'Observações',
    'common.value': 'Valor',
    'common.loadingClients': 'Carregando clientes...',
    'common.noData': 'Nenhum dado encontrado',
    'common.select': 'Selecione...',
    'common.dateNotInformed': 'Data não informada',
    'common.thirdParty': 'Terceirizado',
    'common.actions': 'Ações',
    'common.remove': 'Remover',
    'common.add': 'Adicionar',
    'common.update': 'Atualizar',
    'common.delete': 'Excluir',
    'common.edit': 'Editar',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.save': 'Salvar',
    'common.close': 'Fechar',
    'common.search': 'Buscar',
    'common.yes': 'Sim',
    'common.no': 'Não',
    'common.resourceLimits': 'Limites de Recursos',
    'common.keepCurrent': 'Manter atual',
    'common.keepSeries': 'Manter da série',
    'common.dateFormatHint': 'DD/MM/AAAA',
    'validation.fixFormErrors': 'Por favor, corrija os erros no formulário',
    'validation.requiredCustomFields': 'Preencha todos os campos personalizados obrigatórios.',
    'validation.priceRequired': 'O preço é obrigatório e deve ser maior que zero',
    'login.appName': 'Agenda House Keep',
    'login.tagline': 'Sistema de Gestão de Limpeza',
    'login.title': 'Entrar no Sistema',
    'login.subtitle': 'Acesse sua conta para continuar',
    'login.emailLabel': 'Email',
    'login.passwordLabel': 'Senha',
    'login.emailPlaceholder': 'seu@email.com',
    'login.emailRequired': 'Email é obrigatório',
    'login.passwordRequired': 'Senha é obrigatória',
    'login.invalidCredentials': 'Email ou senha incorretos',
    'login.connectionError': 'Erro de conexão. Verifique se os serviços estão rodando.',
    'login.twoFactorTitle': 'Autenticação em Dois Fatores',
    'login.twoFactorSubtitle': 'Informe o código de 6 dígitos do seu aplicativo autenticador',
    'login.twoFactorCodeRequired': 'Informe o código de 6 dígitos',
    'login.twoFactorInvalid': 'Código inválido. Tente novamente.',
    'login.twoFactorVerifyError': 'Erro ao verificar código. Tente novamente.',
    'login.submit': 'Entrar',
    'login.submitting': 'Entrando...',
    'login.verify': 'Verificar',
    'login.verifying': 'Verificando...',
    'login.forgotPassword': 'Esqueceu a senha?',
    'login.noAccount': 'Não tem uma conta?',
    'login.register': 'Cadastre-se',
    'forgotPassword.title': 'Esqueci minha senha',
    'forgotPassword.subtitle': 'Informe seu email para receber instruções de redefinição',
    'forgotPassword.submit': 'Enviar link de redefinição',
    'forgotPassword.backToLogin': 'Voltar para o login',
    'resetPassword.title': 'Redefinir senha',
    'resetPassword.submit': 'Redefinir senha',
    'financial.thirdPartyNone': 'Nenhum terceirizado cadastrado',
    'financial.thirdPartyHint': 'Gerencie os terceirizados na página de Funcionários. Marque "Terceirizado" ao criar ou editar um funcionário.',
    'financial.newAllocation': 'Nova Alocação',
    'financial.fixedAmount': 'Valor Fixo',
    'financial.percentage': 'Percentual',
    'financial.costs': 'Custos',
    'financial.newCost': 'Novo Custo',
    'financial.status.pending': 'Pendente',
    'financial.status.paid': 'Pago',
    'financial.status.cancelled': 'Cancelado',
    'billing.loadingInvoices': 'Carregando faturas...',
    'billing.allStatuses': 'Todos os status',
    'billing.retryLoad': 'Tentar novamente',
    'billing.generateFromPlan': 'Gerar a partir do plano ativo',
    'billing.noInvoices': 'Nenhuma fatura encontrada',
    'billing.paymentMethodPrompt': 'Método de pagamento:',
    'billing.paymentError': 'Erro ao processar pagamento',
    'dashboard.completedToday': 'Serviços finalizados hoje',
    'dashboard.completedThisMonth': 'Serviços finalizados no mês',
    'dashboard.completionRate': 'Taxa de Conclusão',
    'dashboard.noAppointmentsYet': 'Nenhum agendamento ainda',
    'dashboard.monthlyRevenueSubtitle': 'Receita dos serviços completados',
    'dashboard.servicesOverTime': '{count} serviços excederam',
    'dashboard.servicesSlower': '⚠️ {count} serviços demoraram mais que o estimado',
    'dashboard.servicesFaster': '✅ {count} serviços foram mais rápidos',
    'dashboard.noDiscrepancy': 'Nenhuma discrepância encontrada',
    'dashboard.avgDifference': 'Diferença média: {value} min',
    'dashboard.appointmentsOfDay': 'Agendamentos de {date}',
    'appointments.clearSelection': 'Limpar seleção',
    'appointments.dateNotInformed': 'Data não informada',
    'rbac.legend': 'Legenda',
    'rbac.colorLegend': 'Legenda de Cores',
    'support.title': 'Suporte',
    'support.newTicket': 'Novo ticket',
    'support.refresh': 'Atualizar',
    'support.noTickets': 'Nenhum ticket encontrado',
    'support.loading': 'Carregando tickets...',
    'zones.fillNameAndCoords': 'Por favor, preencha pelo menos o nome e as coordenadas do centro da zona',
    'menuPermissions.saved': 'Permissões salvas com sucesso!',
    'menuPermissions.saveError': 'Erro ao salvar permissões',
    'recurrence.createTitle': 'Criar Agendamento Recorrente',
    'recurrence.validateConflicts': 'Validar Conflitos',
    'recurrence.creating': 'Criando...',
    'recurrence.createSeries': 'Criar Série',
    'recurrence.noConflicts': 'Não há conflitos! Pode criar a série.',
    'recurrence.successCreated': 'Série recorrente criada com sucesso!',
    'recurrence.errorCreating': 'Erro ao criar série recorrente',
    'workload.loading': 'Carregando carga de trabalho...',
    'workload.errorLoading': 'Erro ao carregar carga de trabalho',
    'forgotPassword.sendLink': 'Enviar Link de Recuperação',
    'forgotPassword.success': 'Se o email existir, um link de recuperação foi enviado.',
    'forgotPassword.error': 'Erro ao processar solicitação.',
    'setup2fa.required': 'Configuração Obrigatória',
    'support.noTicketsYet': 'Nenhum chamado ainda.',
    'calendar.appointmentsTitle': 'Calendário de Agendamentos',
    'zone.myLocation': 'Minha localização',
    'checkpoint.none': 'Nenhum checkpoint encontrado',
    'twoFactor.title': 'Autenticação em Duas Etapas',
    'employeeSelector.loading': 'Carregando funcionários...',
    'quickCreate.employee.title': 'Cadastrar Novo Funcionário',
    'preferences.loading': 'Carregando preferências...',
    'smtp.settingsTitle': 'Configurações SMTP',
    'financial.subtitle': 'Controle de pagamentos, custos e distribuição para terceirizados',
    'companySwitcher.loading': 'Carregando empresas...',
    'completeService.cancel': 'Cancelar',

    'setup2fa.subtitle': 'Para sua segurança, é necessário configurar a autenticação em duas etapas (2FA) antes de continuar.',
    'companySwitcher.notFound': 'Nenhuma empresa encontrada',
    'companySwitcher.noneAvailable': 'Nenhuma empresa disponível',
    // Phase 4 final
    'audit.title': 'Log de Auditoria',
    'audit.subtitle': 'Histórico completo de todas as ações realizadas no sistema',
    'audit.applyFilters': 'Aplicar Filtros',
    'audit.noLogs': 'Nenhum log encontrado',
    'audit.errorLoading': 'Erro ao carregar logs de auditoria',
    'audit.errorExport': 'Erro ao exportar logs',
    'audit.next': 'Próximo',
    'audit.previous': 'Anterior',
    'checkpoint.title': 'Histórico de Checkpoints',
    'checkpoint.loading': 'Carregando histórico...',
    'checkpoint.errorLoading': 'Erro ao carregar histórico de checkpoints',
    'checkpoint.stats': 'Estatísticas',
    'checkpoint.avgPerService': 'Média por Serviço',
    'checkpoint.duration': 'Duração:',
    'rating.title': 'Avaliar Serviço',
    'rating.overall': 'Avaliação Geral *',
    'rating.anonymous': 'Avaliação anônima',
    'rating.success': 'Avaliação enviada com sucesso!',
    'rating.detailedOptional': 'Avaliações Detalhadas (Opcional)',
    'rating.commentOptional': 'Comentário (Opcional)',
    'rating.commentPlaceholder': 'Compartilhe sua experiência com este serviço...',
    'rating.submit': 'Enviar Avaliação',
    'recurrence.editTitle': 'Editar Agendamento Recorrente',
    'recurrence.cancelOccurrence': 'Cancelar apenas esta ocorrência',
    'recurrence.cancelSeries': 'Cancelar toda a série (todas as ocorrências futuras)',
    'recurrence.newEndDate': 'Nova data de término',
    'recurrence.newDuration': 'Nova duração (minutos)',
    'recurrence.newInstructions': 'Novas instruções especiais',
    'recurrence.startDate': 'Data de início *',
    'recurrence.dayOfMonth': 'Dia do mês *',
    'recurrence.frequency': 'Frequência',
    'recurrence.frequencyRequired': 'Frequência *',
    'recurrence.durationRequired': 'Duração (minutos) *',
    'recurrence.daily': 'Diário (todos os dias)',
    'recurrence.monthly': 'Mensal (todo mês)',
    'company.search': 'Buscar empresa',
    'company.searchPlaceholder': 'Buscar empresa...',
    'company.switchTitle': 'Trocar Empresa',
    'company.switchHint': 'Selecione a empresa para trocar o contexto',
    'company.notFound': 'Nenhuma empresa encontrada',
    'company.noneAvailable': 'Nenhuma empresa disponível',
    'completeService.title': 'Finalizar Serviço',
    'completeService.endTime': 'Hora de Término',
    'completeService.autoCalcHint': 'Se não informado, será calculado automaticamente',
    'dashboard.welcome': 'Bem-vindo ao sistema de gestão de limpeza',
    'dashboard.noClients': 'Nenhum cliente cadastrado',
    'dashboard.newClient': 'Novo Cliente',
    'employeeDashboard.loading': 'Carregando dashboard...',
    'employeeDashboard.error': 'Erro ao carregar dashboard',
    'employeeDashboard.completed': 'Concluídos',
    'employeeDashboard.thisMonth': 'Este Mês',
    'employeeDashboard.noUpcoming': 'Nenhum agendamento próximo',
    'employeeDashboard.noData': 'Nenhum dado disponível',
    'employeeDashboard.avgRating': 'Avaliação média:',
    'employeeSelector.available': 'Disponível',
    'employeeSelector.unavailable': 'Indisponível',
    'employeeSelector.noneAvailable': 'Nenhum funcionário disponível',
    'employeeSelector.invalidZone': 'Zona inválida',
    'employeeSelector.validZone': 'Zona válida',
    'workload.title': 'Carga de Trabalho dos Funcionários',
    'workload.avgLoad': 'Média carga (20-40h)',
    'workload.totalAppointments': 'Total de agendamentos:',
    'workload.totalEmployees': 'Total de funcionários:',
    'login.back': 'Voltar',
    'login.forgotPasswordLink': 'Esqueci minha senha',
    'login.twoFactorVerification': 'Verificação em Duas Etapas',
    'login.verificationCode': 'Código de Verificação',
    'login.twoFactorAppHint': 'Digite o código de 6 dígitos do seu aplicativo autenticador',
    'login.contactAdmin': 'Entre em contato com o administrador para criar uma conta',
    'login.privacyPolicy': 'Política de Privacidade',
    'forgotPassword.titleFull': 'Recuperar Senha',
    'forgotPassword.subtitleFull': 'Digite seu email para receber um link de recuperação',
    'quickCreate.client.title': 'Cadastrar Novo Cliente',
    'zone.drawStart': 'Começar a Desenhar',
    'zone.redraw': 'Redesenhar',
    'zone.removeLast': 'Remover Último',
    'zone.minPoints': 'É necessário pelo menos 3 pontos para formar um polígono',
    'zone.centerOnMe': 'Centralizar na minha localização',
    'zone.yourLocation': 'Sua localização',
    'limits.loading': 'Carregando limites...',
    'limits.configure': 'Configurar Limites',
    'limits.usageStats': 'Estatísticas de Uso',
    'limits.maxClients': 'Máximo de Clientes',
    'limits.maxEmployees': 'Máximo de Funcionários',
    'limits.maxUsers': 'Máximo de Usuários',
    'limits.errorLoading': 'Não foi possível carregar limites.',
    'limits.disabledHint': 'Quando desativado, os limites não serão aplicados',
    'billing.invoiceDetails': 'Detalhes da Fatura',
    'billing.clearFilter': 'Limpar filtro',
    'billing.number': 'Número:',
    'plans.loading': 'Carregando planos...',
    'plans.billingCycle': 'Ciclo de Cobrança',
    'plans.errorDeactivate': 'Erro ao desativar plano',
    'plans.errorSave': 'Erro ao salvar plano',
    'plans.history': 'Histórico de Planos',
    'plans.noneRegistered': 'Nenhum plano cadastrado. Clique em',
    'plans.name': 'Nome do Plano',
    'plans.new': 'Novo Plano',
    'customization.adminOnly': 'Apenas administradores podem gerenciar customizações por empresa.',
    'customization.subtitle': 'Configure experiência única para cada cliente corporativo.',
    'customization.title': 'Customização por empresa',
    'customization.selectCompany': 'Selecione uma empresa para personalizar funcionalidades.',
    'customization.branding.subtitle': 'Personalize logotipo, cores e CSS personalizado da empresa.',
    'customization.branding.primaryColor': 'Cor primária',
    'customization.branding.secondaryColor': 'Cor secundária',
    'customization.branding.gradientHint': 'Botões, cards e gráficos utilizarão esse gradiente personalizado.',
    'customization.branding.errorSave': 'Erro ao salvar branding.',
    'customization.branding.errorLoad': 'Não foi possível carregar o branding da empresa.',
    'customization.fields.loading': 'Carregando campos customizados...',
    'customization.fields.required': 'Campo obrigatório',
    'customization.fields.byModule': 'Campos por módulo',
    'customization.fields.configJson': 'Configuração (JSON)',
    'customization.fields.errorRemove': 'Erro ao remover campo.',
    'customization.fields.errorSave': 'Erro ao salvar campo customizado.',
    'customization.features.loading': 'Carregando feature flags...',
    'customization.features.advancedJson': 'Configuração avançada (JSON)',
    'customization.features.enabled': 'Feature habilitado para a empresa',
    'customization.features.invalidJson': 'JSON de configuração inválido.',
    'customization.features.clearForm': 'Limpar formulário',
    'customization.features.none': 'Nenhum feature flag configurado para esta empresa.',
    'customization.features.errorSave': 'Erro ao salvar feature flag.',
    'customization.templates.loading': 'Carregando templates...',
    'customization.templates.subtitle': 'Customize o conteúdo das notificações enviadas aos clientes.',
    'customization.templates.welcomeSample': 'Bem-vindo à House Keep!',
    'customization.templates.errorRemove': 'Erro ao remover template.',
    'customization.workflows.loading': 'Carregando módulos...',
    'customization.workflows.definitionJson': 'Definição do workflow (JSON)',
    'customization.workflows.editor': 'Editor de workflow',
    'customization.workflows.errorRemove': 'Erro ao remover workflow.',
    'customization.workflows.errorSave': 'Erro ao salvar workflow.',
    'customization.workflows.moduleRequired': 'Informe o módulo do workflow.',
    'customization.workflows.invalidJson': 'JSON de definição inválido.',
    'customization.workflows.module': 'Módulo *',
    'customFields.loading': 'Carregando campos personalizados...',
    'adminDashboard.attentionRequired': 'Atenção Requerida',
    'adminDashboard.loadingTrend': 'Carregando dados de tendência...',
    'adminDashboard.noEmployeesCompleted': 'Nenhum funcionário com serviços completados',
    'adminDashboard.last6Months': 'Últimos 6 meses',
    'clientDashboard.errorHistory': 'Erro ao carregar histórico de serviços',
    'employeeDashboard.errorToday': 'Erro ao carregar agendamentos do dia',
    'rbac.departments.title': 'Departamentos',
    'rbac.departments.parent': 'Departamento Pai',
    'rbac.departments.parentOptional': 'Departamento Pai (opcional)',
    'rbac.departments.descPlaceholder': 'Descrição do departamento',
    'rbac.departments.none': 'Nenhum',
    'rbac.departments.noneConfigured': 'Nenhum departamento configurado',
    'rbac.permissions.conditions': 'Condições',
    'rbac.permissions.conditionsOptional': 'Condições (JSON opcional)',
    'rbac.permissions.noneConfigured': 'Nenhuma permissão configurada',
    'rbac.permissions.new': 'Nova Permissão',
    'rbac.permissions.errorLoad': 'Não foi possível carregar permissões.',
    'rbac.roles.custom': 'Customizado',
    'rbac.roles.descPlaceholder': 'Descrição do role',
    'rbac.roles.noneConfigured': 'Nenhum role configurado',
    'rbac.roles.errorLoad': 'Não foi possível carregar roles.',
    'rbac.roles.permissions': 'Permissões',
    'rbac.management.title': 'Gestão de RBAC',
    'rbac.management.subtitle': 'Controle de acesso baseado em roles, permissões e departamentos.',
    'rbac.management.adminOnly': 'Apenas administradores podem gerenciar RBAC.',
    'rbac.management.selectCompany': 'Selecione uma empresa para gerenciar RBAC.',
    'limits.management.adminOnly': 'Apenas administradores do sistema podem configurar esses limites.',
    'limits.management.loadingCompany': 'Carregando informações da empresa...',
    'limits.management.selectCompany': 'Selecione uma empresa para gerenciar os limites de recursos.',
    'preferences.channels': 'Canais de Notificação',
    'preferences.subtitle': 'Configure como e quando você deseja receber notificações',
    'preferences.quietHours': 'Horários Silenciosos',
    'preferences.quietHoursHint': 'Durante este período, você não receberá notificações (exceto urgentes)',
    'preferences.quietStart': 'Início (HH:MM)',
    'preferences.appointmentCreated': 'Agendamento Criado',
    'preferences.appointmentCancelled': 'Agendamento Cancelado',
    'preferences.appointmentReminders': 'Lembretes de Agendamento',
    'resetPassword.minLength': 'A senha deve ter pelo menos 6 caracteres.',
    'resetPassword.mismatch': 'As senhas não coincidem.',
    'resetPassword.confirmNew': 'Confirmar Nova Senha',
    'resetPassword.newPassword': 'Nova Senha',
    'resetPassword.placeholder': 'Digite sua nova senha',
    'resetPassword.successTitle': 'Senha Redefinida!',
    'resetPassword.successMessage': 'Senha redefinida com sucesso! Redirecionando para o login...',
    'resetPassword.titleFull': 'Redefinir Senha',
    'setup2fa.logoutRetry': 'Sair e tentar novamente mais tarde',
    'support.tickets': 'Chamados',
    'support.ticketsSubtitle': 'Chamados e SLA isolados por empresa',
    'support.openTicket': 'Abrir chamado',
    'support.newTicketBtn': 'Novo chamado',
    'support.errorUpdate': 'Falha ao atualizar chamado.',
    'support.errorCreate': 'Falha ao criar chamado.',
    'support.average': 'Média',
    'support.refreshBtn': 'Atualizar',
    'timeDiscrepancies.subtitle': 'Análise detalhada de serviços com diferenças entre tempo estimado e real',
    'timeDiscrepancies.avgDifference': 'Diferença Média',
    'timeDiscrepancies.errorLoading': 'Erro ao carregar discrepâncias de tempo',
    'timeDiscrepancies.errorExport': 'Erro ao exportar relatório',
    'timeDiscrepancies.backToReports': '← Voltar para Relatórios',
    'timeDiscrepancies.alphabetical': '🔤 Ordem Alfabética',
    'timeDiscrepancies.service': 'Serviço',
    'reports.errorGenerate': 'Erro ao gerar relatório. Verifique o console para mais detalhes.',
    'chat.sendWhatsApp': 'Enviar também via WhatsApp',
    'notes.templatePreview': 'Assunto pré-visualizado:',
    'notes.applyTemplate': 'Aplicar conteúdo do template',
    'notes.mobileHint': 'A notificação será enviada para o aplicativo móvel do cliente.',
    'notes.loadingTemplates': 'Carregando templates...',
    'menuPermissions.loading': 'Carregando permissões...',
    'menuPermissions.crudTitle': 'Permissões CRUD',
    'menuPermissions.menuTitle': 'Permissões de Menu',
    'menuPermissions.resourceAction': 'Recurso / Ação',
    'companies.searchPlaceholder': 'Buscar empresas...',
    'companies.active': 'Empresa ativa',
    'companies.errorLoad': 'Erro ao carregar empresas:',
    'companies.errorDelete': 'Erro ao excluir empresa:',
    'companies.errorSave': 'Erro ao salvar empresa:',
    'users.passwordRequiredWhen': 'A senha é obrigatória quando',
    'users.administrator': 'Administrador',
    'users.changePassword': 'Alterar Senha',
    'users.passwordMismatch': 'As senhas não coincidem',
    'users.errorDelete': 'Erro ao excluir usuário:',
    'users.errorCompany': 'Não foi possível determinar a empresa. Por favor, recarregue a página e tente novamente.',
    'users.errorGetCompany': 'Erro ao obter empresa. Por favor, recarregue a página e tente novamente.',
    'appointments.recurring': 'Agendamento Recorrente',
    'appointments.clientSignature': 'Assinatura do cliente',
    'appointments.createFirst': 'Criar Primeiro Agendamento',
    'appointments.errorUpdateProperties': 'Erro ao atualizar propriedades',
    'appointments.errorLoad': 'Erro ao carregar agendamentos. Tente recarregar a página.',
    'appointments.searchClientMin': 'Digite pelo menos 3 letras para buscar cliente...',
    'twoFactor.enabled': '2FA Ativado',
    'twoFactor.disabled': '2FA Desativado',
    'twoFactor.disabledSuccess': '2FA desativado com sucesso.',
    'twoFactor.enabledSuccess': '2FA habilitado com sucesso!',
    'twoFactor.adminMustKeep': 'Administradores devem manter o 2FA habilitado.',
    'twoFactor.warning': 'Atenção:',
    'twoFactor.activate': 'Ativar 2FA',
    'twoFactor.deactivate': 'Desativar 2FA',
    'twoFactor.deactivateTitle': 'Desativar 2FA',
    'twoFactor.deactivateWarning': 'O 2FA é obrigatório para sua conta. Entre em contato com o administrador se precisar desativar.',
    'twoFactor.enabledInfo': 'Seu login exige o código de 2FA. Guarde seus códigos de backup em local seguro.',
    'twoFactor.disabledInfo': 'O 2FA está desativado. Ative para adicionar uma camada extra de segurança à sua conta.',
    'twoFactor.requiredDisabled': 'Esta ação está desabilitada porque o 2FA é obrigatório para sua conta.',
    'twoFactor.errorLoadStatus': 'Não foi possível carregar o status do 2FA.',
    'twoFactor.errorStartSetup': 'Falha ao iniciar configuração 2FA.',
    'twoFactor.errorDisable': 'Não foi possível desativar o 2FA.',
    'products.deactivate': 'Desativar',
    'products.deleteTitle': 'Deletar Produto',
    'products.cost': 'Custo:',
    'products.warning': 'ATENÇÃO:',
    'products.descriptionPlaceholder': 'Descrição do produto...',
    'products.errorDeactivate': 'Erro ao desativar produto',
    'services.deactivate': 'Desativar',
    'services.deleteTitle': 'Deletar Serviço',
    'services.descriptionPlaceholder': 'Descrição detalhada do serviço...',
    'services.errorDeactivate': 'Erro ao desativar serviço',
    'services.errorReactivate': 'Erro ao reativar serviço',
    'services.deleteChoice': 'Escolha como deseja deletar este serviço:',
    'services.hardDeleteUnavailable': 'Hard delete não disponível. Fazendo soft delete...',
    'settings.whatsapp': 'Configurações WhatsApp',
    'settings.smtpSaved': 'Configuração SMTP salva com sucesso',
    'settings.whatsappSaved': 'Configuração WhatsApp salva com sucesso',
    'settings.currentApplied': 'Configurações Atuais Aplicadas:',
    'settings.customizationByCompany': 'Customização por Empresa',
    'settings.phonePlaceholder': '+5511999999999 ou whatsapp:+5511999999999',
    'settings.auth': 'Autenticação',
    'settings.timezoneBRT': 'Fuso Horário de Brasília (BRT)',
    'calendar.appointments': 'agendamentos',
    'calendar.titleShort': 'Calendário de Agendamentos',
    'finance.addContractorQuick': 'Adicionar Terceirizado Rápido',
    'finance.allocationSuccess': 'Alocação criada com sucesso!',
    'finance.loadingMonth': 'Carregando dados do mês...',
    'finance.selectToDistribute': 'Clique no botão "Selecionar para Distribuir"',
    'finance.createFirstAllocation': 'Criar Primeira Alocação',
    'properties.instructions': 'Instruções',
    'properties.cepHint': '💡 8 dígitos (Brasil) ou 5 dígitos (USA)',
    'properties.errorLoad': 'Erro ao carregar propriedades:',
    'employees.thirdPartyHint': 'Marque se este funcionário é um terceirizado/contratado externo',
    'employees.zoneExample': 'Ex: Zona Norte, Centro, etc.',

    'menu.companies': 'Empresas',
    'menu.zones': 'Zonas',
    'menu.services': 'Serviços',
    'menu.limits': 'Limites',
    'menu.rbac': 'RBAC',
    'menu.notificationPreferences': 'Preferências de Notificação',
    'menu.history': 'Histórico',
  },
  
  'pt-PT': {
    // Navigation
    dashboard: 'Painel',
    users: 'Utilizadores',
    menuPermissions: 'Permissões de Menu',
    clients: 'Clientes',
    properties: 'Imóveis',
    appointments: 'Marcações',
    financial: 'Financeiro',
    reports: 'Relatórios',
    settings: 'Definições',
    logout: 'Terminar sessão',
    help: 'Ajuda',
    helpTitle: 'Central de Ajuda',
    helpSubtitle: 'Assista aos vídeos tutoriais para aprender a usar o Agenda House Keep.',
    helpVideoList: 'Tutoriais disponíveis',
    helpVideoOverview: 'Visão geral do sistema',
    helpVideoOverviewDesc: 'Navegue pelos módulos principais: painel, clientes, marcaçãos e financeiro.',
    helpVideoAdminFull: 'Admin — fluxo completo',
    helpVideoAdminFullDesc: 'Registe colaboradors, clientes, imóvels e agende um serviço de limpeza.',
    helpVideoEmployee: 'Colaborador — rotina diária',
    helpVideoEmployeeDesc: 'Veja sua agenda, clientes, avaliações e preferências de notificação.',
    helpVideoClient: 'Cliente — marcaçãos e preferências',
    helpVideoClientDesc: 'Acompanhe seus marcaçãos de limpeza e configure alertas de notificação.',
    helpTip: 'Os vídeos não possuem áudio — as legendas explicativas estão queimadas na gravação. Use tela cheia para melhor leitura.',
    helpAudienceAll: 'Todos',
    helpAudienceAdmin: 'Admin',
    helpAudienceEmployee: 'Colaborador',
    helpAudienceClient: 'Cliente',
    helpRecommended: 'Para si',
    search: 'Pesquisar...',
    searchAll: 'Todos',
    searching: 'Buscando...',
    noResults: 'Nenhum resultado encontrado',
    recentSearches: 'Buscas Recentes',
    employees: 'Colaboradores',
    products: 'Produtos',
    
    // Settings Page
    settingsTitle: 'Definições',
    settingsSubtitle: 'Gira suas preferências e definições da conta',
    settingsMenu: 'Menu de Definições',
    myAccount: 'A minha conta',
    notifications: 'Notificações',
    security: 'Segurança',
    
    // Account Settings
    regionalSettings: 'Definições Regionais',
    language: 'Idioma',
    currency: 'Moeda',
    dateFormat: 'Formato de Data',
    timeFormat: 'Formato de Hora',
    timezone: 'Fuso horário',
    numberFormat: 'Formato de Números',
    
    // Save buttons
    saveSettings: 'Guardar Definições',
    saving: 'A guardar...',
    settingsSaved: 'Definições salvas com sucesso!',
    
    // Account info
    accountInformation: 'Informações da Conta',
    email: 'Correio eletrónico',
    role: 'Função',
    status: 'Status',
    active: 'Ativo',
    inactive: 'Inativo',
    
    // Reports page
    reportsAndAnalytics: 'Relatórios e Análises',
    reportsSubtitle: 'Acompanhe o desempenho do seu negócio',
    period: 'Período',
    
    // Appointments page
    appointmentManagement: 'Gestão de Marcações',
    appointmentSubtitle: 'Gira todos os marcaçãos de serviços',
    appointmentList: 'Lista de Marcações',
    newAppointment: 'Novo Marcação',
    client: 'Cliente',
    property: 'Imóvel',
    serviceType: 'Tipo de Serviço',
    dateTime: 'Data e Hora',
    cleaning: 'Limpeza',
    maintenance: 'Manutenção',
    repair: 'Reparo',
    schedule: 'Agendar',
    cancel: 'Cancelar',
    noAppointmentsFound: 'Nenhum marcação encontrado',
    loadingAppointments: 'Carregando marcaçãos...',
    appointmentCreatedSuccess: 'Marcação criado com sucesso!',
    appointmentUpdatedSuccess: 'Marcação atualizado com sucesso!',
    appointmentCancelledSuccess: 'Marcação cancelado com sucesso!',
    format: 'Formato',
    scheduled: 'Agendado',
    confirmed: 'Confirmado',
    completed: 'Concluído',
    cancelled: 'Cancelado',
    last3Months: 'Últimos 3 meses',
    last6Months: 'Últimos 6 meses',
    lastYear: 'Último ano',
    monthlyRevenue: 'Receita Mensal',
    servicesByType: 'Serviços por Tipo',
    topClients: 'Top Clientes',
    download: 'Baixar',
    totalBilled: 'Total faturado',
    services: 'serviços',
    reportMonthlyRevenue: 'Relatório de Receita Mensal',
    reportServiceTypes: 'Relatório de Tipos de Serviço',
    reportTopClients: 'Relatório de Top Clientes',
    reportTypeNotRecognized: 'Tipo de relatório não reconhecido',
    reportGeneratedSuccess: 'Relatório {type} gerado e baixado com sucesso!',
    reportGenerationError: 'Erro ao gerar relatório. Verifique o console para mais detalhes.',
    'serviceSuggestions.title': 'Sugestões de Próximo Serviço',
    'serviceSuggestions.subtitle': 'Analisamos o histórico de marcaçãos para sugerir o melhor momento de recontato.',
    'serviceSuggestions.loading': 'Calculando sugestões...',
    'serviceSuggestions.noSuggestions': 'Ainda não há histórico suficiente para gerar sugestões.',
    'serviceSuggestions.noSuggestionsHint': 'Conclua mais serviços para liberar recomendações personalizadas.',
    'serviceSuggestions.avgInterval': 'Intervalo médio: {days} dias',
    'serviceSuggestions.nextSuggested': 'Próxima sugestão:',
    'serviceSuggestions.totalCompleted': 'Serviços completados: {count}',
    'serviceSuggestions.confidence.alto': 'Alta confiança',
    'serviceSuggestions.confidence.medio': 'Confiança média',
    'serviceSuggestions.confidence.baixo': 'Baixa confiança',
    generatedAt: 'Gerado em',
    totalServices: 'Total de Serviços',
    totalClients: 'Total de Clientes',
    month: 'Mês',
    count: 'Quantidade',
    
    // Financial page
    financialDashboard: 'Painel Financeiro',
    financialSubtitle: 'Acompanhe sua situação financeira',
    totalRevenue: 'Receita Total',
    pending: 'Pendentes',
    completedServices: 'Serviços Concluídos',
    recentTransactions: 'Transações Recentes',
    allTransactions: 'Todas as Transações',
    income: 'Receita',
    expense: 'Despesa',
    paid: 'Pago',
    loading: 'Carregando',
    noTransactionsFound: 'Nenhuma transação encontrada',
      
      // Menu Permissions
      menuPermissionsSubtitle: 'Configure quais opções do menu cada perfil de usuário pode acessar',
    saveChanges: 'Guardar Alterações',
    restoreDefaults: 'Restaurar Padrões',
    unsavedChanges: 'Alterações não salvas',
    menuProfile: 'Menu / Perfil',
    selectAll: 'Marcar Todos',
    deselectAll: 'Desmarcar Todos',
    mainMenu: 'Menu Principal',
    administration: 'Administração',
    legend: 'Legenda',
    mainMenuDesc: 'Opções essenciais para operação diária',
    administrationDesc: 'Opções para gerenciamento do sistema',
    reportsDesc: 'Opções para análise e relatórios',
    tip: 'Dica',
    tipText: 'Use "Marcar/Desmarcar Todos" para configurar rapidamente todas as permissões de um perfil.',
    
    // Client Management
    clientManagement: 'Gestão de Clientes',
    clientSubtitle: 'Gira todos os seus clientes',
    clientList: 'Lista de Clientes',
    newClient: 'Novo Cliente',
    clientName: 'Nome',
    clientPhone: 'Telemóvel',
    clientDocument: 'Documento',
    clientRegistration: 'Cadastro',
    clientActions: 'Ações',
    birthDate: 'Data de Nascimento',
    birthDateHelp: 'Enviaremos um lembrete de aniversário para este cliente',
    noClientsFound: 'Nenhum cliente cadastrado',
    loadingClients: 'Carregando clientes...',
    
    // Property Management
    propertyManagement: 'Gestão de Imóveis',
    propertySubtitle: 'Gira todas as imóvels disponíveis',
    propertyList: 'Imóveis',
    addProperty: 'Adicionar Imóvel',
    propertyName: 'Nome da Imóvel',
    propertyAddress: 'Morada',
    propertyType: 'Tipo de Imóvel',
    propertyPrice: 'Preço Mensal (€)',
    noPropertiesFound: 'Nenhuma imóvel cadastrada',
    loadingProperties: 'Carregando imóvels...',
    
    // Dashboard
    dashboardSubtitle: 'Bem-vindo ao sistema de gestão de imóvels',
    dashboardCustomize: 'Personalizar',
    dashboardDoneCustomize: 'Concluir',
    dashboardConfigureWidgets: 'Configurar widgets',
    dashboardLayout: 'Layout',
    dashboardLayoutGrid: 'Grade',
    dashboardLayoutList: 'Lista',
    dashboardAvailableWidgets: 'Widgets disponíveis',
    dashboardRestoreDefault: 'Restaurar padrão',
    dashboardEmptyWidgets: 'Nenhum widget visível. Abra as definições ou restaure o layout padrão.',
    dashboardAdminTitle: 'Dashboard administrativo',
    dashboardAdminSubtitle: 'Visão geral financeira e operacional',
    dashboardSupervisorTitle: 'Dashboard de supervisão',
    dashboardSupervisorSubtitle: 'Operação de campo e equipe',
    dashboardEmployeeTitle: 'Meu dia',
    dashboardEmployeeSubtitle: 'Marcações e serviços de hoje',
    dashboardClientTitle: 'Meus serviços',
    dashboardClientSubtitle: 'Próximos marcaçãos e histórico',
    dashboardSaveError: 'Não foi possível salvar as preferências dos widgets',
    dashboardWidgetTodayAppointments: 'Marcações de hoje',
    dashboardWidgetUpcoming: 'Próximos marcaçãos',
    dashboardWidgetCompletedToday: 'Completados hoje',
    dashboardWidgetRecent: 'Histórico de serviços',
    dashboardWidgetTotalServices: 'Total de serviços',
    dashboardNoAppointmentsToday: 'Nenhum marcação para hoje',
    dashboardNoUpcoming: 'Nenhum marcação futuro',
    dashboardNoRecentServices: 'Nenhum serviço completado ainda',
    quickActions: 'Ações Rápidas',
    welcomeMessage: 'Bem-vindo ao sistema de gestão de imóvels',
    revenue: 'Receita',
    
    // User Roles
    administrator: 'Administrador',
    supervisor: 'Supervisor',
    employee: 'Colaborador',
    clientRole: 'Cliente',
    
    // Search
    searchingFor: 'Buscando por',
    
    // Common Actions
    create: 'Criar',
    edit: 'Editar',
    delete: 'Eliminar',
    save: 'Guardar',
    success: 'Sucesso',
    error: 'Erro',
    confirm: 'Confirmar',
    registerProperty: 'Cadastrar Imóvel',
    editClient: 'Editar Cliente',
    deleteClient: 'Eliminar Cliente',
    
    // Password validation
    passwordsDoNotMatch: 'As senhas não coincidem',
    passwordTooShort: 'A senha deve ter pelo menos 8 caracteres',
    currentPassword: 'Senha Atual',
    newPassword: 'Nova Senha',
    confirmNewPassword: 'Confirmar Nova Senha',
    changePassword: 'Alterar Senha',
    changing: 'Alterando...',
    
    // Property Types
    house: 'Casa',
    apartment: 'Apartamento',
    condo: 'Condomínio',
    commercial: 'Comercial',
    
    // Common Fields
    name: 'Nome',
    phone: 'Telemóvel',
    document: 'Documento',
    address: 'Morada',
    type: 'Tipo',
    price: 'Preço',
    monthly: 'Mensal',
    actions: 'Ações',
    registration: 'Cadastro',
    
    // Users Management
    userManagement: 'Gerenciamento de Utilizadores',
    userSubtitle: 'Gira utilizadores e permissões do sistema',
    createNewUser: 'Criar Novo Usuário',
    editUser: 'Editar Usuário',
    filterByRole: 'Filtrar por Perfil',
    filterByStatus: 'Filtrar por Status',
    allRoles: 'Todos os perfis',
    allStatus: 'Todos os status',
    lastLogin: 'Último Login',
    never: 'Nunca',
    confirmDelete: 'Tem certeza que deseja excluir este usuário?',
    errorLoadingUsers: 'Erro ao carregar utilizadores. Verifique suas permissões.',
    errorCreatingUser: 'Erro ao criar usuário',
    errorUpdatingUser: 'Erro ao atualizar usuário',
    errorDeletingUser: 'Erro ao excluir usuário',
    errorUpdatingRole: 'Erro ao atualizar role',
    password: 'Senha',
    optional: 'Opcional',
    
    // Employees Management
    'employees.title': 'Gestão de Colaboradores',
    'employees.subtitle': 'Gira sua equipe',
    'employees.list': 'Lista de Colaboradores',
    'employees.new': 'Novo Colaborador',
    'employees.edit': 'Editar Colaborador',
    'employees.name': 'Nome',
    'employees.email': 'Correio eletrónico',
    'employees.phone': 'Telemóvel',
    'employees.document': 'Documento',
    'employees.noDocument': 'Sem documento',
    'employees.zone': 'Zona',
    'employees.hireDate': 'Data de Contratação',
    'employees.status': 'Status',
    'employees.active': 'Ativo',
    'employees.inactive': 'Inativo',
    'employees.notFound': 'Nenhum colaborador encontrado',
    'employees.loading': 'Carregando colaboradors...',
    'employees.filter.zone': 'Zona',
    'employees.filter.allZones': 'Todas as zonas',
    'employees.filter.status': 'Status',
    'employees.filter.allStatus': 'Todos',
    'employees.filter.active': 'Ativos',
    'employees.filter.inactive': 'Inativos',
    'employees.error.loading': 'Erro ao carregar colaboradors',
    'employees.ratings.highlightTitle': 'Destaques em avaliações',
    'employees.ratings.highlightSubtitle': 'Acompanhe quem está recebendo as melhores notas dos clientes.',
    'employees.ratings.total': 'avaliações',
    
    // Zones Management
    'zones.title': 'Gerenciamento de Zonas',
    'zones.subtitle': 'Gira as zonas geográficas de atuação',
    'zones.name': 'Nome',
    'zones.description': 'Descrição',
    'zones.center': 'Centro',
    'zones.centerLat': 'Latitude do Centro',
    'zones.centerLon': 'Longitude do Centro',
    'zones.radius': 'Raio (km)',
    'zones.radiusHelp': 'Deixe vazio para usar polígono (boundaries)',
    'zones.boundaries': 'Boundaries (JSON)',
    'zones.boundariesHelp': 'Formato GeoJSON para definir polígono da zona',
    'zones.create': 'Nova Zona',
    'zones.edit': 'Editar Zona',
    'zones.empty': 'Nenhuma zona cadastrada',
    'zones.success.created': 'Zona criada com sucesso!',
    'zones.success.updated': 'Zona atualizada com sucesso!',
    'zones.success.deleted': 'Zona desativada com sucesso!',
    'zones.error.loading': 'Erro ao carregar zonas',
    'zones.error.saving': 'Erro ao salvar zona',
    'zones.error.deleting': 'Erro ao deletar zona',
    'zones.confirm.delete': 'Tem certeza que deseja desativar a zona',
    'zones.mapView': 'Visualização no Mapa',
    'zones.showMap': 'Mostrar Mapa',
    'zones.hideMap': 'Ocultar Mapa',
    'zones.currentLocation.loading': 'Obtendo localização...',
    'zones.currentLocation.gps': 'GPS',
    'zones.currentLocation.ip': 'Aproximado (IP)',
    'zones.currentLocation.refresh': 'Atualizar localização',
    'zones.currentLocation.error': 'Localização indisponível',
    
    // Services Management
    'services.title': 'Gestão de Serviços',
    'services.subtitle': 'Gira os serviços de limpeza oferecidos',
    'services.list': 'Lista de Serviços',
    'services.new': 'Novo Serviço',
    'services.edit': 'Editar Serviço',
    'services.name': 'Nome do Serviço',
    'services.description': 'Descrição',
    'services.type': 'Tipo de Serviço',
    'services.duration': 'Duração (min)',
    'services.price': 'Preço Base',
    'services.rooms': 'Cômodos Incluídos',
    'services.includedRooms': 'Cômodos',
    'services.minutes': 'minutos',
    'services.notFound': 'Nenhum serviço encontrado',
    'services.loading': 'Carregando serviços...',
    'services.filter.type': 'Tipo de Serviço',
    'services.filter.allTypes': 'Todos os tipos',
    'services.filter.status': 'Status',
    'services.filter.allStatus': 'Todos',
    'services.filter.active': 'Ativos',
    'services.filter.inactive': 'Inativos',
    'services.error.loading': 'Erro ao carregar serviços',
    
    // Products Management
    'products.title': 'Gestão de Produtos',
    'products.subtitle': 'Controle de estoque de produtos de limpeza',
    'products.list': 'Lista de Produtos',
    'products.new': 'Novo Produto',
    'products.edit': 'Editar Produto',
    'products.name': 'Nome do Produto',
    'products.brand': 'Marca',
    'products.description': 'Descrição',
    'products.unit': 'Unidade',
    'products.quantity': 'Quantidade',
    'products.minStock': 'Estoque Mínimo',
    'products.costPrice': 'Preço de Custo',
    'products.category': 'Categoria',
    'products.notFound': 'Nenhum produto encontrado',
    'products.loading': 'Carregando produtos...',
    'products.filter.category': 'Categoria',
    'products.filter.allCategories': 'Todas as categorias',
    'products.filter.status': 'Status',
    'products.filter.allStatus': 'Todos',
    'products.filter.active': 'Ativos',
    'products.filter.inactive': 'Inativos',
    'products.error.loading': 'Erro ao carregar produtos',
    
    // Notification History
    'notifications.history.title': 'Histórico de Notificações',
    'notifications.history.unread': 'Não lidas:',
    'notifications.history.filterByType': 'Filtrar por tipo',
    'notifications.history.all': 'Todas',
    'notifications.history.info': 'Informativas',
    'notifications.history.success': 'Sucesso',
    'notifications.history.warning': 'Avisos',
    'notifications.history.error': 'Erros',
    'notifications.history.markAllRead': 'Marcar todas como lidas',
    'notifications.history.markAsRead': 'Marcar como lida',
    'notifications.history.delete': 'Eliminar',
    'notifications.history.loading': 'Carregando...',
    'notifications.history.none': 'Nenhuma notificação ainda',
    'notifications.history.loadMore': 'Carregar mais notificações',
    'notifications.history.error.loading': 'Erro ao carregar histórico',
    'notifications.history.error.markRead': 'Erro ao marcar como lida',
    'notifications.history.error.markAllRead': 'Erro ao marcar todas como lidas',
    'notifications.history.error.delete': 'Erro ao deletar',
    
    // Notification Settings
    'notifications.settings.title': 'Definições de Notificações',
    'notifications.settings.notSupported': 'Notificações Push não são suportadas',
    'notifications.settings.notSupportedDesc': 'Seu navegador não suporta Push Notifications. Por favor, use um navegador moderno como Chrome, Firefox ou Edge.',
    'notifications.settings.permissionStatus': 'Status da Permissão:',
    'notifications.settings.subscriptionStatus': 'Status da Subscription:',
    'notifications.settings.permission.granted': 'Concedida',
    'notifications.settings.permission.denied': 'Negada',
    'notifications.settings.permission.default': 'Não solicitada',
    'notifications.settings.subscription.active': 'Ativa',
    'notifications.settings.subscription.inactive': 'Inativa',
    'notifications.settings.activate': 'Ativar Notificações',
    'notifications.settings.activatePush': 'Ativar Push Notifications',
    'notifications.settings.sendTest': 'Enviar Notificação de Teste',
    'notifications.settings.deactivate': 'Desativar Notificações',
    'notifications.settings.permissionDenied': 'Permissão para notificações foi negada. Por favor, habilite nas definições do navegador.',
    'notifications.settings.error.requestPermission': 'Erro ao solicitar permissão',
    'notifications.settings.error.activate': 'Erro ao ativar notificações',
    'notifications.settings.error.deactivate': 'Erro ao desativar notificações',
    'notifications.settings.error.sendTest': 'Erro ao enviar notificação de teste',
    'notifications.settings.loading': 'Carregando...',
    'notifications.settings.connecting': 'Conectando...',
    'notifications.settings.sending': 'Enviando...',
    'notifications.settings.deactivating': 'Desativando...',
    
    // Special Instructions Modal
    'specialInstructions.title': 'Instruções Especiais',
    'specialInstructions.current': 'Instruções Atuais',
    'specialInstructions.history': 'Histórico',
    'specialInstructions.placeholder': 'Digite as instruções especiais para esta imóvel...',
    'specialInstructions.saving': 'A guardar...',
    'specialInstructions.deleting': 'Deletando...',
    'specialInstructions.edit': 'Editar Instruções',
    'specialInstructions.add': 'Adicionar Instruções',
    'specialInstructions.none': 'Nenhuma instrução especial cadastrada para esta imóvel.',
    'specialInstructions.noHistory': 'Nenhum histórico de alterações encontrado.',
    'specialInstructions.changedBy': 'Alterado por:',
    'specialInstructions.invalidId': 'ID da Imóvel Inválido',
    'specialInstructions.invalidIdDesc': 'Esta imóvel (ID: {id}) não possui um UUID válido e não pode usar a funcionalidade de instruções especiais.',
    'specialInstructions.invalidIdSolution': 'Solução: Crie uma nova imóvel usando o botão "+ Add Property" na página de Imóveis.',
    'specialInstructions.error.loading': 'Erro ao carregar instruções',
    'specialInstructions.error.saving': 'Erro ao salvar instruções',
    'specialInstructions.error.deleting': 'Erro ao deletar instruções',
    'specialInstructions.confirmDelete': 'Tem certeza que deseja deletar as instruções especiais desta imóvel?',
    
    // Animal Management Modal
    'animals.title': 'Animais - {propertyName}',
    'animals.subtitle': 'Gerir animais desta imóvel para alertas de segurança',
    'animals.total': 'Total de animais:',
    'animals.dangerous': 'perigoso(s)',
    'animals.add': 'Adicionar Animal',
    'animals.new': 'Novo Animal',
    'animals.edit': 'Editar Animal',
    'animals.none': 'Nenhum animal cadastrado nesta imóvel.',
    'animals.addFirst': 'Adicionar Primeiro Animal',
    'animals.name': 'Nome *',
    'animals.type': 'Tipo *',
    'animals.breed': 'Raça',
    'animals.behavior': 'Comportamento',
    'animals.size': 'Tamanho',
    'animals.notes': 'Observações',
    'animals.dangerousLabel': 'Animal perigoso (requer atenção especial)',
    'animals.dangerousTag': 'Perigoso',
    'animals.type.dog': 'Cão',
    'animals.type.cat': 'Gato',
    'animals.type.bird': 'Pássaro',
    'animals.type.other': 'Outro',
    'animals.behavior.friendly': 'Amigável',
    'animals.behavior.shy': 'Tímido',
    'animals.behavior.aggressive': 'Agressivo',
    'animals.behavior.unknown': 'Desconhecido',
    'animals.size.small': 'Pequeno',
    'animals.size.medium': 'Médio',
    'animals.size.large': 'Grande',
    'animals.size.select': 'Selecione...',
    'animals.label.type': 'Tipo:',
    'animals.label.breed': 'Raça:',
    'animals.label.behavior': 'Comportamento:',
    'animals.label.size': 'Tamanho:',
    'animals.label.notes': 'Observações:',
    'animals.error.loading': 'Erro ao carregar animais',
    'animals.error.saving': 'Erro ao salvar animal',
    'animals.error.deleting': 'Erro ao excluir animal',
    'animals.success.created': 'Animal criado com sucesso!',
    'animals.success.updated': 'Animal atualizado com sucesso!',
    'animals.success.deleted': 'Animal excluído com sucesso!',
    'animals.confirmDelete': 'Tem certeza que deseja excluir este animal?',
    
    // Check-in/Check-out
    'checkin.title': 'Check-in',
    'checkout.title': 'Check-out',
    'checkin.process': 'Fazer Check-in',
    'checkout.process': 'Fazer Check-out',
    'checkin.processing': 'Processando...',
    
    // SMTP Settings
    'smtp.success.saved': 'Configuração SMTP salva com sucesso',
    'smtp.success.testSent': 'Correio eletrónico de teste enviado com sucesso! Verifique sua caixa de entrada.',
    'smtp.error.saving': 'Erro ao salvar configuração SMTP',
    'smtp.error.testing': 'Erro ao testar configuração SMTP',
    'smtp.error.unknown': 'Erro desconhecido',
    'smtp.error.testEmail': 'Por favor, indique um correio eletrónico para teste',
    'smtp.save': 'Guardar Configuração',
    'smtp.sendTest': 'Enviar Teste',
    'smtp.saveNotificationSettings': 'Guardar Notification Settings',
    
    // Reports - Months
    'reports.month.jan': 'Jan',
    'reports.month.feb': 'Fev',
    'reports.month.mar': 'Mar',
    'reports.month.apr': 'Abr',
    'reports.month.may': 'Mai',
    'reports.month.jun': 'Jun',
    'reports.month.jul': 'Jul',
    'reports.month.aug': 'Ago',
    'reports.month.sep': 'Set',
    'reports.month.oct': 'Out',
    'reports.month.nov': 'Nov',
    'reports.month.dec': 'Dez',
    'reports.clientNotInformed': 'Cliente não informado',
    'reports.error.loadingProperties': 'Erro ao pesquisar properties para mapear clientes',
    'reports.error.loading': 'Erro ao carregar relatórios',
    'reports.error.generating': 'Erro ao gerar relatório',
    'reports.error.generatingPdf': 'Erro ao gerar relatório PDF',
    'reports.error.generatingDetails': 'Erro ao gerar relatório. Verifique o console para mais detalhes.',
    'reports.filters': 'Filtros',
    'reports.filterByZone': 'Zona',
    'reports.allZones': 'Todas as zonas',
    
    // Properties
    'properties.error.notReturned': 'Imóvel não retornada pela API',
    'properties.success.created': 'Imóvel criada com sucesso!',
    'properties.success.updated': 'Imóvel atualizada com sucesso!',
    'properties.error.creating': 'Erro ao criar imóvel',
    'properties.error.updating': 'Erro ao atualizar imóvel',
    'properties.error.deleting': 'Erro ao deletar imóvel',
    'properties.error.loading': 'Erro ao carregar imóvels',
    'properties.error.cep': 'Erro ao pesquisar Código postal/ZIP Code',
    'properties.confirmDelete': 'Tem certeza que deseja deletar esta imóvel?',
    'properties.clientNotFound': 'Client not found? Click "New Client" to register',
    'properties.searchingCep': 'Buscando Código postal...',
    'properties.searchingZip': 'Searching ZIP Code...',
    'properties.updating': 'Atualizando...',
    'properties.creating': 'Criando...',
    'properties.update': 'Atualizar',
    'properties.create': 'Criar Imóvel',
    'properties.phone': 'Telemóvel',
    'properties.documentId': 'Documento',
    'properties.enterDocumentId': 'Digite o documento',
    'properties.type.residential': 'Residencial',
    'properties.type.commercial': 'Comercial',
    'properties.type.other': 'Outro',
    
    // Appointments
    'appointments.error.selectClient': 'Por favor, selecione um cliente',
    'appointments.error.selectProperty': 'Por favor, selecione uma imóvel',
    'appointments.error.selectValidProperty': 'Por favor, selecione uma imóvel válida',
    'appointments.error.selectEmployee': 'Por favor, selecione um colaborador',
    'appointments.error.creating': 'Erro ao criar marcação',
    'appointments.error.updating': 'Erro ao atualizar marcação',
    'appointments.error.cancelling': 'Erro ao cancelar marcação',
    'appointments.error.dateNotInformed': 'Data não informada',
    'appointments.error.invalidDate': 'Data inválida',
    'appointments.error.formattingDate': 'Erro ao formatar data',
    'appointments.edit': 'Editar Marcação',
    'appointments.searchClientPlaceholder': 'Digite pelo menos 3 letras para pesquisar cliente...',
    'appointments.selectPropertyPlaceholder': 'Selecione uma imóvel...',
    'appointments.searchPropertyPlaceholder': 'Digite para pesquisar ou selecione do dropdown acima',
    'appointments.searchPropertyPlaceholderAlt': 'Selecione um cliente primeiro ou digite para pesquisar...',
    'appointments.selectClientFirst': 'Selecione um cliente primeiro',
    'appointments.employee': 'Colaborador',
    'appointments.searchEmployeePlaceholder': 'Digite para pesquisar ou clique para ver todos...',
    'appointments.noName': 'Sem nome',
    'appointments.time': 'Hora',
    
    // Financial
    'financial.error.loadingPayments': 'Erro ao carregar pagamentos',
    'financial.error.loadingClients': 'Erro ao carregar clientes',
    'financial.error.loadingAllocations': 'Erro ao carregar alocações',
    'financial.error.loadingCosts': 'Erro ao carregar custos',
    'financial.error.loadingBalance': 'Erro ao carregar saldo',
    'financial.success.paymentCreated': 'Pagamento registrado com sucesso!',
    'financial.success.paymentUpdated': 'Pagamento atualizado!',
    'financial.success.paymentDeleted': 'Pagamento excluído!',
    'financial.success.allocationCreated': 'Alocação criada com sucesso!',
    'financial.success.statusUpdated': 'Status atualizado!',
    'financial.success.thirdPartyCreated': 'Terceirizado criado com sucesso! O campo foi atualizado automaticamente.',
    'financial.success.thirdPartyCreatedPartial': 'Terceirizado criado, mas houve problema ao atualizar a lista. Tente recarregar a página.',
    'financial.success.costCreated': 'Custo registrado!',
    'financial.error.creatingPayment': 'Erro ao criar pagamento',
    'financial.error.updatingPayment': 'Erro ao atualizar pagamento',
    'financial.error.deletingPayment': 'Erro ao excluir pagamento',
    'financial.error.creatingAllocation': 'Erro ao criar alocação',
    'financial.error.updatingStatus': 'Erro ao atualizar status',
    'financial.error.creatingThirdParty': 'Erro ao criar terceirizado',
    'financial.error.creatingCost': 'Erro ao criar custo',
    'financial.error.deletingCost': 'Erro ao excluir custo',
    'financial.confirmDeletePayment': 'Tem certeza que deseja excluir este pagamento?',
    'financial.confirmDeleteCost': 'Eliminar este custo?',
    'financial.status.paid': 'Pago',
    'financial.status.pending': 'Pendente',
    'financial.status.cancelled': 'Cancelado',
    
    // Autocomplete
    'autocomplete.placeholder': 'Digite para pesquisar...',
    'autocomplete.error.searching': 'Erro ao pesquisar',
    'autocomplete.error.loading': 'Erro ao carregar opções iniciais',
    'autocomplete.minChars': 'Digite pelo menos {minChars} caracteres para pesquisar',
    'autocomplete.createNew': 'Criar novo: "{value}"',
    
    // Chat Modal
    'chat.title': 'Chat em Tempo Real',
    'chat.subtitle': 'Comunicação entre cliente e colaborador vinculados ao marcação',
    'chat.filter': 'Filtrar por cliente ou imóvel',
    'chat.property': 'Imóvel',
    'chat.client': 'Cliente:',
    'chat.employee': 'Colaborador:',
    'chat.messagePlaceholder': 'Digite uma mensagem',
    'chat.sending': 'Enviando...',
    'chat.send': 'Enviar',
    'chat.loadingThreads': 'Carregando conversas...',
    'chat.noThreads': 'Nenhuma conversa disponível',
    'chat.loadingMessages': 'Carregando mensagens...',
    'chat.noMessages': 'Nenhuma mensagem ainda',
    'chat.selectThread': 'Selecione uma conversa para começar',
    'chat.helpRequest': 'Pedido de Ajuda · Prioridade',
    
    // Quick Create Modals
    'quickCreate.property.title': 'Cadastrar Nova Imóvel',
    'quickCreate.property.client': 'Cliente:',
    'quickCreate.property.name': 'Nome da Imóvel',
    'quickCreate.property.address': 'Morada',
    'quickCreate.property.zipCode': 'Código postal / ZIP Code',
    'quickCreate.property.type': 'Tipo',
    'quickCreate.property.city': 'Cidade',
    'quickCreate.property.state': 'Estado (UF)',
    'quickCreate.property.price': 'Preço Mensal (€)',
    'quickCreate.property.required': '(obrigatório)',
    'quickCreate.property.searchingCep': '🔍 Buscando...',
    'quickCreate.property.cepInstructions': 'Digite o Código postal (8 dígitos) ou ZIP Code (5 dígitos) para preencher automaticamente',
    'quickCreate.property.cepNotFound': 'Código postal/ZIP Code não encontrado',
    'quickCreate.property.clientNotSelected': 'Cliente não selecionado. Por favor, selecione um cliente primeiro.',
    'quickCreate.property.invalidResponse': 'Resposta inválida da API - imóvel não retornada',
    'quickCreate.property.error': 'Erro ao criar imóvel',
    'quickCreate.property.error.endpoint': 'Endpoint não encontrado. Verifique se o serviço está rodando.',
    'quickCreate.property.error.invalidData': 'Dados inválidos. Verifique os campos obrigatórios.',
    'quickCreate.property.error.server': 'Erro interno do servidor. Tente novamente.',
    'quickCreate.property.error.connection': 'Erro de conexão. Verifique sua conexão com a internet.',
    'quickCreate.property.exampleName': 'Ex: Casa da Praia',
    'quickCreate.property.exampleAddress': 'Rua, número, bairro...',
    'quickCreate.property.autoFill': 'Será preenchido automaticamente pelo Código postal',
    'quickCreate.property.examplePrice': 'Ex: 250.00',
    'quickCreate.property.registering': 'Cadastrando...',
    'quickCreate.property.register': 'Cadastrar Imóvel',
    'quickCreate.employee.error': 'Erro ao criar colaborador',
    'quickCreate.employee.exampleZone': 'Ex: Zona Norte',
    'quickCreate.employee.registering': 'Cadastrando...',
    'quickCreate.employee.register': 'Cadastrar Colaborador',
    'quickCreate.client.error': 'Erro ao criar cliente',
    'quickCreate.client.registering': 'Cadastrando...',
    'quickCreate.client.register': 'Cadastrar Cliente',
    
    // Complete Service Modal
    'completeService.error.positiveTime': 'Tempo real deve ser um número positivo',
    'completeService.error.invalidEndTime': 'Data/hora de término inválida',
    'completeService.error': 'Erro ao finalizar serviço',
    'completeService.error.invalidData': 'Dados inválidos. Verifique os campos preenchidos.',
    'completeService.error.notFound': 'Marcação não encontrado. Por favor, recarregue a página.',
    'completeService.error.server': 'Erro interno do servidor. Tente novamente.',
    'completeService.error.connection': 'Erro de conexão. Verifique sua conexão com a internet.',
    'completeService.notesPlaceholder': 'Observações sobre a finalização do serviço...',
    'completeService.completing': 'Finalizando...',
    'completeService.complete': 'Finalizar Serviço',
    
    // Dashboard
    'dashboard.noAppointments': 'Nenhum marcação ainda',
    'dashboard.employees': 'Colaboradores',
    'dashboard.services': 'Serviços',
    'dashboard.products': 'Produtos',
    
    // Common error messages
    'errors.loading': 'Erro ao carregar',
    'errors.saving': 'Erro ao salvar',
    'errors.creating': 'Erro ao criar',
    'errors.updating': 'Erro ao atualizar',
    'errors.deleting': 'Erro ao deletar',
    'errors.searching': 'Erro ao pesquisar',
    'errors.testing': 'Erro ao testar',
    'errors.unknown': 'Erro desconhecido',
    
    // Common success messages
    'success.created': 'criado com sucesso!',
    'success.updated': 'atualizado com sucesso!',
    'success.deleted': 'deletado com sucesso!',
    'success.saved': 'salvo com sucesso!',
    
    // Common confirmations
    'confirm.delete': 'Tem certeza que deseja deletar isto?',
    'confirm.cancel': 'Tem certeza que deseja cancelar isto?',
    'confirm.action': 'Tem certeza que deseja fazer isto?',
    
    // Common placeholders
    'placeholders.typeToSearch': 'Digite para pesquisar...',
    'placeholders.select': 'Selecione...',
    'placeholders.pleaseSelect': 'Por favor, selecione...',
    'placeholders.pleaseInform': 'Por favor, informe...',
    
    // Common actions
    'actions.save': 'Guardar',
    'actions.cancel': 'Cancelar',
    'actions.confirm': 'Confirmar',
    'actions.delete': 'Eliminar',
    'actions.edit': 'Editar',
    'actions.create': 'Criar',
    'actions.update': 'Atualizar',
    'actions.add': 'Adicionar',
    'actions.remove': 'Remover',
    
    // Ratings
    'ratings.history.title': 'Histórico de Avaliações',
    'ratings.history.subtitle': 'Visualize todas as avaliações recebidas',
    'ratings.history.empty': 'Nenhuma avaliação encontrada',
    'ratings.search.placeholder': 'Pesquisar por cliente, imóvel ou comentário...',
    'ratings.filter.all': 'Todos os Status',
    'ratings.filter.approved': 'Aprovadas',
    'ratings.filter.pending': 'Pendentes',
    'ratings.filter.submitted': 'Enviadas',
    'ratings.stats.average': 'Avaliação Média',
    'ratings.stats.total': 'Total de Avaliações',
    'ratings.stats.fiveStar': '5 Estrelas',

    // PWA
    'pwa.install.title': 'Instalar House Keep',
    'pwa.install.description': 'Adicione o app à tela inicial para acesso rápido.',
    'pwa.install.action': 'Instalar',
    'pwa.install.dismiss': 'Agora não',
    'pwa.install.ios_hint': 'Toque em Compartilhar e depois em "Adicionar à Tela de Início".',
    'pwa.update.title': 'Nova versão disponível',
    'pwa.update.action': 'Atualizar agora',
    'pwa.offline.message': 'Si está offline',
    'common.loading': 'Carregando...',
    'common.loadingChart': 'Carregando gráfico...',
    'common.loadingData': 'Carregando dados...',
    'common.sortBy': 'Ordenar por:',
    'common.month': 'Mês',
    'common.quantity': 'Quantidade',
    'common.position': 'Posição',
    'common.difference': 'Diferença',
    'common.yourResponse': 'Sua Resposta:',
    'common.punctuality': 'Pontualidade',
    'common.quality': 'Qualidade',
    'common.communication': 'Comunicação',
    'billing.title': 'Faturação SaaS',
    'billing.subtitle': 'Planos de cobrança e faturas da plataforma',
    'billing.tabs.plans': 'Planos',
    'billing.tabs.invoices': 'Faturas',
    'billing.tabs.aria': 'Seções de faturação',
    'reports.monthlyRevenue': 'Receita Mensal',
    'reports.monthlyRevenueCol': 'Receita (€)',
    'reports.serviceTypes': 'Tipos de Serviço',
    'reports.topClients': 'Top Clientes',
    'reports.type': 'Tipo',
    'reports.client': 'Cliente',
    'reports.services': 'Serviços',
    'reports.generatedBy': 'Relatório gerado pelo Sistema Agenda House Keep',
    'reports.moreInfo': 'Para mais informações, acesse o sistema em {url}',
    'reports.timeDiscrepancies': 'Discrepâncias de Tempo',
    'reports.timeDiscrepanciesFull': 'Discrepâncias de Tempo (Esperado vs Real)',
    'reports.noClients': 'Nenhum cliente encontrado.',
    'reports.addClientsHint': 'Adicione clientes no sistema para visualizar os relatórios.',
    'reports.noDiscrepancies': 'Nenhuma discrepância encontrada.',
    'reports.allOnTime': 'Todos os serviços completados estão dentro do tempo estimado.',
    'reports.noAppointmentsDay': 'Sem marcaçãos neste dia',
    'reports.loadingRatings': 'Carregando avaliações...',
    'permissions.legend': 'Legenda - Permissões CRUD:',
    'permissions.createDesc': 'Criar: Permite criar novos registos do recurso',
    'permissions.readDesc': 'Ler: Permite visualizar registos do recurso',
    'permissions.updateDesc': 'Atualizar: Permite modificar registos existentes',
    'permissions.deleteDesc': 'Eliminar: Permite remover registos do recurso',
    'permissions.tipTitle': 'Dica:',
    'permissions.tipText': 'As permissões CRUD controlam quais ações cada perfil pode realizar nas páginas. Mesmo com acesso ao menu (separador anterior), só poderá executar as ações permitidas aqui.',
    'language.en': 'English',
    'language.es': 'Español',
    'language.ptBR': 'Português (Brasil)',
    'language.ptPT': 'Português (Portugal)',

    // Phase 4 — common UI strings
    'common.name': 'Nome',
    'common.description': 'Descrição',
    'common.status': 'Estado',
    'common.email': 'Correio eletrónico',
    'common.phone': 'Telemóvel',
    'common.client': 'Cliente',
    'common.employee': 'Colaborador',
    'common.optional': '(opcional)',
    'common.requiredMark': '(obrigatório)',
    'common.all': 'Todos',
    'common.filters': 'Filtros',
    'common.action': 'Ação',
    'common.resource': 'Recurso',
    'common.clear': 'Limpar',
    'common.clearSelection': 'Limpar seleção',
    'common.tryAgain': 'Tentar novamente',
    'common.backToLogin': 'Voltar ao início de sessão',
    'common.notes': 'Observações',
    'common.value': 'Valor',
    'common.loadingClients': 'A carregar clientes...',
    'common.noData': 'Nenhum dado encontrado',
    'common.select': 'Selecione...',
    'common.dateNotInformed': 'Data não informada',
    'common.thirdParty': 'Subcontratado',
    'common.actions': 'Ações',
    'common.remove': 'Remover',
    'common.add': 'Adicionar',
    'common.update': 'Atualizar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.save': 'Guardar',
    'common.close': 'Fechar',
    'common.search': 'Pesquisar',
    'common.yes': 'Sim',
    'common.no': 'Não',
    'common.resourceLimits': 'Limites de Recursos',
    'common.keepCurrent': 'Manter atual',
    'common.keepSeries': 'Manter da série',
    'common.dateFormatHint': 'DD/MM/AAAA',
    'validation.fixFormErrors': 'Por favor, corrija os erros no formulário',
    'validation.requiredCustomFields': 'Preencha todos os campos personalizados obrigatórios.',
    'validation.priceRequired': 'O preço é obrigatório e deve ser superior a zero',
    'login.appName': 'Agenda House Keep',
    'login.tagline': 'Sistema de Gestão de Limpeza',
    'login.title': 'Iniciar sessão',
    'login.subtitle': 'Aceda à sua conta para continuar',
    'login.emailLabel': 'Correio eletrónico',
    'login.passwordLabel': 'Palavra-passe',
    'login.emailPlaceholder': 'seu@email.com',
    'login.emailRequired': 'O correio eletrónico é obrigatório',
    'login.passwordRequired': 'A palavra-passe é obrigatória',
    'login.invalidCredentials': 'Correio eletrónico ou palavra-passe incorretos',
    'login.connectionError': 'Erro de ligação. Verifique se os serviços estão a correr.',
    'login.twoFactorTitle': 'Autenticação de dois fatores',
    'login.twoFactorSubtitle': 'Introduza o código de 6 dígitos da sua aplicação autenticadora',
    'login.twoFactorCodeRequired': 'Introduza o código de 6 dígitos',
    'login.twoFactorInvalid': 'Código inválido. Tente novamente.',
    'login.twoFactorVerifyError': 'Erro ao verificar código. Tente novamente.',
    'login.submit': 'Entrar',
    'login.submitting': 'A entrar...',
    'login.verify': 'Verificar',
    'login.verifying': 'A verificar...',
    'login.forgotPassword': 'Esqueceu a palavra-passe?',
    'login.noAccount': 'Não tem uma conta?',
    'login.register': 'Registe-se',
    'forgotPassword.title': 'Esqueci a palavra-passe',
    'forgotPassword.subtitle': 'Indique o seu correio eletrónico para receber instruções de redefinição',
    'forgotPassword.submit': 'Enviar link de redefinição',
    'forgotPassword.backToLogin': 'Voltar ao início de sessão',
    'resetPassword.title': 'Redefinir palavra-passe',
    'resetPassword.submit': 'Redefinir palavra-passe',
    'financial.thirdPartyNone': 'Nenhum subcontratado registado',
    'financial.thirdPartyHint': 'Gira os subcontratados na página de Colaboradores. Marque "Subcontratado" ao criar ou editar um colaborador.',
    'financial.newAllocation': 'Nova Atribuição',
    'financial.fixedAmount': 'Valor Fixo',
    'financial.percentage': 'Percentagem',
    'financial.costs': 'Custos',
    'financial.newCost': 'Novo Custo',
    'financial.status.pending': 'Pendente',
    'financial.status.paid': 'Pago',
    'financial.status.cancelled': 'Cancelado',
    'billing.loadingInvoices': 'A carregar faturas...',
    'billing.allStatuses': 'Todos os estados',
    'billing.retryLoad': 'Tentar novamente',
    'billing.generateFromPlan': 'Gerar a partir do plano ativo',
    'billing.noInvoices': 'Nenhuma fatura encontrada',
    'billing.paymentMethodPrompt': 'Método de pagamento:',
    'billing.paymentError': 'Erro ao processar pagamento',
    'dashboard.completedToday': 'Serviços concluídos hoje',
    'dashboard.completedThisMonth': 'Serviços concluídos no mês',
    'dashboard.completionRate': 'Taxa de Conclusão',
    'dashboard.noAppointmentsYet': 'Nenhuma marcação ainda',
    'dashboard.monthlyRevenueSubtitle': 'Receita dos serviços concluídos',
    'dashboard.servicesOverTime': '{count} serviços excederam o tempo',
    'dashboard.servicesSlower': '⚠️ {count} serviços demoraram mais do que o estimado',
    'dashboard.servicesFaster': '✅ {count} serviços foram mais rápidos',
    'dashboard.noDiscrepancy': 'Nenhuma discrepância encontrada',
    'dashboard.avgDifference': 'Diferença média: {value} min',
    'dashboard.appointmentsOfDay': 'Marcações de {date}',
    'appointments.clearSelection': 'Limpar seleção',
    'appointments.dateNotInformed': 'Data não informada',
    'rbac.legend': 'Legenda',
    'rbac.colorLegend': 'Legenda de Cores',
    'support.title': 'Suporte',
    'support.newTicket': 'Novo ticket',
    'support.refresh': 'Atualizar',
    'support.noTickets': 'Nenhum ticket encontrado',
    'support.loading': 'A carregar tickets...',
    'zones.fillNameAndCoords': 'Por favor, preencha pelo menos o nome e as coordenadas do centro da zona',
    'menuPermissions.saved': 'Permissões guardadas com sucesso!',
    'menuPermissions.saveError': 'Erro ao guardar permissões',

    // Phase 4 — common UI strings
    'common.name': 'Nome',
    'common.description': 'Descrição',
    'common.status': 'Estado',
    'common.email': 'Correio eletrónico',
    'common.phone': 'Telemóvel',
    'common.client': 'Cliente',
    'common.employee': 'Colaborador',
    'common.optional': '(opcional)',
    'common.requiredMark': '(obrigatório)',
    'common.all': 'Todos',
    'common.filters': 'Filtros',
    'common.action': 'Ação',
    'common.resource': 'Recurso',
    'common.clear': 'Limpar',
    'common.clearSelection': 'Limpar seleção',
    'common.tryAgain': 'Tentar novamente',
    'common.backToLogin': 'Voltar ao início de sessão',
    'common.notes': 'Observações',
    'common.value': 'Valor',
    'common.loadingClients': 'A carregar clientes...',
    'common.noData': 'Nenhum dado encontrado',
    'common.select': 'Selecione...',
    'common.dateNotInformed': 'Data não informada',
    'common.thirdParty': 'Subcontratado',
    'common.actions': 'Ações',
    'common.remove': 'Remover',
    'common.add': 'Adicionar',
    'common.update': 'Atualizar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.save': 'Guardar',
    'common.close': 'Fechar',
    'common.search': 'Pesquisar',
    'common.yes': 'Sim',
    'common.no': 'Não',
    'common.resourceLimits': 'Limites de Recursos',
    'common.keepCurrent': 'Manter atual',
    'common.keepSeries': 'Manter da série',
    'common.dateFormatHint': 'DD/MM/AAAA',
    'validation.fixFormErrors': 'Por favor, corrija os erros no formulário',
    'validation.requiredCustomFields': 'Preencha todos os campos personalizados obrigatórios.',
    'validation.priceRequired': 'O preço é obrigatório e deve ser superior a zero',
    'login.appName': 'Agenda House Keep',
    'login.tagline': 'Sistema de Gestão de Limpeza',
    'login.title': 'Iniciar sessão',
    'login.subtitle': 'Aceda à sua conta para continuar',
    'login.emailLabel': 'Correio eletrónico',
    'login.passwordLabel': 'Palavra-passe',
    'login.emailPlaceholder': 'seu@email.com',
    'login.emailRequired': 'O correio eletrónico é obrigatório',
    'login.passwordRequired': 'A palavra-passe é obrigatória',
    'login.invalidCredentials': 'Correio eletrónico ou palavra-passe incorretos',
    'login.connectionError': 'Erro de ligação. Verifique se os serviços estão a correr.',
    'login.twoFactorTitle': 'Autenticação de dois fatores',
    'login.twoFactorSubtitle': 'Introduza o código de 6 dígitos da sua aplicação autenticadora',
    'login.twoFactorCodeRequired': 'Introduza o código de 6 dígitos',
    'login.twoFactorInvalid': 'Código inválido. Tente novamente.',
    'login.twoFactorVerifyError': 'Erro ao verificar código. Tente novamente.',
    'login.submit': 'Entrar',
    'login.submitting': 'A entrar...',
    'login.verify': 'Verificar',
    'login.verifying': 'A verificar...',
    'login.forgotPassword': 'Esqueceu a palavra-passe?',
    'login.noAccount': 'Não tem uma conta?',
    'login.register': 'Registe-se',
    'forgotPassword.title': 'Esqueci a palavra-passe',
    'forgotPassword.subtitle': 'Indique o seu correio eletrónico para receber instruções de redefinição',
    'forgotPassword.submit': 'Enviar link de redefinição',
    'forgotPassword.backToLogin': 'Voltar ao início de sessão',
    'resetPassword.title': 'Redefinir palavra-passe',
    'resetPassword.submit': 'Redefinir palavra-passe',
    'financial.thirdPartyNone': 'Nenhum subcontratado registado',
    'financial.thirdPartyHint': 'Gira os subcontratados na página de Colaboradores. Marque "Subcontratado" ao criar ou editar um colaborador.',
    'financial.newAllocation': 'Nova Atribuição',
    'financial.fixedAmount': 'Valor Fixo',
    'financial.percentage': 'Percentagem',
    'financial.costs': 'Custos',
    'financial.newCost': 'Novo Custo',
    'financial.status.pending': 'Pendente',
    'financial.status.paid': 'Pago',
    'financial.status.cancelled': 'Cancelado',
    'billing.loadingInvoices': 'A carregar faturas...',
    'billing.allStatuses': 'Todos os estados',
    'billing.retryLoad': 'Tentar novamente',
    'billing.generateFromPlan': 'Gerar a partir do plano ativo',
    'billing.noInvoices': 'Nenhuma fatura encontrada',
    'billing.paymentMethodPrompt': 'Método de pagamento:',
    'billing.paymentError': 'Erro ao processar pagamento',
    'dashboard.completedToday': 'Serviços concluídos hoje',
    'dashboard.completedThisMonth': 'Serviços concluídos no mês',
    'dashboard.completionRate': 'Taxa de Conclusão',
    'dashboard.noAppointmentsYet': 'Nenhuma marcação ainda',
    'dashboard.monthlyRevenueSubtitle': 'Receita dos serviços concluídos',
    'dashboard.servicesOverTime': '{count} serviços excederam o tempo',
    'dashboard.servicesSlower': '⚠️ {count} serviços demoraram mais do que o estimado',
    'dashboard.servicesFaster': '✅ {count} serviços foram mais rápidos',
    'dashboard.noDiscrepancy': 'Nenhuma discrepância encontrada',
    'dashboard.avgDifference': 'Diferença média: {value} min',
    'dashboard.appointmentsOfDay': 'Marcações de {date}',
    'appointments.clearSelection': 'Limpar seleção',
    'appointments.dateNotInformed': 'Data não informada',
    'rbac.legend': 'Legenda',
    'rbac.colorLegend': 'Legenda de Cores',
    'support.title': 'Suporte',
    'support.newTicket': 'Novo ticket',
    'support.refresh': 'Atualizar',
    'support.noTickets': 'Nenhum ticket encontrado',
    'support.loading': 'A carregar tickets...',
    'zones.fillNameAndCoords': 'Por favor, preencha pelo menos o nome e as coordenadas do centro da zona',
    'menuPermissions.saved': 'Permissões guardadas com sucesso!',
    'menuPermissions.saveError': 'Erro ao guardar permissões',
    'recurrence.createTitle': 'Criar Marcação Recorrente',
    'recurrence.validateConflicts': 'Validar Conflitos',
    'recurrence.creating': 'A criar...',
    'recurrence.createSeries': 'Criar Série',
    'recurrence.noConflicts': 'Não há conflitos! Pode criar a série.',
    'recurrence.successCreated': 'Série recorrente criada com sucesso!',
    'recurrence.errorCreating': 'Erro ao criar série recorrente',
    'workload.loading': 'A carregar carga de trabalho...',
    'workload.errorLoading': 'Erro ao carregar carga de trabalho',
    'forgotPassword.sendLink': 'Enviar Link de Recuperação',
    'forgotPassword.success': 'Se o correio eletrónico existir, foi enviado um link de recuperação.',
    'forgotPassword.error': 'Erro ao processar pedido.',
    'setup2fa.required': 'Configuração Obrigatória',
    'support.noTicketsYet': 'Nenhum pedido ainda.',
    'calendar.appointmentsTitle': 'Calendário de Marcações',
    'zone.myLocation': 'A minha localização',
    'checkpoint.none': 'Nenhum checkpoint encontrado',
    'twoFactor.title': 'Autenticação de Dois Fatores',
    'employeeSelector.loading': 'A carregar colaboradores...',
    'quickCreate.employee.title': 'Registar Novo Colaborador',
    'preferences.loading': 'A carregar preferências...',
    'smtp.settingsTitle': 'Definições SMTP',
    'financial.subtitle': 'Controlo de pagamentos, custos e distribuição para subcontratados',
    'companySwitcher.loading': 'A carregar empresas...',
    'completeService.cancel': 'Cancelar',

    'setup2fa.subtitle': 'Para a sua segurança, é necessário configurar a autenticação de dois fatores (2FA) antes de continuar.',
    'companySwitcher.notFound': 'Nenhuma empresa encontrada',
    'companySwitcher.noneAvailable': 'Nenhuma empresa disponível',
    // Phase 4 final
    'audit.title': 'Log de Auditoria',
    'audit.subtitle': 'Histórico completo de todas as ações realizadas no sistema',
    'audit.applyFilters': 'Aplicar Filtros',
    'audit.noLogs': 'Nenhum log encontrado',
    'audit.errorLoading': 'Erro ao carregar logs de auditoria',
    'audit.errorExport': 'Erro ao exportar logs',
    'audit.next': 'Próximo',
    'audit.previous': 'Anterior',
    'checkpoint.title': 'Histórico de Checkpoints',
    'checkpoint.loading': 'A carregar histórico...',
    'checkpoint.errorLoading': 'Erro ao carregar histórico de checkpoints',
    'checkpoint.stats': 'Estatísticas',
    'checkpoint.avgPerService': 'Média por Serviço',
    'checkpoint.duration': 'Duração:',
    'rating.title': 'Avaliar Serviço',
    'rating.overall': 'Avaliação Geral *',
    'rating.anonymous': 'Avaliação anônima',
    'rating.success': 'Avaliação enviada com sucesso!',
    'rating.detailedOptional': 'Avaliações Detalhadas (Opcional)',
    'rating.commentOptional': 'Comentário (Opcional)',
    'rating.commentPlaceholder': 'Compartilhe sua experiência com este serviço...',
    'rating.submit': 'Enviar Avaliação',
    'recurrence.editTitle': 'Editar Marcação Recorrente',
    'recurrence.cancelOccurrence': 'Cancelar apenas esta ocorrência',
    'recurrence.cancelSeries': 'Cancelar toda a série (todas as ocorrências futuras)',
    'recurrence.newEndDate': 'Nova data de término',
    'recurrence.newDuration': 'Nova duração (minutos)',
    'recurrence.newInstructions': 'Novas instruções especiais',
    'recurrence.startDate': 'Data de início *',
    'recurrence.dayOfMonth': 'Dia do mês *',
    'recurrence.frequency': 'Frequência',
    'recurrence.frequencyRequired': 'Frequência *',
    'recurrence.durationRequired': 'Duração (minutos) *',
    'recurrence.daily': 'Diário (todos os dias)',
    'recurrence.monthly': 'Mensal (todo mês)',
    'company.search': 'Pesquisar empresa',
    'company.searchPlaceholder': 'Pesquisar empresa...',
    'company.switchTitle': 'Trocar Empresa',
    'company.switchHint': 'Selecione a empresa para trocar o contexto',
    'company.notFound': 'Nenhuma empresa encontrada',
    'company.noneAvailable': 'Nenhuma empresa disponível',
    'completeService.title': 'Finalizar Serviço',
    'completeService.endTime': 'Hora de Término',
    'completeService.autoCalcHint': 'Se não informado, será calculado automaticamente',
    'dashboard.welcome': 'Bem-vindo ao sistema de gestão de limpeza',
    'dashboard.noClients': 'Nenhum cliente registado',
    'dashboard.newClient': 'Novo Cliente',
    'employeeDashboard.loading': 'A carregar dashboard...',
    'employeeDashboard.error': 'Erro ao carregar dashboard',
    'employeeDashboard.completed': 'Concluídos',
    'employeeDashboard.thisMonth': 'Este Mês',
    'employeeDashboard.noUpcoming': 'Nenhum marcação próximo',
    'employeeDashboard.noData': 'Nenhum dado disponível',
    'employeeDashboard.avgRating': 'Avaliação média:',
    'employeeSelector.available': 'Disponível',
    'employeeSelector.unavailable': 'Indisponível',
    'employeeSelector.noneAvailable': 'Nenhum colaborador disponível',
    'employeeSelector.invalidZone': 'Zona inválida',
    'employeeSelector.validZone': 'Zona válida',
    'workload.title': 'Carga de Trabalho dos Colaboradors',
    'workload.avgLoad': 'Média carga (20-40h)',
    'workload.totalAppointments': 'Total de marcaçãos:',
    'workload.totalEmployees': 'Total de colaboradors:',
    'login.back': 'Voltar',
    'login.forgotPasswordLink': 'Esqueci minha senha',
    'login.twoFactorVerification': 'Verificação em Duas Etapas',
    'login.verificationCode': 'Código de Verificação',
    'login.twoFactorAppHint': 'Introduza o código de 6 dígitos do seu aplicativo autenticador',
    'login.contactAdmin': 'Entre em contato com o administrador para criar uma conta',
    'login.privacyPolicy': 'Política de Privacidade',
    'forgotPassword.titleFull': 'Recuperar Senha',
    'forgotPassword.subtitleFull': 'Introduza seu correio eletrónico para receber um link de recuperação',
    'quickCreate.client.title': 'Registar Novo Cliente',
    'zone.drawStart': 'Começar a Desenhar',
    'zone.redraw': 'Redesenhar',
    'zone.removeLast': 'Remover Último',
    'zone.minPoints': 'É necessário pelo menos 3 pontos para formar um polígono',
    'zone.centerOnMe': 'Centralizar na minha localização',
    'zone.yourLocation': 'Sua localização',
    'limits.loading': 'A carregar limites...',
    'limits.configure': 'Configurar Limites',
    'limits.usageStats': 'Estatísticas de Uso',
    'limits.maxClients': 'Máximo de Clientes',
    'limits.maxEmployees': 'Máximo de Colaboradors',
    'limits.maxUsers': 'Máximo de Usuários',
    'limits.errorLoading': 'Não foi possível carregar limites.',
    'limits.disabledHint': 'Quando desativado, os limites não serão aplicados',
    'billing.invoiceDetails': 'Detalhes da Fatura',
    'billing.clearFilter': 'Limpar filtro',
    'billing.number': 'Número:',
    'plans.loading': 'A carregar planos...',
    'plans.billingCycle': 'Ciclo de Cobrança',
    'plans.errorDeactivate': 'Erro ao desativar plano',
    'plans.errorSave': 'Erro ao salvar plano',
    'plans.history': 'Histórico de Planos',
    'plans.noneRegistered': 'Nenhum plano registado. Clique em',
    'plans.name': 'Nome do Plano',
    'plans.new': 'Novo Plano',
    'customization.adminOnly': 'Apenas administradores podem gerenciar customizações por empresa.',
    'customization.subtitle': 'Configure experiência única para cada cliente corporativo.',
    'customization.title': 'Customização por empresa',
    'customization.selectCompany': 'Selecione uma empresa para personalizar funcionalidades.',
    'customization.branding.subtitle': 'Personalize logotipo, cores e CSS personalizado da empresa.',
    'customization.branding.primaryColor': 'Cor primária',
    'customization.branding.secondaryColor': 'Cor secundária',
    'customization.branding.gradientHint': 'Botões, cards e gráficos utilizarão esse gradiente personalizado.',
    'customization.branding.errorSave': 'Erro ao salvar branding.',
    'customization.branding.errorLoad': 'Não foi possível carregar o branding da empresa.',
    'customization.fields.loading': 'A carregar campos customizados...',
    'customization.fields.required': 'Campo obrigatório',
    'customization.fields.byModule': 'Campos por módulo',
    'customization.fields.configJson': 'Configuração (JSON)',
    'customization.fields.errorRemove': 'Erro ao remover campo.',
    'customization.fields.errorSave': 'Erro ao salvar campo customizado.',
    'customization.features.loading': 'A carregar feature flags...',
    'customization.features.advancedJson': 'Configuração avançada (JSON)',
    'customization.features.enabled': 'Feature habilitado para a empresa',
    'customization.features.invalidJson': 'JSON de configuração inválido.',
    'customization.features.clearForm': 'Limpar formulário',
    'customization.features.none': 'Nenhum feature flag configurado para esta empresa.',
    'customization.features.errorSave': 'Erro ao salvar feature flag.',
    'customization.templates.loading': 'A carregar templates...',
    'customization.templates.subtitle': 'Customize o conteúdo das notificações enviadas aos clientes.',
    'customization.templates.welcomeSample': 'Bem-vindo à House Keep!',
    'customization.templates.errorRemove': 'Erro ao remover template.',
    'customization.workflows.loading': 'A carregar módulos...',
    'customization.workflows.definitionJson': 'Definição do workflow (JSON)',
    'customization.workflows.editor': 'Editor de workflow',
    'customization.workflows.errorRemove': 'Erro ao remover workflow.',
    'customization.workflows.errorSave': 'Erro ao salvar workflow.',
    'customization.workflows.moduleRequired': 'Informe o módulo do workflow.',
    'customization.workflows.invalidJson': 'JSON de definição inválido.',
    'customization.workflows.module': 'Módulo *',
    'customFields.loading': 'A carregar campos personalizados...',
    'adminDashboard.attentionRequired': 'Atenção Requerida',
    'adminDashboard.loadingTrend': 'A carregar dados de tendência...',
    'adminDashboard.noEmployeesCompleted': 'Nenhum colaborador com serviços completados',
    'adminDashboard.last6Months': 'Últimos 6 meses',
    'clientDashboard.errorHistory': 'Erro ao carregar histórico de serviços',
    'employeeDashboard.errorToday': 'Erro ao carregar marcaçãos do dia',
    'rbac.departments.title': 'Departamentos',
    'rbac.departments.parent': 'Departamento Pai',
    'rbac.departments.parentOptional': 'Departamento Pai (opcional)',
    'rbac.departments.descPlaceholder': 'Descrição do departamento',
    'rbac.departments.none': 'Nenhum',
    'rbac.departments.noneConfigured': 'Nenhum departamento configurado',
    'rbac.permissions.conditions': 'Condições',
    'rbac.permissions.conditionsOptional': 'Condições (JSON opcional)',
    'rbac.permissions.noneConfigured': 'Nenhuma permissão configurada',
    'rbac.permissions.new': 'Nova Permissão',
    'rbac.permissions.errorLoad': 'Não foi possível carregar permissões.',
    'rbac.roles.custom': 'Customizado',
    'rbac.roles.descPlaceholder': 'Descrição do role',
    'rbac.roles.noneConfigured': 'Nenhum role configurado',
    'rbac.roles.errorLoad': 'Não foi possível carregar roles.',
    'rbac.roles.permissions': 'Permissões',
    'rbac.management.title': 'Gestão de RBAC',
    'rbac.management.subtitle': 'Controle de acesso baseado em roles, permissões e departamentos.',
    'rbac.management.adminOnly': 'Apenas administradores podem gerenciar RBAC.',
    'rbac.management.selectCompany': 'Selecione uma empresa para gerenciar RBAC.',
    'limits.management.adminOnly': 'Apenas administradores do sistema podem configurar esses limites.',
    'limits.management.loadingCompany': 'A carregar informações da empresa...',
    'limits.management.selectCompany': 'Selecione uma empresa para gerenciar os limites de recursos.',
    'preferences.channels': 'Canais de Notificação',
    'preferences.subtitle': 'Configure como e quando você deseja receber notificações',
    'preferences.quietHours': 'Horários Silenciosos',
    'preferences.quietHoursHint': 'Durante este período, você não receberá notificações (exceto urgentes)',
    'preferences.quietStart': 'Início (HH:MM)',
    'preferences.appointmentCreated': 'Marcação Criado',
    'preferences.appointmentCancelled': 'Marcação Cancelado',
    'preferences.appointmentReminders': 'Lembretes de Marcação',
    'resetPassword.minLength': 'A senha deve ter pelo menos 6 caracteres.',
    'resetPassword.mismatch': 'As senhas não coincidem.',
    'resetPassword.confirmNew': 'Confirmar Nova Senha',
    'resetPassword.newPassword': 'Nova Senha',
    'resetPassword.placeholder': 'Introduza sua nova senha',
    'resetPassword.successTitle': 'Senha Redefinida!',
    'resetPassword.successMessage': 'Senha redefinida com sucesso! Redirecionando para o login...',
    'resetPassword.titleFull': 'Redefinir Senha',
    'setup2fa.logoutRetry': 'Sair e tentar novamente mais tarde',
    'support.tickets': 'Chamados',
    'support.ticketsSubtitle': 'Chamados e SLA isolados por empresa',
    'support.openTicket': 'Abrir chamado',
    'support.newTicketBtn': 'Novo chamado',
    'support.errorUpdate': 'Falha ao atualizar chamado.',
    'support.errorCreate': 'Falha ao criar chamado.',
    'support.average': 'Média',
    'support.refreshBtn': 'Atualizar',
    'timeDiscrepancies.subtitle': 'Análise detalhada de serviços com diferenças entre tempo estimado e real',
    'timeDiscrepancies.avgDifference': 'Diferença Média',
    'timeDiscrepancies.errorLoading': 'Erro ao carregar discrepâncias de tempo',
    'timeDiscrepancies.errorExport': 'Erro ao exportar relatório',
    'timeDiscrepancies.backToReports': '← Voltar para Relatórios',
    'timeDiscrepancies.alphabetical': '🔤 Ordem Alfabética',
    'timeDiscrepancies.service': 'Serviço',
    'reports.errorGenerate': 'Erro ao gerar relatório. Verifique o console para mais detalhes.',
    'chat.sendWhatsApp': 'Enviar também via WhatsApp',
    'notes.templatePreview': 'Assunto pré-visualizado:',
    'notes.applyTemplate': 'Aplicar conteúdo do template',
    'notes.mobileHint': 'A notificação será enviada para o aplicativo móvel do cliente.',
    'notes.loadingTemplates': 'A carregar templates...',
    'menuPermissions.loading': 'A carregar permissões...',
    'menuPermissions.crudTitle': 'Permissões CRUD',
    'menuPermissions.menuTitle': 'Permissões de Menu',
    'menuPermissions.resourceAction': 'Recurso / Ação',
    'companies.searchPlaceholder': 'Pesquisar empresas...',
    'companies.active': 'Empresa ativa',
    'companies.errorLoad': 'Erro ao carregar empresas:',
    'companies.errorDelete': 'Erro ao excluir empresa:',
    'companies.errorSave': 'Erro ao salvar empresa:',
    'users.passwordRequiredWhen': 'A senha é obrigatória quando',
    'users.administrator': 'Administrador',
    'users.changePassword': 'Alterar Senha',
    'users.passwordMismatch': 'As senhas não coincidem',
    'users.errorDelete': 'Erro ao excluir usuário:',
    'users.errorCompany': 'Não foi possível determinar a empresa. Por favor, recarregue a página e tente novamente.',
    'users.errorGetCompany': 'Erro ao obter empresa. Por favor, recarregue a página e tente novamente.',
    'appointments.recurring': 'Marcação Recorrente',
    'appointments.clientSignature': 'Assinatura do cliente',
    'appointments.createFirst': 'Criar Primeiro Marcação',
    'appointments.errorUpdateProperties': 'Erro ao atualizar propriedades',
    'appointments.errorLoad': 'Erro ao carregar marcaçãos. Tente recarregar a página.',
    'appointments.searchClientMin': 'Introduza pelo menos 3 letras para pesquisar cliente...',
    'twoFactor.enabled': '2FA Ativado',
    'twoFactor.disabled': '2FA Desativado',
    'twoFactor.disabledSuccess': '2FA desativado com sucesso.',
    'twoFactor.enabledSuccess': '2FA habilitado com sucesso!',
    'twoFactor.adminMustKeep': 'Administradores devem manter o 2FA habilitado.',
    'twoFactor.warning': 'Atenção:',
    'twoFactor.activate': 'Ativar 2FA',
    'twoFactor.deactivate': 'Desativar 2FA',
    'twoFactor.deactivateTitle': 'Desativar 2FA',
    'twoFactor.deactivateWarning': 'O 2FA é obrigatório para sua conta. Entre em contato com o administrador se precisar desativar.',
    'twoFactor.enabledInfo': 'Seu login exige o código de 2FA. Guarde seus códigos de backup em local seguro.',
    'twoFactor.disabledInfo': 'O 2FA está desativado. Ative para adicionar uma camada extra de segurança à sua conta.',
    'twoFactor.requiredDisabled': 'Esta ação está desabilitada porque o 2FA é obrigatório para sua conta.',
    'twoFactor.errorLoadStatus': 'Não foi possível carregar o status do 2FA.',
    'twoFactor.errorStartSetup': 'Falha ao iniciar configuração 2FA.',
    'twoFactor.errorDisable': 'Não foi possível desativar o 2FA.',
    'products.deactivate': 'Desativar',
    'products.deleteTitle': 'Eliminar Produto',
    'products.cost': 'Custo:',
    'products.warning': 'ATENÇÃO:',
    'products.descriptionPlaceholder': 'Descrição do produto...',
    'products.errorDeactivate': 'Erro ao desativar produto',
    'services.deactivate': 'Desativar',
    'services.deleteTitle': 'Eliminar Serviço',
    'services.descriptionPlaceholder': 'Descrição detalhada do serviço...',
    'services.errorDeactivate': 'Erro ao desativar serviço',
    'services.errorReactivate': 'Erro ao reativar serviço',
    'services.deleteChoice': 'Escolha como deseja deletar este serviço:',
    'services.hardDeleteUnavailable': 'Hard delete não disponível. Fazendo soft delete...',
    'settings.whatsapp': 'Definições WhatsApp',
    'settings.smtpSaved': 'Configuração SMTP salva com sucesso',
    'settings.whatsappSaved': 'Configuração WhatsApp salva com sucesso',
    'settings.currentApplied': 'Definições Atuais Aplicadas:',
    'settings.customizationByCompany': 'Customização por Empresa',
    'settings.phonePlaceholder': '+5511999999999 ou whatsapp:+5511999999999',
    'settings.auth': 'Autenticação',
    'settings.timezoneBRT': 'Fuso Horário de Brasília (BRT)',
    'calendar.appointments': 'marcaçãos',
    'calendar.titleShort': 'Calendário de Marcaçãos',
    'finance.addContractorQuick': 'Adicionar Terceirizado Rápido',
    'finance.allocationSuccess': 'Alocação criada com sucesso!',
    'finance.loadingMonth': 'A carregar dados do mês...',
    'finance.selectToDistribute': 'Clique no botão "Selecionar para Distribuir"',
    'finance.createFirstAllocation': 'Criar Primeira Alocação',
    'properties.instructions': 'Instruções',
    'properties.cepHint': '💡 8 dígitos (Brasil) ou 5 dígitos (USA)',
    'properties.errorLoad': 'Erro ao carregar propriedades:',
    'employees.thirdPartyHint': 'Marque se este colaborador é um terceirizado/contratado externo',
    'employees.zoneExample': 'Ex: Zona Norte, Centro, etc.',

    'menu.companies': 'Empresas',
    'menu.zones': 'Zonas',
    'menu.services': 'Serviços',
    'menu.limits': 'Limites',
    'menu.rbac': 'RBAC',
    'menu.notificationPreferences': 'Preferências de Notificação',
    'menu.history': 'Histórico',
  },
  
  es: {
    // Navigation
    dashboard: 'Panel',
    users: 'Usuarios',
    menuPermissions: 'Permisos de Menu',
    clients: 'Clientes',
    properties: 'Propiedades',
    appointments: 'Citas',
    financial: 'Financiero',
    reports: 'Reportes',
    settings: 'Configuraciones',
    logout: 'Salir',
    help: 'Ayuda',
    helpTitle: 'Centro de Ayuda',
    helpSubtitle: 'Mire los videos tutoriales para aprender a usar Agenda House Keep.',
    helpVideoList: 'Tutoriales disponibles',
    helpVideoOverview: 'Visión general del sistema',
    helpVideoOverviewDesc: 'Navegue por los módulos principales: panel, clientes, citas y financiero.',
    helpVideoAdminFull: 'Admin — flujo completo',
    helpVideoAdminFullDesc: 'Registre empleados, clientes, propiedades y programe un servicio de limpieza.',
    helpVideoEmployee: 'Empleado — rutina diaria',
    helpVideoEmployeeDesc: 'Vea su agenda, clientes, evaluaciones y preferencias de notificación.',
    helpVideoClient: 'Cliente — citas y preferencias',
    helpVideoClientDesc: 'Siga sus citas de limpieza y configure alertas de notificación.',
    helpTip: 'Los videos no tienen audio — los subtítulos explicativos están grabados en la pantalla. Use pantalla completa para mejor lectura.',
    helpAudienceAll: 'Todos',
    helpAudienceAdmin: 'Admin',
    helpAudienceEmployee: 'Empleado',
    helpAudienceClient: 'Cliente',
    helpRecommended: 'Para ti',
    search: 'Buscar...',
    searchAll: 'Todos',
    searching: 'Buscando...',
    noResults: 'No se encontraron resultados',
    recentSearches: 'Búsquedas recientes',
    employees: 'Empleados',
    products: 'Productos',
    
    // Settings Page
    settingsTitle: 'Configuraciones',
    settingsSubtitle: 'Gestiona tus preferencias y configuraciones de cuenta',
    settingsMenu: 'Menu de Configuraciones',
    myAccount: 'Mi Cuenta',
    notifications: 'Notificaciones',
    security: 'Seguridad',
    
    // Account Settings
    regionalSettings: 'Configuraciones Regionales',
    language: 'Idioma',
    currency: 'Moneda',
    dateFormat: 'Formato de Fecha',
    timeFormat: 'Formato de Hora',
    timezone: 'Zona Horaria',
    numberFormat: 'Formato de Numeros',
    
    // Save buttons
    saveSettings: 'Guardar Configuraciones',
    saving: 'Guardando...',
    settingsSaved: 'Configuraciones guardadas exitosamente!',
    
    // Account info
    accountInformation: 'Informacion de la Cuenta',
    email: 'Email',
    role: 'Rol',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    
    // Reports page
    reportsAndAnalytics: 'Reportes y Analisis',
    reportsSubtitle: 'Rastrea el rendimiento de tu negocio',
    period: 'Periodo',
    
    // Appointments page
    appointmentManagement: 'Gestion de Citas',
    appointmentSubtitle: 'Gestiona todas las citas de servicios',
    appointmentList: 'Lista de Citas',
    newAppointment: 'Nueva Cita',
    client: 'Cliente',
    property: 'Propiedad',
    serviceType: 'Tipo de Servicio',
    dateTime: 'Fecha y Hora',
    cleaning: 'Limpieza',
    maintenance: 'Mantenimiento',
    repair: 'Reparacion',
    schedule: 'Programar',
    cancel: 'Cancelar',
    noAppointmentsFound: 'No se encontraron citas',
    loadingAppointments: 'Cargando citas...',
    appointmentCreatedSuccess: 'Cita creada exitosamente!',
    appointmentUpdatedSuccess: 'Cita actualizada exitosamente!',
    appointmentCancelledSuccess: 'Cita cancelada exitosamente!',
    format: 'Formato',
    scheduled: 'Programada',
    confirmed: 'Confirmada',
    completed: 'Completada',
    cancelled: 'Cancelada',
    
    // Reports page (continued)
    last3Months: 'Ultimos 3 meses',
    last6Months: 'Ultimos 6 meses',
    lastYear: 'Ultimo año',
    monthlyRevenue: 'Ingresos Mensuales',
    servicesByType: 'Servicios por Tipo',
    topClients: 'Mejores Clientes',
    download: 'Descargar',
    totalBilled: 'Total Facturado',
    services: 'Servicios',
    reportMonthlyRevenue: 'Informe de Ingresos Mensuales',
    reportServiceTypes: 'Informe de Tipos de Servicio',
    reportTopClients: 'Informe de Mejores Clientes',
    reportTypeNotRecognized: 'Tipo de informe no reconocido',
    reportGeneratedSuccess: 'Informe {type} generado y descargado exitosamente!',
    reportGenerationError: 'Error al generar informe. Verifique la consola para más detalles.',
    generatedAt: 'Generado en',
    totalServices: 'Total de Servicios',
    totalClients: 'Total de Clientes',
    month: 'Mes',
    count: 'Cantidad',
    
    // Financial page
    financialDashboard: 'Panel Financiero',
    financialSubtitle: 'Rastrea tu situación financiera',
    totalRevenue: 'Ingresos Totales',
    pending: 'Pendientes',
    completedServices: 'Servicios Completados',
    recentTransactions: 'Transacciones Recientes',
    allTransactions: 'Todas las Transacciones',
    income: 'Ingreso',
    expense: 'Gasto',
    paid: 'Pagado',
    loading: 'Cargando',
    noTransactionsFound: 'No se encontraron transacciones',
    
    // Menu permissions
    menuPermissionsSubtitle: 'Configure los permisos de menu para diferentes perfiles de usuario',
    saveChanges: 'Guardar Cambios',
    restoreDefaults: 'Restaurar Valores por Defecto',
    unsavedChanges: 'Cambios no guardados',
    menuProfile: 'Menu / Perfil',
    selectAll: 'Seleccionar Todo',
    deselectAll: 'Deseleccionar Todo',
    mainMenu: 'Menu Principal',
    administration: 'Administracion',
    legend: 'Leyenda',
    mainMenuDesc: 'Opciones esenciales para operacion diaria',
    administrationDesc: 'Opciones para gestion del sistema',
    reportsDesc: 'Opciones para analisis y reportes',
    tip: 'Consejo',
    tipText: 'Usa "Seleccionar/Deseleccionar Todo" para configurar rapidamente todos los permisos de un perfil.',
    
    // Client Management
    clientManagement: 'Gestion de Clientes',
    clientSubtitle: 'Gestiona todos tus clientes',
    clientList: 'Lista de Clientes',
    newClient: 'Nuevo Cliente',
    clientName: 'Nombre',
    clientPhone: 'Telefono',
    clientDocument: 'Documento',
    clientRegistration: 'Registro',
    clientActions: 'Acciones',
    birthDate: 'Fecha de Nacimiento',
    birthDateHelp: 'Enviaremos un recordatorio de cumpleaños a este cliente',
    noClientsFound: 'No hay clientes registrados',
    loadingClients: 'Cargando clientes...',
    
    // Property Management
    propertyManagement: 'Gestion de Propiedades',
    propertySubtitle: 'Gestiona todas las propiedades disponibles',
    propertyList: 'Propiedades',
    addProperty: 'Agregar Propiedad',
    propertyName: 'Nombre de la Propiedad',
    propertyAddress: 'Direccion',
    propertyType: 'Tipo de Propiedad',
    propertyPrice: 'Precio Mensual ($)',
    noPropertiesFound: 'No hay propiedades registradas',
    loadingProperties: 'Cargando propiedades...',
    
    // Dashboard
    dashboardSubtitle: 'Bienvenido al sistema de gestion de propiedades',
    dashboardCustomize: 'Personalizar',
    dashboardDoneCustomize: 'Finalizar',
    dashboardConfigureWidgets: 'Configurar widgets',
    dashboardLayout: 'Disposición',
    dashboardLayoutGrid: 'Cuadrícula',
    dashboardLayoutList: 'Lista',
    dashboardAvailableWidgets: 'Widgets disponibles',
    dashboardRestoreDefault: 'Restaurar predeterminado',
    dashboardEmptyWidgets: 'No hay widgets visibles. Abra la configuración o restaure el diseño predeterminado.',
    dashboardAdminTitle: 'Panel administrativo',
    dashboardAdminSubtitle: 'Resumen financiero y operativo',
    dashboardSupervisorTitle: 'Panel de supervisión',
    dashboardSupervisorSubtitle: 'Operaciones de campo y equipo',
    dashboardEmployeeTitle: 'Mi día',
    dashboardEmployeeSubtitle: 'Citas y servicios de hoy',
    dashboardClientTitle: 'Mis servicios',
    dashboardClientSubtitle: 'Próximas citas e historial',
    dashboardSaveError: 'No se pudieron guardar las preferencias de widgets',
    dashboardWidgetTodayAppointments: 'Citas de hoy',
    dashboardWidgetUpcoming: 'Próximas citas',
    dashboardWidgetCompletedToday: 'Completados hoy',
    dashboardWidgetRecent: 'Servicios recientes',
    dashboardWidgetTotalServices: 'Total de servicios',
    dashboardNoAppointmentsToday: 'No hay citas para hoy',
    dashboardNoUpcoming: 'No hay citas próximas',
    dashboardNoRecentServices: 'Aún no hay servicios completados',
    quickActions: 'Acciones Rapidas',
    welcomeMessage: 'Bienvenido al sistema de gestion de propiedades',
    revenue: 'Ingresos',
    
    // User Roles
    administrator: 'Administrador',
    supervisor: 'Supervisor',
    employee: 'Empleado',
    clientRole: 'Cliente',
    
    // Search
    searchingFor: 'Buscando',
    
    // Common Actions
    create: 'Crear',
    edit: 'Editar',
    delete: 'Eliminar',
    save: 'Guardar',
    success: 'Exito',
    error: 'Error',
    confirm: 'Confirmar',
    registerProperty: 'Registrar Propiedad',
    editClient: 'Editar Cliente',
    deleteClient: 'Eliminar Cliente',
    
    // Password validation
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
    currentPassword: 'Contraseña Actual',
    newPassword: 'Nueva Contraseña',
    confirmNewPassword: 'Confirmar Nueva Contraseña',
    changePassword: 'Cambiar Contraseña',
    changing: 'Cambiando...',
    
    // Property Types
    house: 'Casa',
    apartment: 'Apartamento',
    condo: 'Condominio',
    commercial: 'Comercial',
    
    // Common Fields
    name: 'Nombre',
    phone: 'Telefono',
    document: 'Documento',
    address: 'Direccion',
    type: 'Tipo',
    price: 'Precio',
    monthly: 'Mensual',
    actions: 'Acciones',
    registration: 'Registro',
    
    // Users Management
    userManagement: 'Gestión de Usuarios',
    userSubtitle: 'Administre usuarios y permisos del sistema',
    createNewUser: 'Crear Nuevo Usuario',
    editUser: 'Editar Usuario',
    filterByRole: 'Filtrar por Perfil',
    filterByStatus: 'Filtrar por Estado',
    allRoles: 'Todos los perfiles',
    allStatus: 'Todos los estados',
    lastLogin: 'Último Acceso',
    never: 'Nunca',
    confirmDelete: '¿Está seguro de que desea eliminar este usuario?',
    errorLoadingUsers: 'Error al cargar usuarios. Verifique sus permisos.',
    errorCreatingUser: 'Error al crear usuario',
    errorUpdatingUser: 'Error al actualizar usuario',
    errorDeletingUser: 'Error al eliminar usuario',
    errorUpdatingRole: 'Error al actualizar rol',
    password: 'Contraseña',
    optional: 'Opcional',
    
    // Employees Management
    'employees.title': 'Gestión de Empleados',
    'employees.subtitle': 'Gestiona tu equipo',
    'employees.list': 'Lista de Empleados',
    'employees.new': 'Nuevo Empleado',
    'employees.edit': 'Editar Empleado',
    'employees.name': 'Nombre',
    'employees.email': 'Correo electrónico',
    'employees.phone': 'Teléfono',
    'employees.document': 'Documento',
    'employees.noDocument': 'Sin documento',
    'employees.zone': 'Zona',
    'employees.hireDate': 'Fecha de Contratación',
    'employees.status': 'Estado',
    'employees.active': 'Activo',
    'employees.inactive': 'Inactivo',
    'employees.notFound': 'No se encontraron empleados',
    'employees.loading': 'Cargando empleados...',
    'employees.filter.zone': 'Zona',
    'employees.filter.allZones': 'Todas las zonas',
    'employees.filter.status': 'Estado',
    'employees.filter.allStatus': 'Todos',
    'employees.filter.active': 'Activos',
    'employees.filter.inactive': 'Inactivos',
    'employees.error.loading': 'Error al cargar empleados',
    'employees.ratings.highlightTitle': 'Destacados en Calificaciones',
    'employees.ratings.highlightSubtitle': 'Sigue quién está recibiendo las mejores calificaciones de los clientes.',
    'employees.ratings.total': 'calificaciones',
    
    // Zones Management (Spanish)
    'zones.title': 'Gestión de Zonas',
    'zones.subtitle': 'Gestione las zonas geográficas de operación',
    'zones.name': 'Nombre',
    'zones.description': 'Descripción',
    'zones.center': 'Centro',
    'zones.centerLat': 'Latitud del Centro',
    'zones.centerLon': 'Longitud del Centro',
    'zones.radius': 'Radio (km)',
    'zones.radiusHelp': 'Deje vacío para usar polígono (boundaries)',
    'zones.boundaries': 'Boundaries (JSON)',
    'zones.boundariesHelp': 'Formato GeoJSON para definir polígono de la zona',
    'zones.create': 'Nueva Zona',
    'zones.edit': 'Editar Zona',
    'zones.empty': 'No hay zonas registradas',
    'zones.success.created': '¡Zona creada con éxito!',
    'zones.success.updated': '¡Zona actualizada con éxito!',
    'zones.success.deleted': '¡Zona desactivada con éxito!',
    'zones.error.loading': 'Error al cargar zonas',
    'zones.error.saving': 'Error al guardar zona',
    'zones.error.deleting': 'Error al eliminar zona',
    'zones.confirm.delete': '¿Está seguro de que desea desactivar la zona',
    'zones.mapView': 'Vista del Mapa',
    'zones.showMap': 'Mostrar Mapa',
    'zones.hideMap': 'Ocultar Mapa',
    'zones.currentLocation.loading': 'Obteniendo ubicación...',
    'zones.currentLocation.gps': 'GPS',
    'zones.currentLocation.ip': 'Aproximado (IP)',
    'zones.currentLocation.refresh': 'Actualizar ubicación',
    'zones.currentLocation.error': 'Ubicación no disponible',
    
    // Services Management
    'services.title': 'Gestión de Servicios',
    'services.subtitle': 'Gestiona los servicios de limpieza ofrecidos',
    'services.list': 'Lista de Servicios',
    'services.new': 'Nuevo Servicio',
    'services.edit': 'Editar Servicio',
    'services.name': 'Nombre del Servicio',
    'services.description': 'Descripción',
    'services.type': 'Tipo de Servicio',
    'services.duration': 'Duración (min)',
    'services.price': 'Precio Base',
    'services.rooms': 'Habitaciones Incluidas',
    'services.includedRooms': 'Habitaciones',
    'services.minutes': 'minutos',
    'services.notFound': 'No se encontraron servicios',
    'services.loading': 'Cargando servicios...',
    'services.filter.type': 'Tipo de Servicio',
    'services.filter.allTypes': 'Todos los tipos',
    'services.filter.status': 'Estado',
    'services.filter.allStatus': 'Todos',
    'services.filter.active': 'Activos',
    'services.filter.inactive': 'Inactivos',
    'services.error.loading': 'Error al cargar servicios',
    
    // Products Management
    'products.title': 'Gestión de Productos',
    'products.subtitle': 'Control de inventario de productos de limpieza',
    'products.list': 'Lista de Productos',
    'products.new': 'Nuevo Producto',
    'products.edit': 'Editar Producto',
    'products.name': 'Nombre del Producto',
    'products.brand': 'Marca',
    'products.description': 'Descripción',
    'products.unit': 'Unidad',
    'products.quantity': 'Cantidad',
    'products.minStock': 'Stock Mínimo',
    'products.costPrice': 'Precio de Costo',
    'products.category': 'Categoría',
    'products.notFound': 'No se encontraron productos',
    'products.loading': 'Cargando productos...',
    'products.filter.category': 'Categoría',
    'products.filter.allCategories': 'Todas las categorías',
    'products.filter.status': 'Estado',
    'products.filter.allStatus': 'Todos',
    'products.filter.active': 'Activos',
    'products.filter.inactive': 'Inactivos',
    'products.error.loading': 'Error al cargar productos',
    
    // Notification History
    'notifications.history.title': 'Historial de Notificaciones',
    'notifications.history.unread': 'No leídas:',
    'notifications.history.filterByType': 'Filtrar por tipo',
    'notifications.history.all': 'Todas',
    'notifications.history.info': 'Informativas',
    'notifications.history.success': 'Éxito',
    'notifications.history.warning': 'Advertencias',
    'notifications.history.error': 'Errores',
    'notifications.history.markAllRead': 'Marcar todas como leídas',
    'notifications.history.markAsRead': 'Marcar como leída',
    'notifications.history.delete': 'Eliminar',
    'notifications.history.loading': 'Cargando...',
    'notifications.history.none': 'Aún no hay notificaciones',
    'notifications.history.loadMore': 'Cargar más notificaciones',
    'notifications.history.error.loading': 'Error al cargar historial',
    'notifications.history.error.markRead': 'Error al marcar como leída',
    'notifications.history.error.markAllRead': 'Error al marcar todas como leídas',
    'notifications.history.error.delete': 'Error al eliminar',
    
    // Notification Settings
    'notifications.settings.title': 'Configuraciones de Notificaciones',
    'notifications.settings.notSupported': 'Las Notificaciones Push no son compatibles',
    'notifications.settings.notSupportedDesc': 'Su navegador no admite Notificaciones Push. Por favor, use un navegador moderno como Chrome, Firefox o Edge.',
    'notifications.settings.permissionStatus': 'Estado del Permiso:',
    'notifications.settings.subscriptionStatus': 'Estado de la Suscripción:',
    'notifications.settings.permission.granted': 'Concedido',
    'notifications.settings.permission.denied': 'Denegado',
    'notifications.settings.permission.default': 'No solicitado',
    'notifications.settings.subscription.active': 'Activa',
    'notifications.settings.subscription.inactive': 'Inactiva',
    'notifications.settings.activate': 'Activar Notificaciones',
    'notifications.settings.activatePush': 'Activar Push Notifications',
    'notifications.settings.sendTest': 'Enviar Notificación de Prueba',
    'notifications.settings.deactivate': 'Desactivar Notificaciones',
    'notifications.settings.permissionDenied': 'El permiso para notificaciones fue denegado. Por favor, habilítelo en la configuración de su navegador.',
    'notifications.settings.error.requestPermission': 'Error al solicitar permiso',
    'notifications.settings.error.activate': 'Error al activar notificaciones',
    'notifications.settings.error.deactivate': 'Error al desactivar notificaciones',
    'notifications.settings.error.sendTest': 'Error al enviar notificación de prueba',
    'notifications.settings.loading': 'Cargando...',
    'notifications.settings.connecting': 'Conectando...',
    'notifications.settings.sending': 'Enviando...',
    'notifications.settings.deactivating': 'Desactivando...',
    
    // Special Instructions Modal
    'specialInstructions.title': 'Instrucciones Especiales',
    'specialInstructions.current': 'Instrucciones Actuales',
    'specialInstructions.history': 'Historial',
    'specialInstructions.placeholder': 'Escriba las instrucciones especiales para esta propiedad...',
    'specialInstructions.saving': 'Guardando...',
    'specialInstructions.deleting': 'Eliminando...',
    'specialInstructions.edit': 'Editar Instrucciones',
    'specialInstructions.add': 'Agregar Instrucciones',
    'specialInstructions.none': 'No hay instrucciones especiales registradas para esta propiedad.',
    'specialInstructions.noHistory': 'No se encontró historial de cambios.',
    'specialInstructions.changedBy': 'Modificado por:',
    'specialInstructions.invalidId': 'ID de Propiedad Inválido',
    'specialInstructions.invalidIdDesc': 'Esta propiedad (ID: {id}) no tiene un UUID válido y no puede usar la funcionalidad de instrucciones especiales.',
    'specialInstructions.invalidIdSolution': 'Solución: Cree una nueva propiedad usando el botón "+ Add Property" en la página de Propiedades.',
    'specialInstructions.error.loading': 'Error al cargar instrucciones',
    'specialInstructions.error.saving': 'Error al guardar instrucciones',
    'specialInstructions.error.deleting': 'Error al eliminar instrucciones',
    'specialInstructions.confirmDelete': '¿Está seguro de que desea eliminar las instrucciones especiales de esta propiedad?',
    
    // Animal Management Modal
    'animals.title': 'Animales - {propertyName}',
    'animals.subtitle': 'Gestionar animales de esta propiedad para alertas de seguridad',
    'animals.total': 'Total de animales:',
    'animals.dangerous': 'peligroso(s)',
    'animals.add': 'Agregar Animal',
    'animals.new': 'Nuevo Animal',
    'animals.edit': 'Editar Animal',
    'animals.none': 'No hay animales registrados en esta propiedad.',
    'animals.addFirst': 'Agregar Primer Animal',
    'animals.name': 'Nombre *',
    'animals.type': 'Tipo *',
    'animals.breed': 'Raza',
    'animals.behavior': 'Comportamiento',
    'animals.size': 'Tamaño',
    'animals.notes': 'Observaciones',
    'animals.dangerousLabel': 'Animal peligroso (requiere atención especial)',
    'animals.dangerousTag': 'Peligroso',
    'animals.type.dog': 'Perro',
    'animals.type.cat': 'Gato',
    'animals.type.bird': 'Pájaro',
    'animals.type.other': 'Otro',
    'animals.behavior.friendly': 'Amigable',
    'animals.behavior.shy': 'Tímido',
    'animals.behavior.aggressive': 'Agresivo',
    'animals.behavior.unknown': 'Desconocido',
    'animals.size.small': 'Pequeño',
    'animals.size.medium': 'Mediano',
    'animals.size.large': 'Grande',
    'animals.size.select': 'Seleccione...',
    'animals.label.type': 'Tipo:',
    'animals.label.breed': 'Raza:',
    'animals.label.behavior': 'Comportamiento:',
    'animals.label.size': 'Tamaño:',
    'animals.label.notes': 'Observaciones:',
    'animals.error.loading': 'Error al cargar animales',
    'animals.error.saving': 'Error al guardar animal',
    'animals.error.deleting': 'Error al eliminar animal',
    'animals.success.created': '¡Animal creado exitosamente!',
    'animals.success.updated': '¡Animal actualizado exitosamente!',
    'animals.success.deleted': '¡Animal eliminado exitosamente!',
    'animals.confirmDelete': '¿Está seguro de que desea eliminar este animal?',
    
    // Check-in/Check-out
    'checkin.title': 'Check-in',
    'checkout.title': 'Check-out',
    'checkin.process': 'Hacer Check-in',
    'checkout.process': 'Hacer Check-out',
    'checkin.processing': 'Procesando...',
    
    // SMTP Settings
    'smtp.success.saved': 'Configuración SMTP guardada exitosamente',
    'smtp.success.testSent': '¡Email de prueba enviado exitosamente! Revise su bandeja de entrada.',
    'smtp.error.saving': 'Error al guardar configuración SMTP',
    'smtp.error.testing': 'Error al probar configuración SMTP',
    'smtp.error.unknown': 'Error desconocido',
    'smtp.error.testEmail': 'Por favor, proporcione un email para prueba',
    'smtp.save': 'Guardar Configuración',
    'smtp.sendTest': 'Enviar Prueba',
    'smtp.saveNotificationSettings': 'Guardar Configuraciones de Notificaciones',
    
    // Reports - Months
    'reports.month.jan': 'Ene',
    'reports.month.feb': 'Feb',
    'reports.month.mar': 'Mar',
    'reports.month.apr': 'Abr',
    'reports.month.may': 'May',
    'reports.month.jun': 'Jun',
    'reports.month.jul': 'Jul',
    'reports.month.aug': 'Ago',
    'reports.month.sep': 'Sep',
    'reports.month.oct': 'Oct',
    'reports.month.nov': 'Nov',
    'reports.month.dec': 'Dic',
    'reports.clientNotInformed': 'Cliente no informado',
    'reports.error.loadingProperties': 'Error al cargar propiedades para mapear clientes',
    'reports.error.loading': 'Error al cargar reportes',
    'reports.error.generating': 'Error al generar reporte',
    'reports.error.generatingPdf': 'Error al generar reporte PDF',
    'reports.error.generatingDetails': 'Error al generar reporte. Verifique la consola para más detalles.',
    'reports.filters': 'Filtros',
    'reports.filterByZone': 'Zona',
    'reports.allZones': 'Todas las zonas',
    
    // Properties
    'properties.error.notReturned': 'Propiedad no devuelta por la API',
    'properties.success.created': '¡Propiedad creada exitosamente!',
    'properties.success.updated': '¡Propiedad actualizada exitosamente!',
    'properties.error.creating': 'Error al crear propiedad',
    'properties.error.updating': 'Error al actualizar propiedad',
    'properties.error.deleting': 'Error al eliminar propiedad',
    'properties.error.loading': 'Error al cargar propiedades',
    'properties.error.cep': 'Error al buscar CEP/Código Postal',
    'properties.confirmDelete': '¿Está seguro de que desea eliminar esta propiedad?',
    'properties.clientNotFound': '¿Cliente no encontrado? Haga clic en "New Client" para registrar',
    'properties.searchingCep': 'Buscando CEP...',
    'properties.searchingZip': 'Buscando Código Postal...',
    'properties.updating': 'Actualizando...',
    'properties.creating': 'Creando...',
    'properties.update': 'Actualizar',
    'properties.create': 'Crear Propiedad',
    'properties.phone': 'Teléfono',
    'properties.documentId': 'ID del Documento',
    'properties.enterDocumentId': 'Ingrese el ID del documento',
    'properties.type.residential': 'Residencial',
    'properties.type.commercial': 'Comercial',
    'properties.type.other': 'Otro',
    
    // Appointments
    'appointments.error.selectClient': 'Por favor, seleccione un cliente',
    'appointments.error.selectProperty': 'Por favor, seleccione una propiedad',
    'appointments.error.selectValidProperty': 'Por favor, seleccione una propiedad válida',
    'appointments.error.selectEmployee': 'Por favor, seleccione un empleado',
    'appointments.error.creating': 'Error al crear cita',
    'appointments.error.updating': 'Error al actualizar cita',
    'appointments.error.cancelling': 'Error al cancelar cita',
    'appointments.error.dateNotInformed': 'Fecha no informada',
    'appointments.error.invalidDate': 'Fecha inválida',
    'appointments.error.formattingDate': 'Error al formatear fecha',
    'appointments.edit': 'Editar Cita',
    'appointments.searchClientPlaceholder': 'Escriba al menos 3 letras para buscar cliente...',
    'appointments.selectPropertyPlaceholder': 'Seleccione una propiedad...',
    'appointments.searchPropertyPlaceholder': 'Escriba para buscar o seleccione del menú desplegable arriba',
    'appointments.searchPropertyPlaceholderAlt': 'Seleccione un cliente primero o escriba para buscar...',
    'appointments.selectClientFirst': 'Seleccione un cliente primero',
    'appointments.employee': 'Empleado',
    'appointments.searchEmployeePlaceholder': 'Escriba para buscar o haga clic para ver todos...',
    'appointments.noName': 'Sin nombre',
    'appointments.time': 'Hora',
    
    // Financial
    'financial.error.loadingPayments': 'Error al cargar pagos',
    'financial.error.loadingClients': 'Error al cargar clientes',
    'financial.error.loadingAllocations': 'Error al cargar asignaciones',
    'financial.error.loadingCosts': 'Error al cargar costos',
    'financial.error.loadingBalance': 'Error al cargar saldo',
    'financial.success.paymentCreated': '¡Pago registrado exitosamente!',
    'financial.success.paymentUpdated': '¡Pago actualizado!',
    'financial.success.paymentDeleted': '¡Pago eliminado!',
    'financial.success.allocationCreated': '¡Asignación creada exitosamente!',
    'financial.success.statusUpdated': '¡Estado actualizado!',
    'financial.success.thirdPartyCreated': '¡Tercero creado exitosamente! El campo se actualizó automáticamente.',
    'financial.success.thirdPartyCreatedPartial': 'Tercero creado, pero hubo un problema al actualizar la lista. Intente recargar la página.',
    'financial.success.costCreated': '¡Costo registrado!',
    'financial.error.creatingPayment': 'Error al crear pago',
    'financial.error.updatingPayment': 'Error al actualizar pago',
    'financial.error.deletingPayment': 'Error al eliminar pago',
    'financial.error.creatingAllocation': 'Error al crear asignación',
    'financial.error.updatingStatus': 'Error al actualizar estado',
    'financial.error.creatingThirdParty': 'Error al crear tercero',
    'financial.error.creatingCost': 'Error al crear costo',
    'financial.error.deletingCost': 'Error al eliminar costo',
    'financial.confirmDeletePayment': '¿Está seguro de que desea eliminar este pago?',
    'financial.confirmDeleteCost': '¿Eliminar este costo?',
    'financial.status.paid': 'Pagado',
    'financial.status.pending': 'Pendiente',
    'financial.status.cancelled': 'Cancelado',
    
    // Autocomplete
    'autocomplete.placeholder': 'Escriba para buscar...',
    'autocomplete.error.searching': 'Error al buscar',
    'autocomplete.error.loading': 'Error al cargar opciones iniciales',
    'autocomplete.minChars': 'Escriba al menos {minChars} caracteres para buscar',
    'autocomplete.createNew': 'Crear nuevo: "{value}"',
    
    // Chat Modal
    'chat.title': 'Chat en Tiempo Real',
    'chat.subtitle': 'Comunicación entre cliente y empleado vinculados a la cita',
    'chat.filter': 'Filtrar por cliente o propiedad',
    'chat.property': 'Propiedad',
    'chat.client': 'Cliente:',
    'chat.employee': 'Empleado:',
    'chat.messagePlaceholder': 'Escriba un mensaje',
    'chat.sending': 'Enviando...',
    'chat.send': 'Enviar',
    'chat.loadingThreads': 'Cargando conversaciones...',
    'chat.noThreads': 'No hay conversaciones disponibles',
    'chat.loadingMessages': 'Cargando mensajes...',
    'chat.noMessages': 'Aún no hay mensajes',
    'chat.selectThread': 'Seleccione una conversación para comenzar',
    'chat.helpRequest': 'Solicitud de Ayuda · Prioridad',
    
    // Quick Create Modals
    'quickCreate.property.title': 'Registrar Nueva Propiedad',
    'quickCreate.property.client': 'Cliente:',
    'quickCreate.property.name': 'Nombre de la Propiedad',
    'quickCreate.property.address': 'Dirección',
    'quickCreate.property.zipCode': 'CEP / Código Postal',
    'quickCreate.property.type': 'Tipo',
    'quickCreate.property.city': 'Ciudad',
    'quickCreate.property.state': 'Estado (UF)',
    'quickCreate.property.price': 'Precio Mensual (R$)',
    'quickCreate.property.required': '(obligatorio)',
    'quickCreate.property.searchingCep': '🔍 Buscando...',
    'quickCreate.property.cepInstructions': 'Ingrese CEP (8 dígitos) o Código Postal (5 dígitos) para completar automáticamente',
    'quickCreate.property.cepNotFound': 'CEP/Código Postal no encontrado',
    'quickCreate.property.clientNotSelected': 'Cliente no seleccionado. Por favor, seleccione un cliente primero.',
    'quickCreate.property.invalidResponse': 'Respuesta inválida de la API - propiedad no devuelta',
    'quickCreate.property.error': 'Error al crear propiedad',
    'quickCreate.property.error.endpoint': 'Endpoint no encontrado. Verifique si el servicio está ejecutándose.',
    'quickCreate.property.error.invalidData': 'Datos inválidos. Verifique los campos requeridos.',
    'quickCreate.property.error.server': 'Error interno del servidor. Intente nuevamente.',
    'quickCreate.property.error.connection': 'Error de conexión. Verifique su conexión a internet.',
    'quickCreate.property.exampleName': 'Ej: Casa de Playa',
    'quickCreate.property.exampleAddress': 'Calle, número, barrio...',
    'quickCreate.property.autoFill': 'Se completará automáticamente por Código Postal',
    'quickCreate.property.examplePrice': 'Ej: 250.00',
    'quickCreate.property.registering': 'Registrando...',
    'quickCreate.property.register': 'Registrar Propiedad',
    'quickCreate.employee.error': 'Error al crear empleado',
    'quickCreate.employee.exampleZone': 'Ej: Zona Norte',
    'quickCreate.employee.registering': 'Registrando...',
    'quickCreate.employee.register': 'Registrar Empleado',
    'quickCreate.client.error': 'Error al crear cliente',
    'quickCreate.client.registering': 'Registrando...',
    'quickCreate.client.register': 'Registrar Cliente',
    
    // Complete Service Modal
    'completeService.error.positiveTime': 'El tiempo real debe ser un número positivo',
    'completeService.error.invalidEndTime': 'Fecha/hora de finalización inválida',
    'completeService.error': 'Error al completar servicio',
    'completeService.error.invalidData': 'Datos inválidos. Verifique los campos completados.',
    'completeService.error.notFound': 'Cita no encontrada. Por favor, recargue la página.',
    'completeService.error.server': 'Error interno del servidor. Intente nuevamente.',
    'completeService.error.connection': 'Error de conexión. Verifique su conexión a internet.',
    'completeService.notesPlaceholder': 'Observaciones sobre la finalización del servicio...',
    'completeService.completing': 'Completando...',
    'completeService.complete': 'Completar Servicio',
    
    // Dashboard
    'dashboard.noAppointments': 'Aún no hay citas',
    'dashboard.employees': 'Empleados',
    'dashboard.services': 'Servicios',
    'dashboard.products': 'Productos',
    
    // Common error messages
    'errors.loading': 'Error al cargar',
    'errors.saving': 'Error al guardar',
    'errors.creating': 'Error al crear',
    'errors.updating': 'Error al actualizar',
    'errors.deleting': 'Error al eliminar',
    'errors.searching': 'Error al buscar',
    'errors.testing': 'Error al probar',
    'errors.unknown': 'Error desconocido',
    
    // Common success messages
    'success.created': '¡creado exitosamente!',
    'success.updated': '¡actualizado exitosamente!',
    'success.deleted': '¡eliminado exitosamente!',
    'success.saved': '¡guardado exitosamente!',
    
    // Common confirmations
    'confirm.delete': '¿Está seguro de que desea eliminar esto?',
    'confirm.cancel': '¿Está seguro de que desea cancelar esto?',
    'confirm.action': '¿Está seguro de que desea hacer esto?',
    
    // Common placeholders
    'placeholders.typeToSearch': 'Escriba para buscar...',
    'placeholders.select': 'Seleccione...',
    'placeholders.pleaseSelect': 'Por favor, seleccione...',
    'placeholders.pleaseInform': 'Por favor, informe...',
    
    // Common actions
    'actions.save': 'Guardar',
    'actions.cancel': 'Cancelar',
    'actions.confirm': 'Confirmar',
    'actions.delete': 'Eliminar',
    'actions.edit': 'Editar',
    'actions.create': 'Crear',
    'actions.update': 'Actualizar',
    'actions.add': 'Agregar',
    'actions.remove': 'Remover',
    
    // Ratings
    'ratings.history.title': 'Historial de Calificaciones',
    'ratings.history.subtitle': 'Ver todas las calificaciones recibidas',
    'ratings.history.empty': 'No se encontraron calificaciones',
    'ratings.search.placeholder': 'Buscar por cliente, propiedad o comentario...',
    'ratings.filter.all': 'Todos los Estados',
    'ratings.filter.approved': 'Aprobadas',
    'ratings.filter.pending': 'Pendientes',
    'ratings.filter.submitted': 'Enviadas',
    'ratings.stats.average': 'Calificación Promedio',
    'ratings.stats.total': 'Total de Calificaciones',
    'ratings.stats.fiveStar': '5 Estrellas',

    // PWA
    'pwa.install.title': 'Instalar House Keep',
    'pwa.install.description': 'Añade la app a la pantalla de inicio para acceso rápido.',
    'pwa.install.action': 'Instalar',
    'pwa.install.dismiss': 'Ahora no',
    'pwa.install.ios_hint': 'Toca Compartir y luego "Añadir a la pantalla de inicio".',
    'pwa.update.title': 'Nueva versión disponible',
    'pwa.update.action': 'Actualizar ahora',
    'pwa.offline.message': 'Estás sin conexión',
    'common.loading': 'Cargando...',
    'common.loadingChart': 'Cargando gráfico...',
    'common.loadingData': 'Cargando datos...',
    'common.sortBy': 'Ordenar por:',
    'common.month': 'Mes',
    'common.quantity': 'Cantidad',
    'common.position': 'Posición',
    'common.difference': 'Diferencia',
    'common.yourResponse': 'Su respuesta:',
    'common.punctuality': 'Puntualidad',
    'common.quality': 'Calidad',
    'common.communication': 'Comunicación',
    'billing.title': 'Facturación SaaS',
    'billing.subtitle': 'Planes de facturación y facturas de la plataforma',
    'billing.tabs.plans': 'Planes',
    'billing.tabs.invoices': 'Facturas',
    'billing.tabs.aria': 'Secciones de facturación',
    'reports.monthlyRevenue': 'Ingresos Mensuales',
    'reports.monthlyRevenueCol': 'Ingresos',
    'reports.serviceTypes': 'Tipos de Servicio',
    'reports.topClients': 'Mejores Clientes',
    'reports.type': 'Tipo',
    'reports.client': 'Cliente',
    'reports.services': 'Servicios',
    'reports.generatedBy': 'Informe generado por el Sistema Agenda House Keep',
    'reports.moreInfo': 'Para más información, acceda al sistema en {url}',
    'reports.timeDiscrepancies': 'Discrepancias de Tiempo',
    'reports.timeDiscrepanciesFull': 'Discrepancias de Tiempo (Esperado vs Real)',
    'reports.noClients': 'No se encontraron clientes.',
    'reports.addClientsHint': 'Agregue clientes en el sistema para ver los informes.',
    'reports.noDiscrepancies': 'No se encontraron discrepancias.',
    'reports.allOnTime': 'Todos los servicios completados están dentro del tiempo estimado.',
    'reports.noAppointmentsDay': 'Sin citas en este día',
    'reports.loadingRatings': 'Cargando calificaciones...',
    'permissions.legend': 'Leyenda - Permisos CRUD:',
    'permissions.createDesc': 'Crear: Permite crear nuevos registros del recurso',
    'permissions.readDesc': 'Leer: Permite visualizar registros del recurso',
    'permissions.updateDesc': 'Actualizar: Permite modificar registros existentes',
    'permissions.deleteDesc': 'Eliminar: Permite eliminar registros del recurso',
    'permissions.tipTitle': 'Consejo:',
    'permissions.tipText': 'Los permisos CRUD controlan qué acciones puede realizar cada perfil en las páginas. Aunque tenga acceso al menú (pestaña anterior), solo podrá ejecutar las acciones permitidas aquí.',
    'language.en': 'English',
    'language.es': 'Español',
    'language.ptBR': 'Português (Brasil)',
    'language.ptPT': 'Português (Portugal)',

    'serviceSuggestions.title': 'Sugerencias de Próximo Servicio',
    'serviceSuggestions.subtitle': 'Analizamos el historial de citas para recomendar el mejor momento para volver a contactar.',
    'serviceSuggestions.loading': 'Calculando sugerencias...',
    'serviceSuggestions.noSuggestions': 'Aún no hay historial suficiente para generar sugerencias.',
    'serviceSuggestions.noSuggestionsHint': 'Complete más servicios para desbloquear recomendaciones personalizadas.',
    'serviceSuggestions.avgInterval': 'Intervalo promedio: {days} días',
    'serviceSuggestions.nextSuggested': 'Próxima fecha sugerida:',
    'serviceSuggestions.totalCompleted': 'Servicios completados: {count}',
    'serviceSuggestions.confidence.alto': 'Alta confianza',
    'serviceSuggestions.confidence.medio': 'Confianza media',
    'serviceSuggestions.confidence.baixo': 'Baja confianza',

    // Phase 4 — common UI strings
    'common.name': 'Nombre',
    'common.description': 'Descripción',
    'common.status': 'Estado',
    'common.email': 'Email',
    'common.phone': 'Teléfono',
    'common.client': 'Cliente',
    'common.employee': 'Empleado',
    'common.optional': '(opcional)',
    'common.requiredMark': '(obligatorio)',
    'common.all': 'Todos',
    'common.filters': 'Filtros',
    'common.action': 'Acción',
    'common.resource': 'Recurso',
    'common.clear': 'Limpiar',
    'common.clearSelection': 'Limpiar selección',
    'common.tryAgain': 'Intentar de nuevo',
    'common.backToLogin': 'Volver al inicio de sesión',
    'common.notes': 'Observaciones',
    'common.value': 'Valor',
    'common.loadingClients': 'Cargando clientes...',
    'common.noData': 'No se encontraron datos',
    'common.select': 'Seleccione...',
    'common.dateNotInformed': 'Fecha no informada',
    'common.thirdParty': 'Tercerizado',
    'common.actions': 'Acciones',
    'common.remove': 'Eliminar',
    'common.add': 'Agregar',
    'common.update': 'Actualizar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.save': 'Guardar',
    'common.close': 'Cerrar',
    'common.search': 'Buscar',
    'common.yes': 'Sí',
    'common.no': 'No',
    'common.resourceLimits': 'Límites de Recursos',
    'common.keepCurrent': 'Mantener actual',
    'common.keepSeries': 'Mantener de la serie',
    'common.dateFormatHint': 'DD/MM/AAAA',
    'validation.fixFormErrors': 'Por favor, corrija los errores en el formulario',
    'validation.requiredCustomFields': 'Complete todos los campos personalizados obligatorios.',
    'validation.priceRequired': 'El precio es obligatorio y debe ser mayor que cero',
    'login.appName': 'Agenda House Keep',
    'login.tagline': 'Sistema de Gestión de Limpieza',
    'login.title': 'Iniciar sesión',
    'login.subtitle': 'Acceda a su cuenta para continuar',
    'login.emailLabel': 'Email',
    'login.passwordLabel': 'Contraseña',
    'login.emailPlaceholder': 'su@email.com',
    'login.emailRequired': 'El email es obligatorio',
    'login.passwordRequired': 'La contraseña es obligatoria',
    'login.invalidCredentials': 'Email o contraseña incorrectos',
    'login.connectionError': 'Error de conexión. Verifique si los servicios están en ejecución.',
    'login.twoFactorTitle': 'Autenticación de dos factores',
    'login.twoFactorSubtitle': 'Ingrese el código de 6 dígitos de su aplicación autenticadora',
    'login.twoFactorCodeRequired': 'Ingrese el código de 6 dígitos',
    'login.twoFactorInvalid': 'Código inválido. Intente de nuevo.',
    'login.twoFactorVerifyError': 'Error al verificar código. Intente de nuevo.',
    'login.submit': 'Iniciar sesión',
    'login.submitting': 'Iniciando sesión...',
    'login.verify': 'Verificar',
    'login.verifying': 'Verificando...',
    'login.forgotPassword': '¿Olvidó su contraseña?',
    'login.noAccount': '¿No tiene una cuenta?',
    'login.register': 'Regístrese',
    'forgotPassword.title': 'Olvidé mi contraseña',
    'forgotPassword.subtitle': 'Ingrese su email para recibir instrucciones de restablecimiento',
    'forgotPassword.submit': 'Enviar enlace de restablecimiento',
    'forgotPassword.backToLogin': 'Volver al inicio de sesión',
    'resetPassword.title': 'Restablecer contraseña',
    'resetPassword.submit': 'Restablecer contraseña',
    'financial.thirdPartyNone': 'Ningún tercerizado registrado',
    'financial.thirdPartyHint': 'Gestione los tercerizados en la página de Empleados. Marque "Tercerizado" al crear o editar un empleado.',
    'financial.newAllocation': 'Nueva Asignación',
    'financial.fixedAmount': 'Valor Fijo',
    'financial.percentage': 'Porcentaje',
    'financial.costs': 'Costos',
    'financial.newCost': 'Nuevo Costo',
    'financial.status.pending': 'Pendiente',
    'financial.status.paid': 'Pagado',
    'financial.status.cancelled': 'Cancelado',
    'billing.loadingInvoices': 'Cargando facturas...',
    'billing.allStatuses': 'Todos los estados',
    'billing.retryLoad': 'Intentar de nuevo',
    'billing.generateFromPlan': 'Generar desde el plan activo',
    'billing.noInvoices': 'No se encontraron facturas',
    'billing.paymentMethodPrompt': 'Método de pago:',
    'billing.paymentError': 'Error al procesar pago',
    'dashboard.completedToday': 'Servicios completados hoy',
    'dashboard.completedThisMonth': 'Servicios completados este mes',
    'dashboard.completionRate': 'Tasa de Finalización',
    'dashboard.noAppointmentsYet': 'Aún no hay citas',
    'dashboard.monthlyRevenueSubtitle': 'Ingresos de servicios completados',
    'dashboard.servicesOverTime': '{count} servicios excedieron el tiempo',
    'dashboard.servicesSlower': '⚠️ {count} servicios tardaron más de lo estimado',
    'dashboard.servicesFaster': '✅ {count} servicios fueron más rápidos',
    'dashboard.noDiscrepancy': 'No se encontraron discrepancias',
    'dashboard.avgDifference': 'Diferencia promedio: {value} min',
    'dashboard.appointmentsOfDay': 'Citas del {date}',
    'appointments.clearSelection': 'Limpiar selección',
    'appointments.dateNotInformed': 'Fecha no informada',
    'rbac.legend': 'Leyenda',
    'rbac.colorLegend': 'Leyenda de Colores',
    'support.title': 'Soporte',
    'support.newTicket': 'Nuevo ticket',
    'support.refresh': 'Actualizar',
    'support.noTickets': 'No se encontraron tickets',
    'support.loading': 'Cargando tickets...',
    'zones.fillNameAndCoords': 'Por favor, complete al menos el nombre y las coordenadas del centro de la zona',
    'menuPermissions.saved': '¡Permisos guardados con éxito!',
    'menuPermissions.saveError': 'Error al guardar permisos',

    // Phase 4 — common UI strings
    'common.name': 'Nombre',
    'common.description': 'Descripción',
    'common.status': 'Estado',
    'common.email': 'Email',
    'common.phone': 'Teléfono',
    'common.client': 'Cliente',
    'common.employee': 'Empleado',
    'common.optional': '(opcional)',
    'common.requiredMark': '(obligatorio)',
    'common.all': 'Todos',
    'common.filters': 'Filtros',
    'common.action': 'Acción',
    'common.resource': 'Recurso',
    'common.clear': 'Limpiar',
    'common.clearSelection': 'Limpiar selección',
    'common.tryAgain': 'Intentar de nuevo',
    'common.backToLogin': 'Volver al inicio de sesión',
    'common.notes': 'Observaciones',
    'common.value': 'Valor',
    'common.loadingClients': 'Cargando clientes...',
    'common.noData': 'No se encontraron datos',
    'common.select': 'Seleccione...',
    'common.dateNotInformed': 'Fecha no informada',
    'common.thirdParty': 'Tercerizado',
    'common.actions': 'Acciones',
    'common.remove': 'Eliminar',
    'common.add': 'Agregar',
    'common.update': 'Actualizar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.save': 'Guardar',
    'common.close': 'Cerrar',
    'common.search': 'Buscar',
    'common.yes': 'Sí',
    'common.no': 'No',
    'common.resourceLimits': 'Límites de Recursos',
    'common.keepCurrent': 'Mantener actual',
    'common.keepSeries': 'Mantener de la serie',
    'common.dateFormatHint': 'DD/MM/AAAA',
    'validation.fixFormErrors': 'Por favor, corrija los errores en el formulario',
    'validation.requiredCustomFields': 'Complete todos los campos personalizados obligatorios.',
    'validation.priceRequired': 'El precio es obligatorio y debe ser mayor que cero',
    'login.appName': 'Agenda House Keep',
    'login.tagline': 'Sistema de Gestión de Limpieza',
    'login.title': 'Iniciar sesión',
    'login.subtitle': 'Acceda a su cuenta para continuar',
    'login.emailLabel': 'Email',
    'login.passwordLabel': 'Contraseña',
    'login.emailPlaceholder': 'su@email.com',
    'login.emailRequired': 'El email es obligatorio',
    'login.passwordRequired': 'La contraseña es obligatoria',
    'login.invalidCredentials': 'Email o contraseña incorrectos',
    'login.connectionError': 'Error de conexión. Verifique si los servicios están en ejecución.',
    'login.twoFactorTitle': 'Autenticación de dos factores',
    'login.twoFactorSubtitle': 'Ingrese el código de 6 dígitos de su aplicación autenticadora',
    'login.twoFactorCodeRequired': 'Ingrese el código de 6 dígitos',
    'login.twoFactorInvalid': 'Código inválido. Intente de nuevo.',
    'login.twoFactorVerifyError': 'Error al verificar código. Intente de nuevo.',
    'login.submit': 'Iniciar sesión',
    'login.submitting': 'Iniciando sesión...',
    'login.verify': 'Verificar',
    'login.verifying': 'Verificando...',
    'login.forgotPassword': '¿Olvidó su contraseña?',
    'login.noAccount': '¿No tiene una cuenta?',
    'login.register': 'Regístrese',
    'forgotPassword.title': 'Olvidé mi contraseña',
    'forgotPassword.subtitle': 'Ingrese su email para recibir instrucciones de restablecimiento',
    'forgotPassword.submit': 'Enviar enlace de restablecimiento',
    'forgotPassword.backToLogin': 'Volver al inicio de sesión',
    'resetPassword.title': 'Restablecer contraseña',
    'resetPassword.submit': 'Restablecer contraseña',
    'financial.thirdPartyNone': 'Ningún tercerizado registrado',
    'financial.thirdPartyHint': 'Gestione los tercerizados en la página de Empleados. Marque "Tercerizado" al crear o editar un empleado.',
    'financial.newAllocation': 'Nueva Asignación',
    'financial.fixedAmount': 'Valor Fijo',
    'financial.percentage': 'Porcentaje',
    'financial.costs': 'Costos',
    'financial.newCost': 'Nuevo Costo',
    'financial.status.pending': 'Pendiente',
    'financial.status.paid': 'Pagado',
    'financial.status.cancelled': 'Cancelado',
    'billing.loadingInvoices': 'Cargando facturas...',
    'billing.allStatuses': 'Todos los estados',
    'billing.retryLoad': 'Intentar de nuevo',
    'billing.generateFromPlan': 'Generar desde el plan activo',
    'billing.noInvoices': 'No se encontraron facturas',
    'billing.paymentMethodPrompt': 'Método de pago:',
    'billing.paymentError': 'Error al procesar pago',
    'dashboard.completedToday': 'Servicios completados hoy',
    'dashboard.completedThisMonth': 'Servicios completados este mes',
    'dashboard.completionRate': 'Tasa de Finalización',
    'dashboard.noAppointmentsYet': 'Aún no hay citas',
    'dashboard.monthlyRevenueSubtitle': 'Ingresos de servicios completados',
    'dashboard.servicesOverTime': '{count} servicios excedieron el tiempo',
    'dashboard.servicesSlower': '⚠️ {count} servicios tardaron más de lo estimado',
    'dashboard.servicesFaster': '✅ {count} servicios fueron más rápidos',
    'dashboard.noDiscrepancy': 'No se encontraron discrepancias',
    'dashboard.avgDifference': 'Diferencia promedio: {value} min',
    'dashboard.appointmentsOfDay': 'Citas del {date}',
    'appointments.clearSelection': 'Limpiar selección',
    'appointments.dateNotInformed': 'Fecha no informada',
    'rbac.legend': 'Leyenda',
    'rbac.colorLegend': 'Leyenda de Colores',
    'support.title': 'Soporte',
    'support.newTicket': 'Nuevo ticket',
    'support.refresh': 'Actualizar',
    'support.noTickets': 'No se encontraron tickets',
    'support.loading': 'Cargando tickets...',
    'zones.fillNameAndCoords': 'Por favor, complete al menos el nombre y las coordenadas del centro de la zona',
    'menuPermissions.saved': '¡Permisos guardados con éxito!',
    'menuPermissions.saveError': 'Error al guardar permisos',
    'recurrence.createTitle': 'Crear Cita Recurrente',
    'recurrence.validateConflicts': 'Validar Conflictos',
    'recurrence.creating': 'Creando...',
    'recurrence.createSeries': 'Crear Serie',
    'recurrence.noConflicts': '¡No hay conflictos! Puede crear la serie.',
    'recurrence.successCreated': '¡Serie recurrente creada con éxito!',
    'recurrence.errorCreating': 'Error al crear serie recurrente',
    'workload.loading': 'Cargando carga de trabajo...',
    'workload.errorLoading': 'Error al cargar carga de trabajo',
    'forgotPassword.sendLink': 'Enviar Enlace de Recuperación',
    'forgotPassword.success': 'Si el email existe, se ha enviado un enlace de recuperación.',
    'forgotPassword.error': 'Error al procesar solicitud.',
    'setup2fa.required': 'Configuración Obligatoria',
    'support.noTicketsYet': 'Aún no hay tickets.',
    'calendar.appointmentsTitle': 'Calendario de Citas',
    'zone.myLocation': 'Mi ubicación',
    'checkpoint.none': 'No se encontraron checkpoints',
    'twoFactor.title': 'Autenticación de Dos Factores',
    'employeeSelector.loading': 'Cargando empleados...',
    'quickCreate.employee.title': 'Registrar Nuevo Empleado',
    'preferences.loading': 'Cargando preferencias...',
    'smtp.settingsTitle': 'Configuración SMTP',
    'financial.subtitle': 'Control de pagos, costos y distribución para tercerizados',
    'companySwitcher.loading': 'Cargando empresas...',
    'completeService.cancel': 'Cancelar',

    'setup2fa.subtitle': 'Por su seguridad, debe configurar la autenticación de dos factores (2FA) antes de continuar.',
    'companySwitcher.notFound': 'No se encontró ninguna empresa',
    'companySwitcher.noneAvailable': 'Ninguna empresa disponible',
    // Phase 4 final
    'audit.title': 'Registro de Auditoría',
    'audit.subtitle': 'Historial completo de todas las acciones en el sistema',
    'audit.applyFilters': 'Aplicar Filtros',
    'audit.noLogs': 'No se encontraron registros',
    'audit.errorLoading': 'Error al cargar registros de auditoría',
    'audit.errorExport': 'Error al exportar registros',
    'audit.next': 'Siguiente',
    'audit.previous': 'Anterior',
    'checkpoint.title': 'Historial de Checkpoints',
    'checkpoint.loading': 'Cargando historial...',
    'checkpoint.errorLoading': 'Error al cargar historial de checkpoints',
    'checkpoint.stats': 'Estadísticas',
    'checkpoint.avgPerService': 'Promedio por Servicio',
    'checkpoint.duration': 'Duración:',
    'rating.title': 'Calificar Servicio',
    'rating.overall': 'Calificación General *',
    'rating.anonymous': 'Calificación anónima',
    'rating.success': '¡Calificación enviada con éxito!',
    'rating.detailedOptional': 'Calificaciones Detalladas (Opcional)',
    'rating.commentOptional': 'Comentario (Opcional)',
    'rating.commentPlaceholder': 'Comparta su experiencia con este servicio...',
    'rating.submit': 'Enviar Calificación',
    'recurrence.editTitle': 'Editar Cita Recurrente',
    'recurrence.cancelOccurrence': 'Cancelar solo esta ocurrencia',
    'recurrence.cancelSeries': 'Cancelar toda la serie (todas las ocurrencias futuras)',
    'recurrence.newEndDate': 'Nueva fecha de finalización',
    'recurrence.newDuration': 'Nueva duración (minutos)',
    'recurrence.newInstructions': 'Nuevas instrucciones especiales',
    'recurrence.startDate': 'Fecha de inicio *',
    'recurrence.dayOfMonth': 'Día del mes *',
    'recurrence.frequency': 'Frecuencia',
    'recurrence.frequencyRequired': 'Frecuencia *',
    'recurrence.durationRequired': 'Duración (minutos) *',
    'recurrence.daily': 'Diario (todos los días)',
    'recurrence.monthly': 'Mensual (cada mes)',
    'company.search': 'Buscar empresa',
    'company.searchPlaceholder': 'Buscar empresa...',
    'company.switchTitle': 'Cambiar Empresa',
    'company.switchHint': 'Seleccione la empresa para cambiar el contexto',
    'company.notFound': 'No se encontró ninguna empresa',
    'company.noneAvailable': 'Ninguna empresa disponible',
    'completeService.title': 'Finalizar Servicio',
    'completeService.endTime': 'Hora de Finalización',
    'completeService.autoCalcHint': 'Si no se informa, se calculará automáticamente',
    'dashboard.welcome': 'Bienvenido al sistema de gestión de limpieza',
    'dashboard.noClients': 'No hay clientes registrados',
    'dashboard.newClient': 'Nuevo Cliente',
    'employeeDashboard.loading': 'Cargando panel...',
    'employeeDashboard.error': 'Error al cargar panel',
    'employeeDashboard.completed': 'Completados',
    'employeeDashboard.thisMonth': 'Este Mes',
    'employeeDashboard.noUpcoming': 'No hay citas próximas',
    'employeeDashboard.noData': 'No hay datos disponibles',
    'employeeDashboard.avgRating': 'Calificación promedio:',
    'employeeSelector.available': 'Disponible',
    'employeeSelector.unavailable': 'No disponible',
    'employeeSelector.noneAvailable': 'No hay empleados disponibles',
    'employeeSelector.invalidZone': 'Zona inválida',
    'employeeSelector.validZone': 'Zona válida',
    'workload.title': 'Carga de Trabajo de Empleados',
    'workload.avgLoad': 'Carga promedio (20-40h)',
    'workload.totalAppointments': 'Total de citas:',
    'workload.totalEmployees': 'Total de empleados:',
    'login.back': 'Volver',
    'login.forgotPasswordLink': 'Olvidé mi contraseña',
    'login.twoFactorVerification': 'Verificación en Dos Pasos',
    'login.verificationCode': 'Código de Verificación',
    'login.twoFactorAppHint': 'Ingrese el código de 6 dígitos de su aplicación autenticadora',
    'login.contactAdmin': 'Contacte al administrador para crear una cuenta',
    'login.privacyPolicy': 'Política de Privacidad',
    'forgotPassword.titleFull': 'Recuperar Contraseña',
    'forgotPassword.subtitleFull': 'Ingrese su email para recibir un enlace de recuperación',
    'quickCreate.client.title': 'Registrar Nuevo Cliente',
    'zone.drawStart': 'Comenzar a Dibujar',
    'zone.redraw': 'Redibujar',
    'zone.removeLast': 'Eliminar Último',
    'zone.minPoints': 'Se requieren al menos 3 puntos para formar un polígono',
    'zone.centerOnMe': 'Centrar en mi ubicación',
    'zone.yourLocation': 'Su ubicación',
    'limits.loading': 'Cargando límites...',
    'limits.configure': 'Configurar Límites',
    'limits.usageStats': 'Estadísticas de Uso',
    'limits.maxClients': 'Máximo de Clientes',
    'limits.maxEmployees': 'Máximo de Empleados',
    'limits.maxUsers': 'Máximo de Usuarios',
    'limits.errorLoading': 'No se pudieron cargar los límites.',
    'limits.disabledHint': 'Cuando esté desactivado, los límites no se aplicarán',
    'billing.invoiceDetails': 'Detalles de la Factura',
    'billing.clearFilter': 'Limpiar filtro',
    'billing.number': 'Número:',
    'plans.loading': 'Cargando planes...',
    'plans.billingCycle': 'Ciclo de Facturación',
    'plans.errorDeactivate': 'Error al desactivar plan',
    'plans.errorSave': 'Error al guardar plan',
    'plans.history': 'Historial de Planes',
    'plans.noneRegistered': 'No hay planes registrados. Haga clic en',
    'plans.name': 'Nombre del Plan',
    'plans.new': 'Nuevo Plan',
    'customization.adminOnly': 'Solo los administradores pueden gestionar personalizaciones por empresa.',
    'customization.subtitle': 'Configure una experiencia única para cada cliente corporativo.',
    'customization.title': 'Personalización por empresa',
    'customization.selectCompany': 'Seleccione una empresa para personalizar funcionalidades.',
    'customization.branding.subtitle': 'Personalice logotipo, colores y CSS personalizado de la empresa.',
    'customization.branding.primaryColor': 'Color primario',
    'customization.branding.secondaryColor': 'Color secundario',
    'customization.branding.gradientHint': 'Botones, tarjetas y gráficos usarán este gradiente personalizado.',
    'customization.branding.errorSave': 'Error al guardar branding.',
    'customization.branding.errorLoad': 'No se pudo cargar el branding de la empresa.',
    'customization.fields.loading': 'Cargando campos personalizados...',
    'customization.fields.required': 'Campo obligatorio',
    'customization.fields.byModule': 'Campos por módulo',
    'customization.fields.configJson': 'Configuración (JSON)',
    'customization.fields.errorRemove': 'Error al eliminar campo.',
    'customization.fields.errorSave': 'Error al guardar campo personalizado.',
    'customization.features.loading': 'Cargando feature flags...',
    'customization.features.advancedJson': 'Configuración avanzada (JSON)',
    'customization.features.enabled': 'Feature habilitado para la empresa',
    'customization.features.invalidJson': 'JSON de configuración inválido.',
    'customization.features.clearForm': 'Limpiar formulario',
    'customization.features.none': 'No hay feature flags configurados para esta empresa.',
    'customization.features.errorSave': 'Error al guardar feature flag.',
    'customization.templates.loading': 'Cargando plantillas...',
    'customization.templates.subtitle': 'Personalice el contenido de las notificaciones enviadas a los clientes.',
    'customization.templates.welcomeSample': '¡Bienvenido a House Keep!',
    'customization.templates.errorRemove': 'Error al eliminar plantilla.',
    'customization.workflows.loading': 'Cargando módulos...',
    'customization.workflows.definitionJson': 'Definición del workflow (JSON)',
    'customization.workflows.editor': 'Editor de workflow',
    'customization.workflows.errorRemove': 'Error al eliminar workflow.',
    'customization.workflows.errorSave': 'Error al guardar workflow.',
    'customization.workflows.moduleRequired': 'Ingrese el módulo del workflow.',
    'customization.workflows.invalidJson': 'JSON de definición inválido.',
    'customization.workflows.module': 'Módulo *',
    'customFields.loading': 'Cargando campos personalizados...',
    'adminDashboard.attentionRequired': 'Atención Requerida',
    'adminDashboard.loadingTrend': 'Cargando datos de tendencia...',
    'adminDashboard.noEmployeesCompleted': 'Ningún empleado con servicios completados',
    'adminDashboard.last6Months': 'Últimos 6 meses',
    'clientDashboard.errorHistory': 'Error al cargar historial de servicios',
    'employeeDashboard.errorToday': 'Error al cargar citas del día',
    'rbac.departments.title': 'Departamentos',
    'rbac.departments.parent': 'Departamento Padre',
    'rbac.departments.parentOptional': 'Departamento Padre (opcional)',
    'rbac.departments.descPlaceholder': 'Descripción del departamento',
    'rbac.departments.none': 'Ninguno',
    'rbac.departments.noneConfigured': 'No hay departamentos configurados',
    'rbac.permissions.conditions': 'Condiciones',
    'rbac.permissions.conditionsOptional': 'Condiciones (JSON opcional)',
    'rbac.permissions.noneConfigured': 'No hay permisos configurados',
    'rbac.permissions.new': 'Nuevo Permiso',
    'rbac.permissions.errorLoad': 'No se pudieron cargar permisos.',
    'rbac.roles.custom': 'Personalizado',
    'rbac.roles.descPlaceholder': 'Descripción del role',
    'rbac.roles.noneConfigured': 'No hay roles configurados',
    'rbac.roles.errorLoad': 'No se pudieron cargar roles.',
    'rbac.roles.permissions': 'Permisos',
    'rbac.management.title': 'Gestión de RBAC',
    'rbac.management.subtitle': 'Control de acceso basado en roles, permisos y departamentos.',
    'rbac.management.adminOnly': 'Solo los administradores pueden gestionar RBAC.',
    'rbac.management.selectCompany': 'Seleccione una empresa para gestionar RBAC.',
    'limits.management.adminOnly': 'Solo los administradores del sistema pueden configurar estos límites.',
    'limits.management.loadingCompany': 'Cargando información de la empresa...',
    'limits.management.selectCompany': 'Seleccione una empresa para gestionar los límites de recursos.',
    'preferences.channels': 'Canales de Notificación',
    'preferences.subtitle': 'Configure cómo y cuándo desea recibir notificaciones',
    'preferences.quietHours': 'Horas Silenciosas',
    'preferences.quietHoursHint': 'Durante este período no recibirá notificaciones (excepto urgentes)',
    'preferences.quietStart': 'Inicio (HH:MM)',
    'preferences.appointmentCreated': 'Cita Creada',
    'preferences.appointmentCancelled': 'Cita Cancelada',
    'preferences.appointmentReminders': 'Recordatorios de Citas',
    'resetPassword.minLength': 'La contraseña debe tener al menos 6 caracteres.',
    'resetPassword.mismatch': 'Las contraseñas no coinciden.',
    'resetPassword.confirmNew': 'Confirmar Nueva Contraseña',
    'resetPassword.newPassword': 'Nueva Contraseña',
    'resetPassword.placeholder': 'Ingrese su nueva contraseña',
    'resetPassword.successTitle': '¡Contraseña Restablecida!',
    'resetPassword.successMessage': '¡Contraseña restablecida con éxito! Redirigiendo al inicio de sesión...',
    'resetPassword.titleFull': 'Restablecer Contraseña',
    'setup2fa.logoutRetry': 'Salir e intentar de nuevo más tarde',
    'support.tickets': 'Tickets',
    'support.ticketsSubtitle': 'Tickets y SLA aislados por empresa',
    'support.openTicket': 'Abrir ticket',
    'support.newTicketBtn': 'Nuevo ticket',
    'support.errorUpdate': 'Error al actualizar ticket.',
    'support.errorCreate': 'Error al crear ticket.',
    'support.average': 'Promedio',
    'support.refreshBtn': 'Actualizar',
    'timeDiscrepancies.subtitle': 'Análisis detallado de servicios con diferencias entre tiempo estimado y real',
    'timeDiscrepancies.avgDifference': 'Diferencia Promedio',
    'timeDiscrepancies.errorLoading': 'Error al cargar discrepancias de tiempo',
    'timeDiscrepancies.errorExport': 'Error al exportar informe',
    'timeDiscrepancies.backToReports': '← Volver a Informes',
    'timeDiscrepancies.alphabetical': '🔤 Orden Alfabético',
    'timeDiscrepancies.service': 'Servicio',
    'reports.errorGenerate': 'Error al generar informe. Verifique la consola para más detalles.',
    'chat.sendWhatsApp': 'Enviar también por WhatsApp',
    'notes.templatePreview': 'Asunto previsualizado:',
    'notes.applyTemplate': 'Aplicar contenido de la plantilla',
    'notes.mobileHint': 'La notificación se enviará a la aplicación móvil del cliente.',
    'notes.loadingTemplates': 'Cargando plantillas...',
    'menuPermissions.loading': 'Cargando permisos...',
    'menuPermissions.crudTitle': 'Permisos CRUD',
    'menuPermissions.menuTitle': 'Permisos de Menú',
    'menuPermissions.resourceAction': 'Recurso / Acción',
    'companies.searchPlaceholder': 'Buscar empresas...',
    'companies.active': 'Empresa activa',
    'companies.errorLoad': 'Error al cargar empresas:',
    'companies.errorDelete': 'Error al eliminar empresa:',
    'companies.errorSave': 'Error al guardar empresa:',
    'users.passwordRequiredWhen': 'La contraseña es obligatoria cuando',
    'users.administrator': 'Administrador',
    'users.changePassword': 'Cambiar Contraseña',
    'users.passwordMismatch': 'Las contraseñas no coinciden',
    'users.errorDelete': 'Error al eliminar usuario:',
    'users.errorCompany': 'No se pudo determinar la empresa. Recargue la página e intente de nuevo.',
    'users.errorGetCompany': 'Error al obtener empresa. Recargue la página e intente de nuevo.',
    'appointments.recurring': 'Cita Recurrente',
    'appointments.clientSignature': 'Firma del cliente',
    'appointments.createFirst': 'Crear Primera Cita',
    'appointments.errorUpdateProperties': 'Error al actualizar propiedades',
    'appointments.errorLoad': 'Error al cargar citas. Intente recargar la página.',
    'appointments.searchClientMin': 'Escriba al menos 3 letras para buscar cliente...',
    'twoFactor.enabled': '2FA Activado',
    'twoFactor.disabled': '2FA Desactivado',
    'twoFactor.disabledSuccess': '2FA desactivado con éxito.',
    'twoFactor.enabledSuccess': '¡2FA habilitado con éxito!',
    'twoFactor.adminMustKeep': 'Los administradores deben mantener 2FA habilitado.',
    'twoFactor.warning': 'Atención:',
    'twoFactor.activate': 'Activar 2FA',
    'twoFactor.deactivate': 'Desactivar 2FA',
    'twoFactor.deactivateTitle': 'Desactivar 2FA',
    'twoFactor.deactivateWarning': '2FA es obligatorio para su cuenta. Contacte al administrador si necesita desactivarlo.',
    'twoFactor.enabledInfo': 'Su inicio de sesión requiere el código 2FA. Guarde sus códigos de respaldo en un lugar seguro.',
    'twoFactor.disabledInfo': '2FA está desactivado. Actívelo para agregar una capa extra de seguridad a su cuenta.',
    'twoFactor.requiredDisabled': 'Esta acción está deshabilitada porque 2FA es obligatorio para su cuenta.',
    'twoFactor.errorLoadStatus': 'No se pudo cargar el estado de 2FA.',
    'twoFactor.errorStartSetup': 'Error al iniciar configuración 2FA.',
    'twoFactor.errorDisable': 'No se pudo desactivar 2FA.',
    'products.deactivate': 'Desactivar',
    'products.deleteTitle': 'Eliminar Producto',
    'products.cost': 'Costo:',
    'products.warning': 'ATENCIÓN:',
    'products.descriptionPlaceholder': 'Descripción del producto...',
    'products.errorDeactivate': 'Error al desactivar producto',
    'services.deactivate': 'Desactivar',
    'services.deleteTitle': 'Eliminar Servicio',
    'services.descriptionPlaceholder': 'Descripción detallada del servicio...',
    'services.errorDeactivate': 'Error al desactivar servicio',
    'services.errorReactivate': 'Error al reactivar servicio',
    'services.deleteChoice': 'Elija cómo eliminar este servicio:',
    'services.hardDeleteUnavailable': 'Eliminación permanente no disponible. Realizando eliminación suave...',
    'settings.whatsapp': 'Configuración WhatsApp',
    'settings.smtpSaved': 'Configuración SMTP guardada con éxito',
    'settings.whatsappSaved': 'Configuración WhatsApp guardada con éxito',
    'settings.currentApplied': 'Configuraciones Actuales Aplicadas:',
    'settings.customizationByCompany': 'Personalización por Empresa',
    'settings.phonePlaceholder': '+5511999999999 o whatsapp:+5511999999999',
    'settings.auth': 'Autenticación',
    'settings.timezoneBRT': 'Hora de Brasilia (BRT)',
    'calendar.appointments': 'citas',
    'calendar.titleShort': 'Calendario de Citas',
    'finance.addContractorQuick': 'Agregar Tercerizado Rápido',
    'finance.allocationSuccess': '¡Asignación creada con éxito!',
    'finance.loadingMonth': 'Cargando datos del mes...',
    'finance.selectToDistribute': 'Haga clic en el botón "Seleccionar para Distribuir"',
    'finance.createFirstAllocation': 'Crear Primera Asignación',
    'properties.instructions': 'Instrucciones',
    'properties.cepHint': '💡 8 dígitos (Brasil) o 5 dígitos (USA)',
    'properties.errorLoad': 'Error al cargar propiedades:',
    'employees.thirdPartyHint': 'Marque si este empleado es un contratista externo',
    'employees.zoneExample': 'Ej: Zona Norte, Centro, etc.',

    'menu.companies': 'Empresas',
    'menu.zones': 'Zonas',
    'menu.services': 'Servicios',
    'menu.limits': 'Límites',
    'menu.rbac': 'RBAC',
    'menu.notificationPreferences': 'Preferencias de notificación',
    'menu.history': 'Historial',
  }
};

export type TranslationKey = keyof typeof translations.en;
export type SupportedLanguage = keyof typeof translations;
